(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib-js-ir.js', './korge-root-korim.js', './kotlinx-serialization-kotlinx-serialization-core.js', './korge-root-kds.js', './korge-root-klock.js', './korge-root-korau.js', './korge-root-korio.js', './kotlinx-serialization-kotlinx-serialization-json-js-ir.js', './metron-fleks.js', './korge-root-korge.js', './korge-root-korma.js', './korge-root-korgw.js', './korge-root-kmem.js', './metron-shared.js', './korge-root-korinject.js', './korge-root-klogger.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib-js-ir.js'), require('./korge-root-korim.js'), require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./korge-root-kds.js'), require('./korge-root-klock.js'), require('./korge-root-korau.js'), require('./korge-root-korio.js'), require('./kotlinx-serialization-kotlinx-serialization-json-js-ir.js'), require('./metron-fleks.js'), require('./korge-root-korge.js'), require('./korge-root-korma.js'), require('./korge-root-korgw.js'), require('./korge-root-kmem.js'), require('./metron-shared.js'), require('./korge-root-korinject.js'), require('./korge-root-klogger.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'kotlin-kotlin-stdlib-js-ir' was not found. Please, check whether 'kotlin-kotlin-stdlib-js-ir' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korim'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korim' was not found. Please, check whether 'korge-root-korim' is loaded prior to 'metron-client'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-kds'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-kds' was not found. Please, check whether 'korge-root-kds' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-klock'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-klock' was not found. Please, check whether 'korge-root-klock' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korau'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korau' was not found. Please, check whether 'korge-root-korau' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korio'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korio' was not found. Please, check whether 'korge-root-korio' is loaded prior to 'metron-client'.");
    }
    if (typeof this['kotlinx-serialization-kotlinx-serialization-json-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'kotlinx-serialization-kotlinx-serialization-json-js-ir' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-json-js-ir' is loaded prior to 'metron-client'.");
    }
    if (typeof this['metron-fleks'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'metron-fleks' was not found. Please, check whether 'metron-fleks' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korge'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korge' was not found. Please, check whether 'korge-root-korge' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korma'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korma' was not found. Please, check whether 'korge-root-korma' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korgw'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korgw' was not found. Please, check whether 'korge-root-korgw' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-kmem'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-kmem' was not found. Please, check whether 'korge-root-kmem' is loaded prior to 'metron-client'.");
    }
    if (typeof this['metron-shared'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'metron-shared' was not found. Please, check whether 'metron-shared' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-korinject'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-korinject' was not found. Please, check whether 'korge-root-korinject' is loaded prior to 'metron-client'.");
    }
    if (typeof this['korge-root-klogger'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'korge-root-klogger' was not found. Please, check whether 'korge-root-klogger' is loaded prior to 'metron-client'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'metron-client'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'metron-client'.");
    }
    root['metron-client'] = factory(typeof this['metron-client'] === 'undefined' ? {} : this['metron-client'], this['kotlin-kotlin-stdlib-js-ir'], this['korge-root-korim'], this['kotlinx-serialization-kotlinx-serialization-core'], this['korge-root-kds'], this['korge-root-klock'], this['korge-root-korau'], this['korge-root-korio'], this['kotlinx-serialization-kotlinx-serialization-json-js-ir'], this['metron-fleks'], this['korge-root-korge'], this['korge-root-korma'], this['korge-root-korgw'], this['korge-root-kmem'], this['metron-shared'], this['korge-root-korinject'], this['korge-root-klogger'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir']);
  }
}(this, function (_, kotlin_kotlin, kotlin_com_soywiz_korlibs_korim_korim, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_com_soywiz_korlibs_kds_kds, kotlin_com_soywiz_korlibs_klock_klock, kotlin_com_soywiz_korlibs_korau_korau, kotlin_com_soywiz_korlibs_korio_korio, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json, kotlin_metron_fleks, kotlin_com_soywiz_korlibs_korge2_korge, kotlin_com_soywiz_korlibs_korma_korma, kotlin_com_soywiz_korlibs_korgw_korgw, kotlin_com_soywiz_korlibs_kmem_kmem, kotlin_metron_shared, kotlin_com_soywiz_korlibs_korinject_korinject, kotlin_com_soywiz_korlibs_klogger_klogger, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_getInstance = kotlin_kotlin.$_$.a5;
  var Colors_getInstance = kotlin_com_soywiz_korlibs_korim_korim.$_$.z;
  var rangeTo = kotlin_kotlin.$_$.rd;
  var Enum = kotlin_kotlin.$_$.qg;
  var protoOf = kotlin_kotlin.$_$.yc;
  var classMeta = kotlin_kotlin.$_$.lb;
  var VOID = kotlin_kotlin.$_$.ni;
  var setMetadataFor = kotlin_kotlin.$_$.zc;
  var DoubleSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.l;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var objectMeta = kotlin_kotlin.$_$.xc;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var fastArrayListOf = kotlin_com_soywiz_korlibs_kds_kds.$_$.a2;
  var equals = kotlin_kotlin.$_$.ob;
  var THROW_CCE = kotlin_kotlin.$_$.ah;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.o;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var lazy = kotlin_kotlin.$_$.ci;
  var objectCreate = kotlin_kotlin.$_$.wc;
  var Companion_getInstance = kotlin_com_soywiz_korlibs_klock_klock.$_$.d1;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.f2;
  var TimeSpan__times_impl_86ofia = kotlin_com_soywiz_korlibs_klock_klock.$_$.x;
  var TimeSpan = kotlin_com_soywiz_korlibs_klock_klock.$_$.g1;
  var getStringHashCode = kotlin_kotlin.$_$.wb;
  var getNumberHashCode = kotlin_kotlin.$_$.ub;
  var hashCode = kotlin_kotlin.$_$.xb;
  var KProperty1 = kotlin_kotlin.$_$.ae;
  var getPropertyCallableRef = kotlin_kotlin.$_$.vb;
  var _TimeSpan___get_seconds__impl__cx2k1c = kotlin_com_soywiz_korlibs_klock_klock.$_$.u;
  var CoroutineImpl = kotlin_kotlin.$_$.xa;
  var get_nativeSoundProvider = kotlin_com_soywiz_korlibs_korau_korau.$_$.c;
  var get_resourcesVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.j2;
  var cachedToMemory = kotlin_com_soywiz_korlibs_korio_korio.$_$.g;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.ga;
  var readAudioData = kotlin_com_soywiz_korlibs_korau_korau.$_$.a;
  var readSound = kotlin_com_soywiz_korlibs_korau_korau.$_$.b;
  var readWoffFont = kotlin_com_soywiz_korlibs_korim_korim.$_$.b;
  var Default_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_json.$_$.a;
  var getKClass = kotlin_kotlin.$_$.e;
  var arrayOf = kotlin_kotlin.$_$.ph;
  var createKType = kotlin_kotlin.$_$.b;
  var serializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.k2;
  var KSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.f2;
  var isInterface = kotlin_kotlin.$_$.jc;
  var configureWorld = kotlin_metron_fleks.$_$.g;
  var Companion_getInstance_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.g;
  var get_degrees = kotlin_com_soywiz_korlibs_korma_korma.$_$.da;
  var Container = kotlin_com_soywiz_korlibs_korge2_korge.$_$.i1;
  var addTo = kotlin_com_soywiz_korlibs_korge2_korge.$_$.q1;
  var ensureNotNull = kotlin_kotlin.$_$.th;
  var max = kotlin_com_soywiz_korlibs_klock_klock.$_$.j1;
  var TimeSpan__plus_impl_qdd6zo = kotlin_com_soywiz_korlibs_klock_klock.$_$.s;
  var TimeSpan__unaryMinus_impl_24dqtx = kotlin_com_soywiz_korlibs_klock_klock.$_$.y;
  var TimeSpan__times_impl_86ofia_0 = kotlin_com_soywiz_korlibs_klock_klock.$_$.v;
  var TimeSpan__rem_impl_6i91m2 = kotlin_com_soywiz_korlibs_klock_klock.$_$.t;
  var TimeSpan__minus_impl_5w5v8s = kotlin_com_soywiz_korlibs_klock_klock.$_$.q;
  var TimeSpan__compareTo_impl_zidry4 = kotlin_com_soywiz_korlibs_klock_klock.$_$.g;
  var TimeSpan__div_impl_l42f2r = kotlin_com_soywiz_korlibs_klock_klock.$_$.j;
  var toRatio = kotlin_com_soywiz_korlibs_korma_korma.$_$.ra;
  var Angle__unaryMinus_impl_7901fr = kotlin_com_soywiz_korlibs_korma_korma.$_$.z1;
  var interpolateAngleNormalized = kotlin_com_soywiz_korlibs_korma_korma.$_$.ea;
  var _Entity___get_id__impl__z2xerk = kotlin_metron_fleks.$_$.h;
  var BitArray = kotlin_metron_fleks.$_$.a;
  var fillArrayVal = kotlin_kotlin.$_$.qb;
  var ComponentsHolder = kotlin_metron_fleks.$_$.c;
  var Entity = kotlin_metron_fleks.$_$.d;
  var get_degrees_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.ca;
  var Companion_getInstance_1 = kotlin_com_soywiz_korlibs_korim_korim.$_$.d1;
  var get_DefaultStringTextRenderer = kotlin_com_soywiz_korlibs_korim_korim.$_$.l2;
  var Companion_getInstance_2 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.f;
  var Text = kotlin_com_soywiz_korlibs_korge2_korge.$_$.p1;
  var Angle__plus_impl_26v37k = kotlin_com_soywiz_korlibs_korma_korma.$_$.s1;
  var Companion_getInstance_3 = kotlin_com_soywiz_korlibs_korma_korma.$_$.y7;
  var Angle__cosine_impl_bgvzun = kotlin_com_soywiz_korlibs_korma_korma.$_$.o1;
  var Angle__sine_impl_3l11xv = kotlin_com_soywiz_korlibs_korma_korma.$_$.x1;
  var Vector2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.aa;
  var getPositionRelativeTo = kotlin_com_soywiz_korlibs_korge2_korge.$_$.z1;
  var setPositionRelativeTo = kotlin_com_soywiz_korlibs_korge2_korge.$_$.k2;
  var TimeSpan__div_impl_l42f2r_0 = kotlin_com_soywiz_korlibs_klock_klock.$_$.h;
  var Companion_getInstance_4 = kotlin_com_soywiz_korlibs_korma_korma.$_$.z7;
  var size = kotlin_com_soywiz_korlibs_korge2_korge.$_$.m2;
  var _RectCorners___init__impl__w373y9 = kotlin_com_soywiz_korlibs_korma_korma.$_$.a5;
  var FastRoundRect = kotlin_com_soywiz_korlibs_korge2_korge.$_$.j1;
  var colorMul = kotlin_com_soywiz_korlibs_korge2_korge.$_$.w1;
  var Companion_getInstance_5 = kotlin_com_soywiz_korlibs_klock_klock.$_$.a1;
  var Angle = kotlin_com_soywiz_korlibs_korma_korma.$_$.n9;
  var DateTime = kotlin_com_soywiz_korlibs_klock_klock.$_$.e1;
  var Angle__hashCode_impl_szcndt = kotlin_com_soywiz_korlibs_korma_korma.$_$.r1;
  var DateTime__hashCode_impl_yf0bc9 = kotlin_com_soywiz_korlibs_klock_klock.$_$.b;
  var TimeSpan__hashCode_impl_izs3k5 = kotlin_com_soywiz_korlibs_klock_klock.$_$.k;
  var DateTime__minus_impl_10njw8 = kotlin_com_soywiz_korlibs_klock_klock.$_$.c;
  var scale = kotlin_com_soywiz_korlibs_korge2_korge.$_$.j2;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ii;
  var cancel = kotlin_com_soywiz_korlibs_korio_korio.$_$.y2;
  var Vector2_init_$Create$ = kotlin_com_soywiz_korlibs_korma_korma.$_$.t;
  var Vector2_init_$Create$_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.s;
  var Vector2_init_$Create$_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.u;
  var PointArrayList = kotlin_com_soywiz_korlibs_korma_korma.$_$.s9;
  var toPolygon = kotlin_com_soywiz_korlibs_korma_korma.$_$.h8;
  var pointArrayListOf = kotlin_com_soywiz_korlibs_korma_korma.$_$.ga;
  var positionY = kotlin_com_soywiz_korlibs_korge2_korge.$_$.d2;
  var centerXOn = kotlin_com_soywiz_korlibs_korge2_korge.$_$.d1;
  var Vector2_init_$Create$_2 = kotlin_com_soywiz_korlibs_korma_korma.$_$.q;
  var anchor = kotlin_com_soywiz_korlibs_korge2_korge.$_$.v1;
  var alignY = kotlin_com_soywiz_korlibs_korge2_korge.$_$.b1;
  var GraphicsRenderer_GPU_getInstance = kotlin_com_soywiz_korlibs_korge2_korge.$_$.a;
  var RGBA = kotlin_com_soywiz_korlibs_korim_korim.$_$.v1;
  var ShapeView = kotlin_com_soywiz_korlibs_korge2_korge.$_$.m1;
  var zIndex = kotlin_com_soywiz_korlibs_korge2_korge.$_$.p2;
  var map = kotlin_com_soywiz_korlibs_korma_korma.$_$.fa;
  var toPointArrayList = kotlin_com_soywiz_korlibs_korma_korma.$_$.la;
  var addUpdater = kotlin_com_soywiz_korlibs_korge2_korge.$_$.r1;
  var Event = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b4;
  var Companion_getInstance_6 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.e;
  var UIText = kotlin_com_soywiz_korlibs_korge2_korge.$_$.y;
  var get_styles = kotlin_com_soywiz_korlibs_korge2_korge.$_$.o;
  var set_textFont = kotlin_com_soywiz_korlibs_korge2_korge.$_$.s;
  var set_textColor = kotlin_com_soywiz_korlibs_korge2_korge.$_$.r;
  var set_textSize = kotlin_com_soywiz_korlibs_korge2_korge.$_$.t;
  var set_textAlignment = kotlin_com_soywiz_korlibs_korge2_korge.$_$.p;
  var positionX = kotlin_com_soywiz_korlibs_korge2_korge.$_$.c2;
  var positionY_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.e2;
  var setText = kotlin_com_soywiz_korlibs_korge2_korge.$_$.l2;
  var positionY_1 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.f2;
  var Size = kotlin_com_soywiz_korlibs_korma_korma.$_$.z9;
  var dummyView = kotlin_com_soywiz_korlibs_korge2_korge.$_$.x1;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.di;
  var positionX_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.b2;
  var BlurFilter = kotlin_com_soywiz_korlibs_korge2_korge.$_$.e1;
  var set_filter = kotlin_com_soywiz_korlibs_korge2_korge.$_$.f1;
  var numberToInt = kotlin_kotlin.$_$.uc;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.m;
  var scale_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.i2;
  var centerOn = kotlin_com_soywiz_korlibs_korge2_korge.$_$.c1;
  var get_hapticFeedback = kotlin_com_soywiz_korlibs_korge2_korge.$_$.n;
  var HapticFeedbackKind_GENERIC_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h1;
  var get_keys = kotlin_com_soywiz_korlibs_korge2_korge.$_$.i;
  var Key_SPACE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.i;
  var Key_A_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.a;
  var Key_ESCAPE_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.b;
  var Key_E_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.c;
  var Type_START_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.w;
  var KeyEvent = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.d4;
  var timeout = kotlin_com_soywiz_korlibs_korge2_korge.$_$.u;
  var get_paused = kotlin_com_soywiz_korlibs_korau_korau.$_$.d;
  var numberRangeToNumber = kotlin_kotlin.$_$.rc;
  var toMutableList = kotlin_kotlin.$_$.v9;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.y1;
  var toIntFloor = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.e7;
  var TimeSpan__div_impl_l42f2r_1 = kotlin_com_soywiz_korlibs_klock_klock.$_$.i;
  var get_rootLocalVfs = kotlin_com_soywiz_korlibs_korio_korio.$_$.k2;
  var Companion_getInstance_7 = kotlin_com_soywiz_korlibs_klock_klock.$_$.z;
  var DateTime__format_impl_6el5l1 = kotlin_com_soywiz_korlibs_klock_klock.$_$.a;
  var Companion_getInstance_8 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.l1;
  var Size_init_$Create$ = kotlin_com_soywiz_korlibs_korma_korma.$_$.o;
  var SolidRect = kotlin_com_soywiz_korlibs_korge2_korge.$_$.n1;
  var size_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.o2;
  var UIContainer = kotlin_com_soywiz_korlibs_korge2_korge.$_$.w;
  var position = kotlin_com_soywiz_korlibs_korge2_korge.$_$.g2;
  var get_UI_DEFAULT_PADDING = kotlin_com_soywiz_korlibs_korge2_korge.$_$.a1;
  var UIVerticalStack = kotlin_com_soywiz_korlibs_korge2_korge.$_$.z;
  var UISpacing = kotlin_com_soywiz_korlibs_korge2_korge.$_$.x;
  var get_textColor = kotlin_com_soywiz_korlibs_korge2_korge.$_$.q;
  var _RectCorners___init__impl__w373y9_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.c5;
  var _RectCorners___init__impl__w373y9_1 = kotlin_com_soywiz_korlibs_korma_korma.$_$.b5;
  var RoundRect = kotlin_com_soywiz_korlibs_korge2_korge.$_$.l1;
  var Key_LEFT_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.f;
  var Key_RIGHT_getInstance = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.h;
  var draggable = kotlin_com_soywiz_korlibs_korge2_korge.$_$.h;
  var toPoint = kotlin_com_soywiz_korlibs_korma_korma.$_$.ma;
  var position_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.h2;
  var toIntCeil = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.c7;
  var toIntFloor_0 = kotlin_com_soywiz_korlibs_kmem_kmem.$_$.f7;
  var anchor_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.u1;
  var Anchorable = kotlin_com_soywiz_korlibs_korge2_korge.$_$.g1;
  var getExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.i2;
  var get_timers = kotlin_com_soywiz_korlibs_korge2_korge.$_$.v;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var FleksHookAlreadyAddedException = kotlin_metron_fleks.$_$.e;
  var Comparator = kotlin_kotlin.$_$.ng;
  var compareValues = kotlin_kotlin.$_$.da;
  var println = kotlin_kotlin.$_$.bb;
  var sortedWith = kotlin_kotlin.$_$.f9;
  var IteratingSystem = kotlin_metron_fleks.$_$.f;
  var Companion_getInstance_9 = kotlin_metron_fleks.$_$.j;
  var EachFrame_getInstance = kotlin_metron_fleks.$_$.i;
  var size_1 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.n2;
  var Camera = kotlin_com_soywiz_korlibs_korge2_korge.$_$.h1;
  var onStageResized = kotlin_com_soywiz_korlibs_korge2_korge.$_$.a2;
  var get_DefaultTtfFontAsBitmap = kotlin_com_soywiz_korlibs_korim_korim.$_$.y1;
  var Registry_getInstance = kotlin_metron_shared.$_$.a;
  var Scene = kotlin_com_soywiz_korlibs_korge2_korge.$_$.l;
  var FixedSizeContainer = kotlin_com_soywiz_korlibs_korge2_korge.$_$.k1;
  var AsyncInjector = kotlin_com_soywiz_korlibs_korinject_korinject.$_$.e;
  var Stage = kotlin_com_soywiz_korlibs_korge2_korge.$_$.o1;
  var get_AlphaTransition = kotlin_com_soywiz_korlibs_korge2_korge.$_$.j;
  var withEasing = kotlin_com_soywiz_korlibs_korge2_korge.$_$.m;
  var Companion_getInstance_10 = kotlin_com_soywiz_korlibs_korma_korma.$_$.x7;
  var views = kotlin_com_soywiz_korlibs_korge2_korge.$_$.b;
  var findFirstAscendant = kotlin_com_soywiz_korlibs_korge2_korge.$_$.y1;
  var SceneContainer = kotlin_com_soywiz_korlibs_korge2_korge.$_$.k;
  var Resources = kotlin_com_soywiz_korlibs_korio_korio.$_$.k3;
  var KClass = kotlin_kotlin.$_$.wd;
  var Companion_getInstance_11 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.d;
  var Level_INFO_getInstance = kotlin_com_soywiz_korlibs_klogger_klogger.$_$.c;
  var Size_init_$Create$_0 = kotlin_com_soywiz_korlibs_korma_korma.$_$.p;
  var Companion_getInstance_12 = kotlin_com_soywiz_korlibs_korma_korma.$_$.w7;
  var Companion_getInstance_13 = kotlin_com_soywiz_korlibs_korma_korma.$_$.m7;
  var Korge = kotlin_com_soywiz_korlibs_korge2_korge.$_$.c;
  var KProperty0 = kotlin_kotlin.$_$.zd;
  var ComponentType = kotlin_metron_fleks.$_$.b;
  var GlobalScope_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.o;
  var launchImmediately = kotlin_com_soywiz_korlibs_korio_korio.$_$.u1;
  var getExtraTyped = kotlin_com_soywiz_korlibs_kds_kds.$_$.h2;
  var hasExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.k2;
  var setExtra = kotlin_com_soywiz_korlibs_kds_kds.$_$.r2;
  var Companion_getInstance_14 = kotlin_com_soywiz_korlibs_korgw_korgw.$_$.o2;
  var alpha = kotlin_com_soywiz_korlibs_korge2_korge.$_$.t1;
  var Companion_getInstance_15 = kotlin_com_soywiz_korlibs_korio_korio.$_$.o1;
  var addUpdater_0 = kotlin_com_soywiz_korlibs_korge2_korge.$_$.s1;
  var split = kotlin_kotlin.$_$.df;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b6;
  var mapCapacity = kotlin_kotlin.$_$.l8;
  var coerceAtLeast = kotlin_kotlin.$_$.md;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.u;
  var substringBefore = kotlin_kotlin.$_$.lf;
  var substringAfter = kotlin_kotlin.$_$.jf;
  var to = kotlin_kotlin.$_$.mi;
  var readProperties = kotlin_com_soywiz_korlibs_korio_korio.$_$.h;
  var get_EmptyContinuation = kotlin_kotlin.$_$.ja;
  //endregion
  //region block: pre-declaration
  setMetadataFor(AuditType, 'AuditType', classMeta, Enum);
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, VOID, VOID, VOID, [1]);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Level, 'Level', classMeta, VOID, VOID, VOID, {0: $serializer_getInstance});
  setMetadataFor($invokeCOROUTINE$1, '$invokeCOROUTINE$1', classMeta, CoroutineImpl);
  setMetadataFor(Companion_0, 'Companion', objectMeta, VOID, VOID, VOID, VOID, [2]);
  setMetadataFor(sam$korlibs_math_interpolation_Easing$0, 'sam$korlibs_math_interpolation_Easing$0', classMeta);
  setMetadataFor(Stage_0, 'Stage', classMeta);
  setMetadataFor(ComponentHooks, 'ComponentHooks', classMeta, ComponentType);
  setMetadataFor(Companion_1, 'Companion', objectMeta, ComponentHooks);
  setMetadataFor(Audit, 'Audit', classMeta);
  setMetadataFor(Companion_2, 'Companion', objectMeta, ComponentHooks);
  setMetadataFor(AuditSpawner, 'AuditSpawner', classMeta);
  setMetadataFor(Companion_3, 'Companion', objectMeta, ComponentHooks);
  setMetadataFor(GhostStick, 'GhostStick', classMeta);
  setMetadataFor(Companion_4, 'Companion', objectMeta, ComponentHooks);
  setMetadataFor(GhostStickSpawner, 'GhostStickSpawner', classMeta);
  setMetadataFor(Companion_5, 'Companion', objectMeta, ComponentHooks);
  setMetadataFor(PlayerStick, 'PlayerStick', classMeta);
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor(AuditEvent, 'AuditEvent', classMeta, Event);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor(GameEndEvent, 'GameEndEvent', classMeta, Event);
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor(GameStartEvent, 'GameStartEvent', classMeta, Event);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor(GhostDrawedEvent, 'GhostDrawedEvent', classMeta, Event);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor(GhostSpawnEvent, 'GhostSpawnEvent', classMeta, Event);
  setMetadataFor(Companion_11, 'Companion', objectMeta);
  setMetadataFor(HitEvent, 'HitEvent', classMeta, Event);
  setMetadataFor(Companion_12, 'Companion', objectMeta);
  setMetadataFor(SettingsMenuToggleEvent, 'SettingsMenuToggleEvent', classMeta, Event);
  setMetadataFor(Combo, 'Combo', classMeta);
  setMetadataFor(HealthBar, 'HealthBar', classMeta);
  setMetadataFor(sam$metron_util_Effect$0, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(sam$metron_util_Effect$0_0, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(sam$metron_util_Effect$0_1, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(enableGameFinishing$lambda$slambda, 'enableGameFinishing$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(sam$metron_util_Effect$0_2, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(enableInput$slambda, 'enableInput$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(enableInput$slambda_1, 'enableInput$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(enableInput$slambda_3, 'enableInput$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(enableInput$slambda_5, 'enableInput$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(sam$metron_util_Effect$0_3, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(countdown$lambda$slambda, 'countdown$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(enableMapEditor$lambda$slambda, 'enableMapEditor$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(enableSettingsMenu$slambda, 'enableSettingsMenu$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(enableMusic$lambda$lambda$slambda, 'enableMusic$lambda$lambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($mainViewCOROUTINE$3, '$mainViewCOROUTINE$3', classMeta, CoroutineImpl);
  setMetadataFor(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', classMeta, VOID, [Comparator]);
  setMetadataFor(AuditSpawnerSystem$Companion$audit$slambda, 'AuditSpawnerSystem$Companion$audit$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor(Companion_13, 'Companion', objectMeta);
  setMetadataFor(AuditSpawnerSystem, 'AuditSpawnerSystem', classMeta, IteratingSystem);
  setMetadataFor(GhostSpawnerSystem, 'GhostSpawnerSystem', classMeta, IteratingSystem);
  setMetadataFor(PlayerStickSystem, 'PlayerStickSystem', classMeta, IteratingSystem);
  setMetadataFor(Companion_14, 'Companion', objectMeta);
  setMetadataFor(ResizedEvent, 'ResizedEvent', classMeta, Event);
  setMetadataFor(MainScene$sceneMain$slambda, 'MainScene$sceneMain$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [0]);
  setMetadataFor($sceneMainCOROUTINE$5, '$sceneMainCOROUTINE$5', classMeta, CoroutineImpl);
  setMetadataFor(MainScene, 'MainScene', classMeta, Scene, VOID, VOID, VOID, [0, 1]);
  setMetadataFor(startMain$slambda$slambda, 'startMain$slambda$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor(startMain$slambda, 'startMain$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($startMainCOROUTINE$4, '$startMainCOROUTINE$4', classMeta, CoroutineImpl);
  setMetadataFor(EasingEffect, 'EasingEffect', classMeta);
  setMetadataFor(sam$metron_util_Effect$0_4, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(sam$metron_util_Effect$0_5, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(sam$metron_util_Effect$0_6, 'sam$metron_util_Effect$0', classMeta);
  setMetadataFor(Companion_15, 'Companion', objectMeta);
  setMetadataFor(main$slambda, 'main$slambda', classMeta, CoroutineImpl, VOID, VOID, VOID, [1]);
  setMetadataFor($mainCOROUTINE$6, '$mainCOROUTINE$6', classMeta, CoroutineImpl);
  //endregion
  function set_LoginTokenSetter(_set____db54di) {
    LoginTokenSetter = _set____db54di;
  }
  var LoginTokenSetter;
  function set_LoginTokenGetter(_set____db54di) {
    LoginTokenGetter = _set____db54di;
  }
  var LoginTokenGetter;
  function set_clientWebsite(_set____db54di) {
    clientWebsite = _set____db54di;
  }
  var clientWebsite;
  function set_redirector(_set____db54di) {
    redirector = _set____db54di;
  }
  var redirector;
  var AuditType_TOO_FAST_instance;
  var AuditType_TOO_SLOW_instance;
  var AuditType_FAST_instance;
  var AuditType_SLOW_instance;
  var AuditType_PERF_instance;
  function values() {
    return [AuditType_TOO_FAST_getInstance(), AuditType_TOO_SLOW_getInstance(), AuditType_FAST_getInstance(), AuditType_SLOW_getInstance(), AuditType_PERF_getInstance()];
  }
  var AuditType_entriesInitialized;
  function AuditType_initEntries() {
    if (AuditType_entriesInitialized)
      return Unit_getInstance();
    AuditType_entriesInitialized = true;
    AuditType_TOO_FAST_instance = new AuditType('TOO_FAST', 0, '\uB108\uBB34 \uBE60\uB984!', Colors_getInstance().m4k_1, rangeTo(-0.4, -0.3));
    AuditType_TOO_SLOW_instance = new AuditType('TOO_SLOW', 1, '\uB108\uBB34 \uB290\uB9BC!', Colors_getInstance().m4k_1, rangeTo(0.3, 0.4));
    AuditType_FAST_instance = new AuditType('FAST', 2, '\uBE60\uB984!', Colors_getInstance().a4q_1, rangeTo(-0.3, -0.1));
    AuditType_SLOW_instance = new AuditType('SLOW', 3, '\uB290\uB9BC!', Colors_getInstance().a4q_1, rangeTo(0.1, 0.3));
    AuditType_PERF_instance = new AuditType('PERF', 4, '\uC815\uD655!', Colors_getInstance().n4k_1, rangeTo(-0.1, 0.1));
  }
  function AuditType(name, ordinal, text, color, range) {
    Enum.call(this, name, ordinal);
    this.gf7_1 = text;
    this.hf7_1 = color;
    this.if7_1 = range;
  }
  function AuditType_TOO_FAST_getInstance() {
    AuditType_initEntries();
    return AuditType_TOO_FAST_instance;
  }
  function AuditType_TOO_SLOW_getInstance() {
    AuditType_initEntries();
    return AuditType_TOO_SLOW_instance;
  }
  function AuditType_FAST_getInstance() {
    AuditType_initEntries();
    return AuditType_FAST_instance;
  }
  function AuditType_SLOW_getInstance() {
    AuditType_initEntries();
    return AuditType_SLOW_instance;
  }
  function AuditType_PERF_getInstance() {
    AuditType_initEntries();
    return AuditType_PERF_instance;
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.jf7_1 = [null, null, null, null, new ArrayListSerializer(DoubleSerializer_getInstance()), null, null, null];
  }
  var Companion_instance;
  function Companion_getInstance_16() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('metron.app.Level', this, 8);
    tmp0_serialDesc.aei('Name', false);
    tmp0_serialDesc.aei('Author', false);
    tmp0_serialDesc.aei('Bpm', false);
    tmp0_serialDesc.aei('Offset', false);
    tmp0_serialDesc.aei('map', true);
    tmp0_serialDesc.aei('Degrees', false);
    tmp0_serialDesc.aei('Magnanimity', false);
    tmp0_serialDesc.aei('InitialNote', false);
    this.kf7_1 = tmp0_serialDesc;
  }
  protoOf($serializer).lf7 = function (encoder, value) {
    var tmp0_desc = this.kf7_1;
    var tmp1_output = encoder.geb(tmp0_desc);
    var tmp2_cached = Companion_getInstance_16().jf7_1;
    tmp1_output.tec(tmp0_desc, 0, value.mf7_1);
    tmp1_output.tec(tmp0_desc, 1, value.nf7_1);
    tmp1_output.rec(tmp0_desc, 2, value.of7_1);
    tmp1_output.rec(tmp0_desc, 3, value.pf7_1);
    if (tmp1_output.zec(tmp0_desc, 4) ? true : !equals(value.qf7_1, fastArrayListOf([]))) {
      tmp1_output.vec(tmp0_desc, 4, tmp2_cached[4], value.qf7_1);
    }
    tmp1_output.rec(tmp0_desc, 5, value.rf7_1);
    tmp1_output.rec(tmp0_desc, 6, value.sf7_1);
    tmp1_output.rec(tmp0_desc, 7, value.tf7_1);
    tmp1_output.heb(tmp0_desc);
  };
  protoOf($serializer).le8 = function (encoder, value) {
    return this.lf7(encoder, value instanceof Level ? value : THROW_CCE());
  };
  protoOf($serializer).me8 = function (decoder) {
    var tmp0_desc = this.kf7_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = 0.0;
    var tmp7_local3 = 0.0;
    var tmp8_local4 = null;
    var tmp9_local5 = 0.0;
    var tmp10_local6 = 0.0;
    var tmp11_local7 = 0.0;
    var tmp13_input = decoder.geb(tmp0_desc);
    var tmp14_cached = Companion_getInstance_16().jf7_1;
    if (tmp13_input.veb()) {
      tmp4_local0 = tmp13_input.qeb(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp13_input.qeb(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp13_input.oeb(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp13_input.oeb(tmp0_desc, 3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp13_input.seb(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp13_input.oeb(tmp0_desc, 5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp13_input.oeb(tmp0_desc, 6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp13_input.oeb(tmp0_desc, 7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp13_input.web(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp13_input.qeb(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp13_input.qeb(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp13_input.oeb(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp13_input.oeb(tmp0_desc, 3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp13_input.seb(tmp0_desc, 4, tmp14_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp13_input.oeb(tmp0_desc, 5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp13_input.oeb(tmp0_desc, 6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp13_input.oeb(tmp0_desc, 7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp13_input.heb(tmp0_desc);
    return Level_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer).ke8 = function () {
    return this.kf7_1;
  };
  protoOf($serializer).cei = function () {
    var tmp0_cached = Companion_getInstance_16().jf7_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), tmp0_cached[4], DoubleSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
  };
  var $serializer_instance;
  function $serializer_getInstance() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function Level_init_$Init$(seen0, name, author, bpm, offset, map, degrees, magnanimity, initialNote, serializationConstructorMarker, $this) {
    if (!(239 === (239 & seen0))) {
      throwMissingFieldException(seen0, 239, $serializer_getInstance().kf7_1);
    }
    $this.mf7_1 = name;
    $this.nf7_1 = author;
    $this.of7_1 = bpm;
    $this.pf7_1 = offset;
    if (0 === (seen0 & 16))
      $this.qf7_1 = fastArrayListOf([]);
    else
      $this.qf7_1 = map;
    $this.rf7_1 = degrees;
    $this.sf7_1 = magnanimity;
    $this.tf7_1 = initialNote;
    var tmp = $this;
    tmp.uf7_1 = lazy(Level$_init_$lambda_etycjd($this));
    return $this;
  }
  function Level_init_$Create$(seen0, name, author, bpm, offset, map, degrees, magnanimity, initialNote, serializationConstructorMarker) {
    return Level_init_$Init$(seen0, name, author, bpm, offset, map, degrees, magnanimity, initialNote, serializationConstructorMarker, objectCreate(protoOf(Level)));
  }
  function Level$playingTime$delegate$lambda(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      var tmp0_get_seconds_3mcf5u = this$0.vf7();
      tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
      var tmp = tmp$ret$0;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.reduce' call
      var tmp1_reduce = this$0.qf7_1;
      var iterator = tmp1_reduce.g();
      if (!iterator.h())
        throw UnsupportedOperationException_init_$Create$("Empty collection can't be reduced.");
      var accumulator = iterator.i();
      while (iterator.h()) {
        var tmp$ret$1;
        // Inline function 'metron.app.Level.playingTime$delegate.<anonymous>.<anonymous>' call
        var tmp2_anonymous = accumulator;
        var tmp3_anonymous = iterator.i();
        tmp$ret$1 = tmp2_anonymous + tmp3_anonymous;
        accumulator = tmp$ret$1;
      }
      tmp$ret$2 = accumulator;
      return new TimeSpan(TimeSpan__times_impl_86ofia(tmp, tmp$ret$2));
    };
  }
  function Level$_init_$lambda_etycjd(this$0) {
    return function () {
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      var tmp0_get_seconds_3mcf5u = this$0.vf7();
      tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
      var tmp = tmp$ret$0;
      var tmp$ret$2;
      // Inline function 'kotlin.collections.reduce' call
      var tmp1_reduce = this$0.qf7_1;
      var iterator = tmp1_reduce.g();
      if (!iterator.h())
        throw UnsupportedOperationException_init_$Create$("Empty collection can't be reduced.");
      var accumulator = iterator.i();
      while (iterator.h()) {
        var tmp$ret$1;
        // Inline function 'metron.app.Level.<init>.<anonymous>.<anonymous>' call
        var tmp2_anonymous = accumulator;
        var tmp3_anonymous = iterator.i();
        tmp$ret$1 = tmp2_anonymous + tmp3_anonymous;
        accumulator = tmp$ret$1;
      }
      tmp$ret$2 = accumulator;
      return new TimeSpan(TimeSpan__times_impl_86ofia(tmp, tmp$ret$2));
    };
  }
  function Level(name, author, bpm, offset, map, degrees, magnanimity, initialNote) {
    Companion_getInstance_16();
    map = map === VOID ? fastArrayListOf([]) : map;
    this.mf7_1 = name;
    this.nf7_1 = author;
    this.of7_1 = bpm;
    this.pf7_1 = offset;
    this.qf7_1 = map;
    this.rf7_1 = degrees;
    this.sf7_1 = magnanimity;
    this.tf7_1 = initialNote;
    var tmp = this;
    tmp.uf7_1 = lazy(Level$playingTime$delegate$lambda(this));
  }
  protoOf(Level).vf7 = function () {
    return 60.0 / this.of7_1;
  };
  protoOf(Level).wf7 = function () {
    // Inline function 'kotlin.getValue' call
    playingTime$factory();
    return this.uf7_1.q().m12_1;
  };
  protoOf(Level).xf7 = function (name, author, bpm, offset, map, degrees, magnanimity, initialNote) {
    return new Level(name, author, bpm, offset, map, degrees, magnanimity, initialNote);
  };
  protoOf(Level).yf7 = function (name, author, bpm, offset, map, degrees, magnanimity, initialNote, $super) {
    name = name === VOID ? this.mf7_1 : name;
    author = author === VOID ? this.nf7_1 : author;
    bpm = bpm === VOID ? this.of7_1 : bpm;
    offset = offset === VOID ? this.pf7_1 : offset;
    map = map === VOID ? this.qf7_1 : map;
    degrees = degrees === VOID ? this.rf7_1 : degrees;
    magnanimity = magnanimity === VOID ? this.sf7_1 : magnanimity;
    initialNote = initialNote === VOID ? this.tf7_1 : initialNote;
    return $super === VOID ? this.xf7(name, author, bpm, offset, map, degrees, magnanimity, initialNote) : $super.xf7.call(this, name, author, bpm, offset, map, degrees, magnanimity, initialNote);
  };
  protoOf(Level).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Level))
      return false;
    var tmp0_other_with_cast = other instanceof Level ? other : THROW_CCE();
    if (!(this.mf7_1 === tmp0_other_with_cast.mf7_1))
      return false;
    if (!(this.nf7_1 === tmp0_other_with_cast.nf7_1))
      return false;
    if (!equals(this.of7_1, tmp0_other_with_cast.of7_1))
      return false;
    if (!equals(this.pf7_1, tmp0_other_with_cast.pf7_1))
      return false;
    if (!equals(this.qf7_1, tmp0_other_with_cast.qf7_1))
      return false;
    if (!equals(this.rf7_1, tmp0_other_with_cast.rf7_1))
      return false;
    if (!equals(this.sf7_1, tmp0_other_with_cast.sf7_1))
      return false;
    if (!equals(this.tf7_1, tmp0_other_with_cast.tf7_1))
      return false;
    return true;
  };
  protoOf(Level).hashCode = function () {
    var result = getStringHashCode(this.mf7_1);
    result = imul(result, 31) + getStringHashCode(this.nf7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.of7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.pf7_1) | 0;
    result = imul(result, 31) + hashCode(this.qf7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.rf7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.sf7_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.tf7_1) | 0;
    return result;
  };
  protoOf(Level).toString = function () {
    return 'Level(name=' + this.mf7_1 + ', author=' + this.nf7_1 + ', bpm=' + this.of7_1 + ', offset=' + this.pf7_1 + ', map=' + this.qf7_1 + ', degrees=' + this.rf7_1 + ', magnanimity=' + this.sf7_1 + ', initialNote=' + this.tf7_1 + ')';
  };
  function playingTime$factory() {
    return getPropertyCallableRef('playingTime', 1, KProperty1, function (receiver) {
      return new TimeSpan(receiver.wf7());
    }, null);
  }
  function Stage$Companion$invoke$lambda($configuration, $tmp5_also) {
    return function ($this$configureWorld) {
      $configuration($this$configureWorld, $tmp5_also);
      return Unit_getInstance();
    };
  }
  function Stage$Companion$invoke$lambda_0($tmp0_also) {
    return function (it) {
      $tmp0_also.qf6(_TimeSpan___get_seconds__impl__cx2k1c(it.tby_1));
      return Unit_getInstance();
    };
  }
  function $invokeCOROUTINE$1(_this__u8e3s4, levelName, configuration, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.hf8_1 = _this__u8e3s4;
    this.if8_1 = levelName;
    this.jf8_1 = configuration;
  }
  protoOf($invokeCOROUTINE$1).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 11;
            this.kf8_1 = get_nativeSoundProvider();
            var tmp_0 = this;
            tmp_0.lf8_1 = get_resourcesVfs().b18('sounds/hit.wav');
            this.xi_1 = 1;
            suspendResult = cachedToMemory(this.lf8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.mf8_1 = this.lf8_1;
            this.xi_1 = 2;
            suspendResult = readAudioData(this.mf8_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.nf8_1 = suspendResult;
            this.xi_1 = 3;
            suspendResult = this.kf8_1.n9j(this.nf8_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.of8_1 = suspendResult;
            this.of8_1.l9g(0.45);
            this.pf8_1 = this.of8_1;
            var tmp_1 = this;
            tmp_1.qf8_1 = get_resourcesVfs().b18(this.if8_1 + '/song.mp3');
            this.xi_1 = 4;
            suspendResult = cachedToMemory(this.qf8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.rf8_1 = this.qf8_1;
            this.xi_1 = 5;
            suspendResult = readSound(this.rf8_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.sf8_1 = suspendResult;
            this.xi_1 = 6;
            suspendResult = this.sf8_1.l9k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.tf8_1 = suspendResult;
            this.tf8_1.l9g(0.0);
            this.xi_1 = 7;
            suspendResult = this.pf8_1.l9k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.uf8_1 = suspendResult;
            this.uf8_1.l9g(0.0);
            this.xi_1 = 8;
            suspendResult = readWoffFont(get_resourcesVfs().b18('fonts/NanumSquareNeoTTF-eHv.woff'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.vf8_1 = suspendResult;
            this.xi_1 = 9;
            suspendResult = readWoffFont(get_resourcesVfs().b18('fonts/NanumSquareNeoTTF-dEb.woff'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.wf8_1 = suspendResult;
            var tmp_2 = this;
            tmp_2.xf8_1 = Default_getInstance();
            this.xi_1 = 10;
            suspendResult = get_resourcesVfs().b18(this.if8_1 + '/level.json').g27(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var tmp4_decodeFromString = suspendResult;
            var tmp0_serializer = this.xf8_1.ueb();
            var tmp0_cast = serializer(tmp0_serializer, createKType(getKClass(Level), arrayOf([]), false));
            var level = this.xf8_1.bet(isInterface(tmp0_cast, KSerializer) ? tmp0_cast : THROW_CCE(), tmp4_decodeFromString);
            var tmp5_also = new Stage_0(level, this.sf8_1, this.pf8_1, this.vf8_1, this.wf8_1);
            var tmp0_also = configureWorld(VOID, Stage$Companion$invoke$lambda(this.jf8_1, tmp5_also));
            var tmp_3 = get_screen();
            var tmp_4 = Companion_getInstance_0();
            tmp_3.h6p(tmp_4, Stage$Companion$invoke$lambda_0(tmp0_also));
            tmp5_also.wf9(tmp0_also);
            return tmp5_also;
          case 11:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 11) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  function getDefaultEasing($this) {
    var tmp = Stage$getDefaultEasing$lambda($this);
    return new sam$korlibs_math_interpolation_Easing$0(tmp);
  }
  function Companion_0() {
    Companion_instance_0 = this;
  }
  protoOf(Companion_0).xf9 = function (levelName, configuration, $completion) {
    var tmp = new $invokeCOROUTINE$1(this, levelName, configuration, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  var Companion_instance_0;
  function Companion_getInstance_17() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function sam$korlibs_math_interpolation_Easing$0(function_0) {
    this.yf9_1 = function_0;
  }
  protoOf(sam$korlibs_math_interpolation_Easing$0).d4f = function (it) {
    return this.yf9_1(it);
  };
  function Stage$getDefaultEasing$lambda(this$0) {
    return function (it) {
      var tmp$ret$0;
      // Inline function 'kotlin.math.cos' call
      var tmp0_cos = 3.141592653589793 * it;
      tmp$ret$0 = Math.cos(tmp0_cos);
      return (tmp$ret$0 + 1) / 2 * this$0.pf9_1 - 0.5 * this$0.pf9_1 + 0.5;
    };
  }
  function Stage_0(level, music, hitSound, boldFont, mediumFont) {
    Companion_getInstance_17();
    this.yf8_1 = level;
    this.zf8_1 = music;
    this.af9_1 = hitSound;
    this.bf9_1 = boldFont;
    this.cf9_1 = mediumFont;
    this.df9_1 = null;
    this.ef9_1 = get_degrees(this.yf8_1.rf7_1);
    this.ff9_1 = 0;
    this.gf9_1 = getDefaultEasing(this);
    this.hf9_1 = null;
    var tmp = this;
    // Inline function 'korlibs.korge.view.container' call
    var tmp0_container = get_camera();
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = new Container(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    tmp.if9_1 = addTo(tmp0_addTo, tmp0_container);
    this.jf9_1 = true;
    this.kf9_1 = false;
    this.lf9_1 = false;
    this.mf9_1 = false;
    this.nf9_1 = false;
    this.of9_1 = false;
    this.pf9_1 = 0.0;
    var tmp_0 = this;
    // Inline function 'korlibs.time.seconds' call
    tmp_0.qf9_1 = Companion_getInstance().p12(0.0);
    this.rf9_1 = fastArrayListOf([]);
    this.sf9_1 = 0;
    this.tf9_1 = this.yf8_1.qf7_1.g();
    this.uf9_1 = 0.0;
    this.vf9_1 = this.zf9();
  }
  protoOf(Stage_0).wf9 = function (value) {
    this.df9_1 = value;
  };
  protoOf(Stage_0).hf3 = function () {
    return ensureNotNull(this.df9_1);
  };
  protoOf(Stage_0).wf7 = function () {
    return this.yf8_1.wf7();
  };
  protoOf(Stage_0).afa = function () {
    return this.yf8_1.of7_1;
  };
  protoOf(Stage_0).vf7 = function () {
    return this.yf8_1.vf7();
  };
  protoOf(Stage_0).zf9 = function () {
    return this.yf8_1.tf7_1;
  };
  protoOf(Stage_0).bfa = function () {
    return this.vf7() * 4.0;
  };
  protoOf(Stage_0).cfa = function () {
    return this.yf8_1.pf7_1;
  };
  protoOf(Stage_0).dfa = function () {
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$0;
    // Inline function 'korlibs.time.milliseconds' call
    var tmp0_get_milliseconds_saqqmp = this.ff9_1;
    tmp$ret$0 = Companion_getInstance().g10(tmp0_get_milliseconds_saqqmp);
    var tmp1_get_seconds_18c81p = _TimeSpan___get_seconds__impl__cx2k1c(tmp$ret$0) / this.vf7();
    return Companion_getInstance().p12(tmp1_get_seconds_18c81p);
  };
  protoOf(Stage_0).efa = function () {
    return this.cfa() * this.vf7();
  };
  protoOf(Stage_0).ffa = function () {
    return this.jf9_1 ? true : this.kf9_1;
  };
  protoOf(Stage_0).gfa = function () {
    return this.yf8_1.sf7_1;
  };
  protoOf(Stage_0).hfa = function () {
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = this.bfa();
    var tmp = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    // Inline function 'korlibs.time.seconds' call
    var tmp_0 = Companion_getInstance().p12(0.0);
    var tmp$ret$2;
    // Inline function 'korlibs.time.seconds' call
    var tmp1_get_seconds_18c81p = this.efa();
    tmp$ret$2 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
    return TimeSpan__unaryMinus_impl_24dqtx(TimeSpan__plus_impl_qdd6zo(tmp, max(tmp_0, tmp$ret$2)));
  };
  protoOf(Stage_0).ie1 = function (delta) {
    this.qf9_1 = TimeSpan__plus_impl_qdd6zo(this.qf9_1, delta);
  };
  protoOf(Stage_0).ifa = function (delta) {
    this.ie1(delta);
    return this.jfa();
  };
  protoOf(Stage_0).kfa = function (elapsed) {
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = 60.0 / this.afa();
    var durationInTween = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.Stage.performAngle.<anonymous>' call
    var sum = TimeSpan__rem_impl_6i91m2(elapsed, TimeSpan__times_impl_86ofia_0(durationInTween, 2));
    var elapsedInTween = TimeSpan__compareTo_impl_zidry4(sum, durationInTween) > 0 ? TimeSpan__minus_impl_5w5v8s(TimeSpan__times_impl_86ofia_0(durationInTween, 2), sum) : sum;
    var ratioInTween = TimeSpan__div_impl_l42f2r(elapsedInTween, durationInTween);
    var easedRatioInTween = this.gf9_1.d4f(ratioInTween);
    var ratio = toRatio(easedRatioInTween);
    return interpolateAngleNormalized(ratio, Angle__unaryMinus_impl_7901fr(this.ef9_1), this.ef9_1);
  };
  protoOf(Stage_0).jfa = function (elapsed, $super) {
    elapsed = elapsed === VOID ? this.qf9_1 : elapsed;
    return $super === VOID ? this.kfa(elapsed) : $super.kfa.call(this, new TimeSpan(elapsed)).n3n_1;
  };
  protoOf(Stage_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Stage_0))
      return false;
    var tmp0_other_with_cast = other instanceof Stage_0 ? other : THROW_CCE();
    if (!this.yf8_1.equals(tmp0_other_with_cast.yf8_1))
      return false;
    if (!equals(this.zf8_1, tmp0_other_with_cast.zf8_1))
      return false;
    if (!equals(this.af9_1, tmp0_other_with_cast.af9_1))
      return false;
    if (!equals(this.bf9_1, tmp0_other_with_cast.bf9_1))
      return false;
    if (!equals(this.cf9_1, tmp0_other_with_cast.cf9_1))
      return false;
    return true;
  };
  protoOf(Stage_0).hashCode = function () {
    var result = this.yf8_1.hashCode();
    result = imul(result, 31) + hashCode(this.zf8_1) | 0;
    result = imul(result, 31) + hashCode(this.af9_1) | 0;
    result = imul(result, 31) + hashCode(this.bf9_1) | 0;
    result = imul(result, 31) + hashCode(this.cf9_1) | 0;
    return result;
  };
  protoOf(Stage_0).toString = function () {
    return 'Stage(level=' + this.yf8_1 + ', music=' + this.zf8_1 + ', hitSound=' + this.af9_1 + ', boldFont=' + this.bf9_1 + ', mediumFont=' + this.cf9_1 + ')';
  };
  function createAudit(_this__u8e3s4, ghostStick, audit) {
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var tmp0_create = _this__u8e3s4.hf3().cf4_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var tmp0_postCreate = tmp0_create.gf4_1.if5();
    if (_Entity___get_id__impl__z2xerk(tmp0_postCreate) >= tmp0_create.if4_1.ff2_1) {
      tmp0_create.if4_1.hf2(_Entity___get_id__impl__z2xerk(tmp0_postCreate), new BitArray(64));
    }
    var compMask = tmp0_create.if4_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate));
    // Inline function 'metron.app.components.createAudit.<anonymous>' call
    var tmp1_anonymous = tmp0_create.jf4_1;
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var tmp0_plusAssign = Companion_getInstance_18().ofa(ghostStick, audit);
    var compType = tmp0_plusAssign.pfa();
    tmp1_anonymous.wf3_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate)).mf2(compType.ef3_1);
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var tmp0_holder = tmp1_anonymous.xf3_1;
    if (tmp0_holder.gf3_1.if2(compType.ef3_1)) {
      var _elvis__6sfipt = getKClass(Audit).ue();
      var name = _elvis__6sfipt == null ? tmp0_holder.if3(getKClass(Audit)) : _elvis__6sfipt;
      var tmp = tmp0_holder.hf3();
      var tmp_0 = 0;
      var tmp_1 = tmp0_holder.hf3().gf2();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = null;
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp0_holder.gf3_1.hf2(compType.ef3_1, new ComponentsHolder(tmp, name, tmp_2));
    }
    var tmp_3 = tmp0_holder.gf3_1.k(compType.ef3_1);
    var holder = tmp_3 instanceof ComponentsHolder ? tmp_3 : THROW_CCE();
    holder.pf3(tmp0_postCreate, tmp0_plusAssign);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = tmp0_create.ff4_1.df4_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element.lf5(tmp0_postCreate, compMask);
    }
    var tmp7_safe_receiver = tmp0_create.nf4_1;
    if (tmp7_safe_receiver == null)
      null;
    else
      tmp7_safe_receiver(tmp0_create.ff4_1, new Entity(tmp0_postCreate));
    return tmp0_postCreate;
  }
  function Audit$Companion$invoke$lambda($body) {
    return function () {
      $body.xbu();
      return Unit_getInstance();
    };
  }
  function Audit$Companion$invoke$lambda_0($elapsed, $tmp0_apply, $ghostStick, $stage) {
    return function (it) {
      $elapsed._v = new TimeSpan(TimeSpan__plus_impl_qdd6zo($elapsed._v.m12_1, it.tby_1));
      $tmp0_apply.sbs(2.0);
      var tmp;
      if (TimeSpan__compareTo_impl_zidry4($elapsed._v.m12_1, TimeSpan__times_impl_86ofia($ghostStick.ufa_1, $stage.vf7())) >= 0) {
        $tmp0_apply.xbu();
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function Companion_1() {
    Companion_instance_1 = this;
    ComponentHooks.call(this);
  }
  protoOf(Companion_1).ofa = function (ghostStick, audit) {
    var body = ghostStick.rfa_1;
    var angle = body.hbt();
    var offset = get_degrees_0(-90);
    noteHitEffect(body, ghostStick.qfa_1, VOID, VOID, Audit$Companion$invoke$lambda(body));
    var stage = ghostStick.qfa_1;
    // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
    var tmp0_fastIterateRemove = stage.rf9_1;
    var n = 0;
    var m = 0;
    while (n < tmp0_fastIterateRemove.j()) {
      if (m >= 0 ? !(m === n) : false) {
        tmp0_fastIterateRemove.v2(m, tmp0_fastIterateRemove.k(n));
      }
      // Inline function 'metron.app.components.Companion.invoke.<anonymous>' call
      var tmp1_anonymous = tmp0_fastIterateRemove.k(n);
      if (equals(tmp1_anonymous.rfa_1, body)) {
        m = m - 1 | 0;
      }
      n = n + 1 | 0;
      m = m + 1 | 0;
    }
    while (tmp0_fastIterateRemove.j() > m) {
      tmp0_fastIterateRemove.x2(tmp0_fastIterateRemove.j() - 1 | 0);
    }
    // Inline function 'korlibs.korge.view.text' call
    var tmp2_text = get_camera();
    var tmp3_text = ' ' + audit.gf7_1 + ' ';
    var tmp4_text = audit.hf7_1;
    var tmp5_text = stage.bf9_1;
    var tmp6_text = Companion_getInstance_1().d59_1;
    var tmp7_text = get_DefaultStringTextRenderer();
    var tmp8_text = Companion_getInstance_2().qch_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = new Text(tmp3_text, 45.0, tmp4_text, tmp5_text, tmp6_text, tmp7_text, tmp8_text, null, null);
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(tmp0_addTo, tmp2_text);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.components.Companion.invoke.<anonymous>' call
    tmp0_apply.qdy(Companion_getInstance_1().m59_1);
    tmp0_apply.sdy(body.ibt());
    var auditHeight = get_stickHeight() + 70;
    var tmp = tmp0_apply.p2v().y3n_1;
    // Inline function 'korlibs.math.geom.cos' call
    var tmp0_cos = Angle__plus_impl_26v37k(angle, offset);
    var tmp1_cos = Companion_getInstance_3().e3o_1;
    var tmp_0 = tmp + auditHeight * Angle__cosine_impl_bgvzun(tmp0_cos, tmp1_cos);
    var tmp_1 = tmp0_apply.p2v().z3n_1;
    var tmp$ret$3;
    // Inline function 'korlibs.math.geom.sin' call
    var tmp2_sin = Angle__plus_impl_26v37k(angle, offset);
    var tmp3_sin = Companion_getInstance_3().e3o_1;
    tmp$ret$3 = Angle__sine_impl_3l11xv(tmp2_sin, tmp3_sin);
    tmp0_apply.o5d(new Vector2(tmp_0, tmp_1 + auditHeight * tmp$ret$3));
    var tmp_2 = get_screen();
    var tmp$ret$5;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.min' call
    var tmp4_min = getPositionRelativeTo(tmp0_apply, get_screen()).y3n_1;
    var tmp5_min = get_screen().n13() - tmp0_apply.n13() / 2;
    var tmp6_max = Math.min(tmp4_min, tmp5_min);
    var tmp7_max = tmp0_apply.n13() / 2;
    tmp$ret$5 = Math.max(tmp6_max, tmp7_max);
    setPositionRelativeTo(tmp0_apply, tmp_2, new Vector2(tmp$ret$5, getPositionRelativeTo(tmp0_apply, get_screen()).z3n_1));
    var tmp$ret$6;
    // Inline function 'korlibs.time.milliseconds' call
    tmp$ret$6 = Companion_getInstance().g10(0.0);
    var elapsed = {_v: new TimeSpan(tmp$ret$6)};
    var tmp_3 = get_screen();
    var tmp_4 = Companion_getInstance_0();
    tmp_3.h6p(tmp_4, Audit$Companion$invoke$lambda_0(elapsed, tmp0_apply, ghostStick, stage));
    return new Audit();
  };
  var Companion_instance_1;
  function Companion_getInstance_18() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function Audit() {
    Companion_getInstance_18();
  }
  protoOf(Audit).pfa = function () {
    return Companion_getInstance_18();
  };
  function Companion_2() {
    Companion_instance_2 = this;
    ComponentHooks.call(this);
  }
  var Companion_instance_2;
  function Companion_getInstance_19() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function AuditSpawner() {
    Companion_getInstance_19();
  }
  protoOf(AuditSpawner).pfa = function () {
    return Companion_getInstance_19();
  };
  function createGhostNote(_this__u8e3s4, angle, lifeTime, nextNote) {
    // Inline function 'kotlin.apply' call
    var tmp0_apply = Companion_getInstance_20().gfb(_this__u8e3s4, angle, lifeTime, nextNote);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.components.createGhostNote.<anonymous>' call
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var tmp0_create = _this__u8e3s4.hf3().cf4_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var tmp0_postCreate = tmp0_create.gf4_1.if5();
    if (_Entity___get_id__impl__z2xerk(tmp0_postCreate) >= tmp0_create.if4_1.ff2_1) {
      tmp0_create.if4_1.hf2(_Entity___get_id__impl__z2xerk(tmp0_postCreate), new BitArray(64));
    }
    var compMask = tmp0_create.if4_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate));
    // Inline function 'metron.app.components.createGhostNote.<anonymous>.<anonymous>' call
    var tmp1_anonymous = tmp0_create.jf4_1;
    var note = tmp0_apply;
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var compType = note.pfa();
    tmp1_anonymous.wf3_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate)).mf2(compType.ef3_1);
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var tmp0_holder = tmp1_anonymous.xf3_1;
    if (tmp0_holder.gf3_1.if2(compType.ef3_1)) {
      var _elvis__6sfipt = getKClass(GhostStick).ue();
      var name = _elvis__6sfipt == null ? tmp0_holder.if3(getKClass(GhostStick)) : _elvis__6sfipt;
      var tmp = tmp0_holder.hf3();
      var tmp_0 = 0;
      var tmp_1 = tmp0_holder.hf3().gf2();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = null;
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp0_holder.gf3_1.hf2(compType.ef3_1, new ComponentsHolder(tmp, name, tmp_2));
    }
    var tmp_3 = tmp0_holder.gf3_1.k(compType.ef3_1);
    var holder = tmp_3 instanceof ComponentsHolder ? tmp_3 : THROW_CCE();
    holder.pf3(tmp0_postCreate, note);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = tmp0_create.ff4_1.df4_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element.lf5(tmp0_postCreate, compMask);
    }
    var tmp7_safe_receiver = tmp0_create.nf4_1;
    if (tmp7_safe_receiver == null)
      null;
    else
      tmp7_safe_receiver(tmp0_create.ff4_1, new Entity(tmp0_postCreate));
    return tmp0_apply;
  }
  function GhostStick$Companion$onAdded$lambda(_this__u8e3s4, entity, ghostStick) {
    var stage = ghostStick.qfa_1;
    var tmp = get_screen();
    var tmp_0 = GhostStick$Companion$onAdded$lambda$lambda(stage);
    addTimer(tmp, ghostStick.ufa_1, tmp_0, GhostStick$Companion$onAdded$lambda$lambda_0(ghostStick, stage, _this__u8e3s4, entity.wf2_1));
    return Unit_getInstance();
  }
  function GhostStick$Companion$onAdded$lambda$lambda($stage) {
    return function (it) {
      var tmp;
      if ($stage.ffa()) {
        var tmp$ret$0;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$0 = Companion_getInstance().p12(0.0);
        tmp = tmp$ret$0;
      } else {
        tmp = it.m12_1;
      }
      return new TimeSpan(tmp);
    };
  }
  function GhostStick$Companion$onAdded$lambda$lambda$lambda($stage) {
    return function (it) {
      var tmp;
      if ($stage.ffa()) {
        var tmp$ret$0;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$0 = Companion_getInstance().p12(0.0);
        tmp = tmp$ret$0;
      } else {
        tmp = it.m12_1;
      }
      return new TimeSpan(tmp);
    };
  }
  function GhostStick$Companion$onAdded$lambda$lambda$lambda_0($ghostStick, $stage, $this, $entity) {
    return function ($this$easingEffect) {
      get_screen().q6p(new GhostDrawedEvent($ghostStick, true));
      $this$easingEffect.xbu();
      var tmp$ret$1;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var tmp0_fastIterateRemove = $stage.rf9_1;
      var n = 0;
      var m = 0;
      while (n < tmp0_fastIterateRemove.j()) {
        if (m >= 0 ? !(m === n) : false) {
          tmp0_fastIterateRemove.v2(m, tmp0_fastIterateRemove.k(n));
        }
        var tmp$ret$0;
        // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
        var tmp1_anonymous = tmp0_fastIterateRemove.k(n);
        tmp$ret$0 = equals(tmp1_anonymous.rfa_1, $ghostStick.rfa_1);
        if (tmp$ret$0) {
          var tmp0 = m;
          m = tmp0 - 1 | 0;
        }
        var tmp1 = n;
        n = tmp1 + 1 | 0;
        var tmp2 = m;
        m = tmp2 + 1 | 0;
      }
      while (tmp0_fastIterateRemove.j() > m) {
        tmp0_fastIterateRemove.x2(tmp0_fastIterateRemove.j() - 1 | 0);
      }
      tmp$ret$1 = tmp0_fastIterateRemove;
      $this.yf3($entity);
      return Unit_getInstance();
    };
  }
  function GhostStick$Companion$onAdded$lambda$lambda_0($ghostStick, $stage, $this, $entity) {
    return function (it) {
      var tmp;
      if ($ghostStick.wfa_1) {
        return Unit_getInstance();
      }
      var tmp$ret$3;
      // Inline function 'metron.util.Companion.easingEffect' call
      var tmp1_easingEffect = Companion_getInstance_32();
      var tmp2_easingEffect = $ghostStick.rfa_1;
      var tmp3_easingEffect = TimeSpan__div_impl_l42f2r_0($ghostStick.ufa_1, 2);
      var tmp4_easingEffect = Companion_getInstance_4().t4e();
      var tmp$ret$2;
      // Inline function 'kotlin.arrayOf' call
      var tmp0_arrayOf = [Companion_getInstance_32().kfb(0.5, true)];
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_arrayOf;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var tmp5_easingEffect = tmp$ret$2;
      var tmp6_easingEffect = GhostStick$Companion$onAdded$lambda$lambda$lambda($stage);
      var tmp7_easingEffect = GhostStick$Companion$onAdded$lambda$lambda$lambda_0($ghostStick, $stage, $this, $entity);
      (new EasingEffect(tmp4_easingEffect, tmp5_easingEffect, tmp7_easingEffect, tmp3_easingEffect, tmp2_easingEffect, tmp6_easingEffect)).tfb();
      tmp$ret$3 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function GhostStick$Companion$invoke$lambda($this$transform) {
    size($this$transform, get_stickSize());
    return Unit_getInstance();
  }
  function GhostStick$Companion$invoke$lambda_0(it) {
    return it;
  }
  function GhostStick$Companion$invoke$lambda_1(_this__u8e3s4) {
    return Unit_getInstance();
  }
  function Companion_3() {
    Companion_instance_3 = this;
    ComponentHooks.call(this);
    var tmp = this;
    tmp.ffb_1 = GhostStick$Companion$onAdded$lambda;
  }
  protoOf(Companion_3).afb = function () {
    return this.ffb_1;
  };
  protoOf(Companion_3).ufb = function (stage, angle, lifeTime, nextNote, startTime) {
    var tmp2_$receiver = stage.if9_1;
    var tmp3_corners = _RectCorners___init__impl__w373y9(1);
    var tmp4_size = get_stickSize();
    var tmp5_color = Colors_getInstance().y4p_1;
    // Inline function 'korlibs.korge.view.fastRoundRect' call
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = colorMul(new FastRoundRect(tmp4_size, tmp3_corners), tmp5_color);
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(tmp0_addTo, tmp2_$receiver);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.components.Companion.invoke.<anonymous>' call
    tmp0_apply.wbt(0.5);
    transform(tmp0_apply, GhostStick$Companion$invoke$lambda);
    configurePositionAndAnchor(tmp0_apply);
    tmp0_apply.gbt(angle);
    tmp0_apply.sbs(0.0);
    // Inline function 'metron.util.Companion.easingEffect' call
    Companion_getInstance_32();
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = stage.vf7();
    tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    var tmp3_easingEffect = TimeSpan__div_impl_l42f2r_0(tmp$ret$0, 4);
    var tmp4_easingEffect = Companion_getInstance_4().r4e();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp5_easingEffect = [Companion_getInstance_32().vfb(0.5)];
    var tmp6_easingEffect = GhostStick$Companion$invoke$lambda_0;
    var tmp7_easingEffect = GhostStick$Companion$invoke$lambda_1;
    (new EasingEffect(tmp4_easingEffect, tmp5_easingEffect, tmp7_easingEffect, tmp3_easingEffect, tmp0_apply, tmp6_easingEffect)).tfb();
    var body = tmp0_apply;
    return new GhostStick(stage, body, angle, startTime, lifeTime, nextNote);
  };
  protoOf(Companion_3).gfb = function (stage, angle, lifeTime, nextNote, startTime, $super) {
    startTime = startTime === VOID ? Companion_getInstance_5().yy() : startTime;
    return $super === VOID ? this.ufb(stage, angle, lifeTime, nextNote, startTime) : $super.ufb.call(this, stage, new Angle(angle), new TimeSpan(lifeTime), new TimeSpan(nextNote), new DateTime(startTime));
  };
  var Companion_instance_3;
  function Companion_getInstance_20() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function GhostStick(stage, body, angle, startTime, lifeTime, nextNote, isHitted) {
    Companion_getInstance_20();
    isHitted = isHitted === VOID ? false : isHitted;
    this.qfa_1 = stage;
    this.rfa_1 = body;
    this.sfa_1 = angle;
    this.tfa_1 = startTime;
    this.ufa_1 = lifeTime;
    this.vfa_1 = nextNote;
    this.wfa_1 = isHitted;
  }
  protoOf(GhostStick).pfa = function () {
    return Companion_getInstance_20();
  };
  protoOf(GhostStick).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof GhostStick))
      return false;
    var tmp0_other_with_cast = other instanceof GhostStick ? other : THROW_CCE();
    if (!this.qfa_1.equals(tmp0_other_with_cast.qfa_1))
      return false;
    if (!equals(this.rfa_1, tmp0_other_with_cast.rfa_1))
      return false;
    if (!equals(this.sfa_1, tmp0_other_with_cast.sfa_1))
      return false;
    if (!equals(this.tfa_1, tmp0_other_with_cast.tfa_1))
      return false;
    if (!equals(this.ufa_1, tmp0_other_with_cast.ufa_1))
      return false;
    if (!equals(this.vfa_1, tmp0_other_with_cast.vfa_1))
      return false;
    if (!(this.wfa_1 === tmp0_other_with_cast.wfa_1))
      return false;
    return true;
  };
  protoOf(GhostStick).hashCode = function () {
    var result = this.qfa_1.hashCode();
    result = imul(result, 31) + hashCode(this.rfa_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.sfa_1) | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.tfa_1) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl_izs3k5(this.ufa_1) | 0;
    result = imul(result, 31) + TimeSpan__hashCode_impl_izs3k5(this.vfa_1) | 0;
    result = imul(result, 31) + (this.wfa_1 | 0) | 0;
    return result;
  };
  protoOf(GhostStick).toString = function () {
    return 'GhostStick(stage=' + this.qfa_1 + ', body=' + this.rfa_1 + ', angle=' + new Angle(this.sfa_1) + ', startTime=' + new DateTime(this.tfa_1) + ', lifeTime=' + new TimeSpan(this.ufa_1) + ', nextNote=' + new TimeSpan(this.vfa_1) + ', isHitted=' + this.wfa_1 + ')';
  };
  function noteHitEffect(_this__u8e3s4, stage, period, easing, callback) {
    var tmp;
    if (period === VOID) {
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      var tmp0_get_seconds_3mcf5u = stage.vf7();
      tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
      tmp = TimeSpan__div_impl_l42f2r_0(tmp$ret$0, 6);
    } else {
      tmp = period;
    }
    period = tmp;
    easing = easing === VOID ? Companion_getInstance_4().v4e() : easing;
    var startTime = Companion_getInstance_5().yy();
    _this__u8e3s4.sbs(0.0);
    var listener = {_v: null};
    var tmp_0 = Companion_getInstance_0();
    listener._v = _this__u8e3s4.h6p(tmp_0, noteHitEffect$lambda(startTime, period, listener, callback, easing, _this__u8e3s4));
  }
  function noteHitEffect$lambda($startTime, $period, $listener, $callback, $easing, $this_noteHitEffect) {
    return function (it) {
      var now = Companion_getInstance_5().yy();
      var span = DateTime__minus_impl_10njw8(now, $startTime);
      if (TimeSpan__compareTo_impl_zidry4(span, $period) >= 0) {
        var tmp;
        if ($listener._v == null) {
          throwUninitializedPropertyAccessException('listener');
        } else {
          tmp = $listener._v;
        }
        cancel(tmp);
        $callback();
      } else {
        var i = 1 - TimeSpan__div_impl_l42f2r(span, $period);
        var a = $easing.d4f(i);
        scale($this_noteHitEffect, 1 + a, 1.0);
      }
      return Unit_getInstance();
    };
  }
  function createGhostSpawner(_this__u8e3s4) {
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var tmp0_create = _this__u8e3s4.hf3().cf4_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var tmp0_postCreate = tmp0_create.gf4_1.if5();
    if (_Entity___get_id__impl__z2xerk(tmp0_postCreate) >= tmp0_create.if4_1.ff2_1) {
      tmp0_create.if4_1.hf2(_Entity___get_id__impl__z2xerk(tmp0_postCreate), new BitArray(64));
    }
    var compMask = tmp0_create.if4_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate));
    // Inline function 'metron.app.components.createGhostSpawner.<anonymous>' call
    var tmp1_anonymous = tmp0_create.jf4_1;
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var tmp0_plusAssign = new GhostStickSpawner();
    var compType = tmp0_plusAssign.pfa();
    tmp1_anonymous.wf3_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate)).mf2(compType.ef3_1);
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var tmp0_holder = tmp1_anonymous.xf3_1;
    if (tmp0_holder.gf3_1.if2(compType.ef3_1)) {
      var _elvis__6sfipt = getKClass(GhostStickSpawner).ue();
      var name = _elvis__6sfipt == null ? tmp0_holder.if3(getKClass(GhostStickSpawner)) : _elvis__6sfipt;
      var tmp = tmp0_holder.hf3();
      var tmp_0 = 0;
      var tmp_1 = tmp0_holder.hf3().gf2();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = null;
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp0_holder.gf3_1.hf2(compType.ef3_1, new ComponentsHolder(tmp, name, tmp_2));
    }
    var tmp_3 = tmp0_holder.gf3_1.k(compType.ef3_1);
    var holder = tmp_3 instanceof ComponentsHolder ? tmp_3 : THROW_CCE();
    holder.pf3(tmp0_postCreate, tmp0_plusAssign);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = tmp0_create.ff4_1.df4_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element.lf5(tmp0_postCreate, compMask);
    }
    var tmp7_safe_receiver = tmp0_create.nf4_1;
    if (tmp7_safe_receiver == null)
      null;
    else
      tmp7_safe_receiver(tmp0_create.ff4_1, new Entity(tmp0_postCreate));
    return tmp0_postCreate;
  }
  function Companion_4() {
    Companion_instance_4 = this;
    ComponentHooks.call(this);
  }
  var Companion_instance_4;
  function Companion_getInstance_21() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function GhostStickSpawner() {
    Companion_getInstance_21();
  }
  protoOf(GhostStickSpawner).pfa = function () {
    return Companion_getInstance_21();
  };
  function createPlayerStick(_this__u8e3s4) {
    // Inline function 'com.github.quillraven.fleks.World.entity' call
    // Inline function 'com.github.quillraven.fleks.EntityService.create' call
    var tmp0_create = _this__u8e3s4.hf3().cf4_1;
    // Inline function 'com.github.quillraven.fleks.EntityService.postCreate' call
    var tmp0_postCreate = tmp0_create.gf4_1.if5();
    if (_Entity___get_id__impl__z2xerk(tmp0_postCreate) >= tmp0_create.if4_1.ff2_1) {
      tmp0_create.if4_1.hf2(_Entity___get_id__impl__z2xerk(tmp0_postCreate), new BitArray(64));
    }
    var compMask = tmp0_create.if4_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate));
    // Inline function 'metron.app.components.createPlayerStick.<anonymous>' call
    var tmp1_anonymous = tmp0_create.jf4_1;
    var stage = _this__u8e3s4;
    // Inline function 'com.github.quillraven.fleks.EntityCreateContext.plusAssign' call
    var tmp0_plusAssign = new PlayerStick(stage);
    var compType = tmp0_plusAssign.pfa();
    tmp1_anonymous.wf3_1.k(_Entity___get_id__impl__z2xerk(tmp0_postCreate)).mf2(compType.ef3_1);
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var tmp0_holder = tmp1_anonymous.xf3_1;
    if (tmp0_holder.gf3_1.if2(compType.ef3_1)) {
      var _elvis__6sfipt = getKClass(PlayerStick).ue();
      var name = _elvis__6sfipt == null ? tmp0_holder.if3(getKClass(PlayerStick)) : _elvis__6sfipt;
      var tmp = tmp0_holder.hf3();
      var tmp_0 = 0;
      var tmp_1 = tmp0_holder.hf3().gf2();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = null;
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp0_holder.gf3_1.hf2(compType.ef3_1, new ComponentsHolder(tmp, name, tmp_2));
    }
    var tmp_3 = tmp0_holder.gf3_1.k(compType.ef3_1);
    var holder = tmp_3 instanceof ComponentsHolder ? tmp_3 : THROW_CCE();
    holder.pf3(tmp0_postCreate, tmp0_plusAssign);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = tmp0_create.ff4_1.df4_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'com.github.quillraven.fleks.EntityService.postCreate.<anonymous>' call
      element.lf5(tmp0_postCreate, compMask);
    }
    var tmp7_safe_receiver = tmp0_create.nf4_1;
    if (tmp7_safe_receiver == null)
      null;
    else
      tmp7_safe_receiver(tmp0_create.ff4_1, new Entity(tmp0_postCreate));
    return tmp0_postCreate;
  }
  function PlayerStick$Companion$onAdded$lambda$lambda(this$0) {
    return function ($this$transform) {
      var tmp$ret$1;
      // Inline function 'korlibs.math.geom.pointArrayListOf' call
      var tmp0_pointArrayListOf = [Vector2_init_$Create$(0, -this$0.dfc()), Vector2_init_$Create$_0(0, 0), new Vector2(this$0.efc() / 2, this$0.dfc()), Vector2_init_$Create$_1(this$0.efc(), 0), new Vector2(this$0.efc(), -this$0.dfc())];
      var tmp$ret$0;
      // Inline function 'kotlin.also' call
      var tmp0_also = new PointArrayList(tmp0_pointArrayListOf.length);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.math.geom.pointArrayListOf.<anonymous>' call
      var indexedObject = tmp0_pointArrayListOf;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var element = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        tmp0_also.m3v(element);
      }
      tmp$ret$0 = tmp0_also;
      tmp$ret$1 = tmp$ret$0;
      $this$transform.adv(toPolygon(tmp$ret$1));
      return Unit_getInstance();
    };
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_0(this$0) {
    return function ($this$transform) {
      $this$transform.adv(toPolygon(pointArrayListOf(Vector2_init_$Create$_0(0, 0), Vector2_init_$Create$_1(this$0.efc(), 0), new Vector2(this$0.ffc(), this$0.gfc()), new Vector2(-this$0.ffc() + this$0.efc(), this$0.gfc()))));
      return Unit_getInstance();
    };
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_1(this$0) {
    return function ($this$transform) {
      $this$transform.adv(toPolygon(pointArrayListOf(Vector2_init_$Create$_1(-(this$0.ffc() - this$0.efc()) + this$0.hfc() * 2.0, 0), Vector2_init_$Create$_1(this$0.ifc(), 0), new Vector2(this$0.ffc(), this$0.jfc()), new Vector2(this$0.efc() - this$0.ffc(), this$0.jfc()))));
      positionY($this$transform, this$0.gfc() - $this$transform.o13());
      return Unit_getInstance();
    };
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_2($this$transform) {
    centerXOn($this$transform, get_screen());
    positionY($this$transform, (get_screen().o13() - get_stickY()) * 2 + get_stickWidth() / 2);
    return Unit_getInstance();
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_3($this$transform) {
    size($this$transform, get_stickSize());
    configureAnchor($this$transform);
    return Unit_getInstance();
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_4(x, y) {
    return Vector2_init_$Create$_2(x * get_stickArea(), y * get_stickArea());
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_5(this$0, $tmp6_apply) {
    return function ($this$transform) {
      colorMul($this$transform, this$0.zfb_1);
      anchor($this$transform, 0.5, 0.5);
      alignY($this$transform, $tmp6_apply, 0.42, true);
      return Unit_getInstance();
    };
  }
  function PlayerStick$Companion$onAdded$lambda$lambda_6($playerStick, $tmp6_apply) {
    return function ($this$addUpdater, it) {
      var tmp;
      if ($playerStick.kfc_1.kf9_1) {
        return Unit_getInstance();
      }
      var tmp$ret$0;
      // Inline function 'kotlin.math.min' call
      var tmp0_min = $playerStick.kfc_1.pf9_1;
      tmp$ret$0 = Math.min(0.08, tmp0_min);
      alignY($this$addUpdater, $tmp6_apply, 0.42 - tmp$ret$0, true);
      return Unit_getInstance();
    };
  }
  function PlayerStick$Companion$onAdded$lambda(this$0) {
    return function (_this__u8e3s4, entity, playerStick) {
      var tmp$ret$20;
      // Inline function 'kotlin.arrayOf' call
      var tmp$ret$10;
      // Inline function 'korlibs.korge.view.container' call
      var tmp0_container = get_camera();
      var tmp$ret$9;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo = new Container(false);
      var tmp$ret$8;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = addTo(tmp0_addTo, tmp0_container);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>' call
      var tmp$ret$3;
      // Inline function 'korlibs.korge.view.shapeView' call
      var tmp0_shapeView = Colors_getInstance().k4k_1;
      var tmp1_shapeView = Colors_getInstance().k4k_1;
      var tmp2_shapeView = GraphicsRenderer_GPU_getInstance();
      var tmp$ret$2;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_0 = new ShapeView(null, new RGBA(tmp0_shapeView), new RGBA(tmp1_shapeView), 1.0, true, tmp2_shapeView);
      var tmp$ret$1;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_0 = addTo(tmp0_addTo_0, tmp0_apply);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$0;
      // Inline function 'korlibs.korge.view.shapeView.<anonymous>' call
      tmp$ret$0 = Unit_getInstance();
      tmp$ret$1 = tmp0_apply_0;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var tmp = tmp$ret$3;
      colorMul(transform(tmp, PlayerStick$Companion$onAdded$lambda$lambda(this$0)), this$0.bfc_1);
      var tmp$ret$7;
      // Inline function 'korlibs.korge.view.shapeView' call
      var tmp3_shapeView = Colors_getInstance().k4k_1;
      var tmp4_shapeView = Colors_getInstance().k4k_1;
      var tmp5_shapeView = GraphicsRenderer_GPU_getInstance();
      var tmp$ret$6;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_1 = new ShapeView(null, new RGBA(tmp3_shapeView), new RGBA(tmp4_shapeView), 1.0, true, tmp5_shapeView);
      var tmp$ret$5;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_1 = addTo(tmp0_addTo_1, tmp0_apply);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$4;
      // Inline function 'korlibs.korge.view.shapeView.<anonymous>' call
      tmp$ret$4 = Unit_getInstance();
      tmp$ret$5 = tmp0_apply_1;
      tmp$ret$6 = tmp$ret$5;
      tmp$ret$7 = tmp$ret$6;
      var tmp_0 = tmp$ret$7;
      colorMul(transform(tmp_0, PlayerStick$Companion$onAdded$lambda$lambda_0(this$0)), this$0.afc_1);
      tmp$ret$8 = tmp0_apply;
      tmp$ret$9 = tmp$ret$8;
      tmp$ret$10 = tmp$ret$9;
      var tmp_1 = zIndex(tmp$ret$10, -10);
      var tmp$ret$17;
      // Inline function 'korlibs.korge.view.container' call
      var tmp1_container = get_camera();
      var tmp$ret$16;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_2 = new Container(false);
      var tmp$ret$15;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_2 = addTo(tmp0_addTo_2, tmp1_container);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>' call
      var tmp$ret$14;
      // Inline function 'korlibs.korge.view.shapeView' call
      var tmp0_shapeView_0 = Colors_getInstance().k4k_1;
      var tmp1_shapeView_0 = Colors_getInstance().k4k_1;
      var tmp2_shapeView_0 = GraphicsRenderer_GPU_getInstance();
      var tmp$ret$13;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_3 = new ShapeView(null, new RGBA(tmp0_shapeView_0), new RGBA(tmp1_shapeView_0), 1.0, true, tmp2_shapeView_0);
      var tmp$ret$12;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_3 = addTo(tmp0_addTo_3, tmp0_apply_2);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$11;
      // Inline function 'korlibs.korge.view.shapeView.<anonymous>' call
      tmp$ret$11 = Unit_getInstance();
      tmp$ret$12 = tmp0_apply_3;
      tmp$ret$13 = tmp$ret$12;
      tmp$ret$14 = tmp$ret$13;
      var tmp_2 = tmp$ret$14;
      colorMul(transform(tmp_2, PlayerStick$Companion$onAdded$lambda$lambda_1(this$0)), this$0.bfc_1);
      tmp$ret$15 = tmp0_apply_2;
      tmp$ret$16 = tmp$ret$15;
      tmp$ret$17 = tmp$ret$16;
      var tmp2_arrayOf = [tmp_1, zIndex(tmp$ret$17, 10)];
      var tmp$ret$19;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$18;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$18 = tmp2_arrayOf;
      tmp$ret$19 = tmp$ret$18;
      tmp$ret$20 = tmp$ret$19;
      var tmp3_fastForEach = tmp$ret$20;
      var n = 0;
      while (n < tmp3_fastForEach.length) {
        // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp4_anonymous = tmp3_fastForEach[tmp0];
        transform(tmp4_anonymous, PlayerStick$Companion$onAdded$lambda$lambda_2);
      }
      var tmp_3 = playerStick;
      var tmp$ret$33;
      // Inline function 'kotlin.apply' call
      var tmp$ret$24;
      // Inline function 'korlibs.korge.view.container' call
      var tmp5_container = get_camera();
      var tmp$ret$23;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_4 = new Container(false);
      var tmp$ret$22;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_4 = addTo(tmp0_addTo_4, tmp5_container);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$21;
      // Inline function 'korlibs.korge.view.container.<anonymous>' call
      tmp$ret$21 = Unit_getInstance();
      tmp$ret$22 = tmp0_apply_4;
      tmp$ret$23 = tmp$ret$22;
      tmp$ret$24 = tmp$ret$23;
      var tmp6_apply = tmp$ret$24;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>' call
      var tmp6_corners = _RectCorners___init__impl__w373y9(1);
      var tmp7_size = get_stickSize();
      var tmp8_color = this$0.zfb_1;
      var tmp$ret$27;
      // Inline function 'korlibs.korge.view.fastRoundRect' call
      var tmp$ret$26;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_5 = colorMul(new FastRoundRect(tmp7_size, tmp6_corners), tmp8_color);
      var tmp$ret$25;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_5 = addTo(tmp0_addTo_5, tmp6_apply);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>.<anonymous>' call
      tmp0_apply_5.sbs(1.0);
      transform(tmp0_apply_5, PlayerStick$Companion$onAdded$lambda$lambda_3);
      tmp$ret$25 = tmp0_apply_5;
      tmp$ret$26 = tmp$ret$25;
      tmp$ret$27 = tmp$ret$26;
      configurePosition(tmp6_apply);
      var tmp$ret$32;
      // Inline function 'kotlin.apply' call
      var tmp$ret$31;
      // Inline function 'korlibs.korge.view.shapeView' call
      var tmp_4 = pointArrayListOf(Vector2_init_$Create$_0(0, 0), Vector2_init_$Create$_0(130, 0), Vector2_init_$Create$_0(100, 130), Vector2_init_$Create$_0(30, 130));
      var tmp0_shapeView_1 = toPolygon(toPointArrayList(map(tmp_4, PlayerStick$Companion$onAdded$lambda$lambda_4)));
      var tmp1_shapeView_1 = Colors_getInstance().k4k_1;
      var tmp2_shapeView_1 = Colors_getInstance().k4k_1;
      var tmp3_shapeView_0 = GraphicsRenderer_GPU_getInstance();
      var tmp$ret$30;
      // Inline function 'korlibs.korge.view.addTo' call
      var tmp0_addTo_6 = new ShapeView(tmp0_shapeView_1, new RGBA(tmp1_shapeView_1), new RGBA(tmp2_shapeView_1), 1.0, true, tmp3_shapeView_0);
      var tmp$ret$29;
      // Inline function 'kotlin.apply' call
      var tmp0_apply_6 = addTo(tmp0_addTo_6, tmp6_apply);
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$28;
      // Inline function 'korlibs.korge.view.shapeView.<anonymous>' call
      tmp$ret$28 = Unit_getInstance();
      tmp$ret$29 = tmp0_apply_6;
      tmp$ret$30 = tmp$ret$29;
      tmp$ret$31 = tmp$ret$30;
      var tmp_5 = tmp$ret$31;
      var tmp4_apply = transform(tmp_5, PlayerStick$Companion$onAdded$lambda$lambda_5(this$0, tmp6_apply));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.components.Companion.onAdded.<anonymous>.<anonymous>.<anonymous>' call
      addUpdater(tmp4_apply, PlayerStick$Companion$onAdded$lambda$lambda_6(playerStick, tmp6_apply));
      tmp$ret$32 = tmp4_apply;
      tmp$ret$33 = tmp6_apply;
      tmp_3.lfc_1 = tmp$ret$33;
      return Unit_getInstance();
    };
  }
  function Companion_5() {
    Companion_instance_5 = this;
    ComponentHooks.call(this);
    this.zfb_1 = Colors_getInstance().p4z('FFFFFF');
    this.afc_1 = Colors_getInstance().p4z('8e8e8e');
    this.bfc_1 = Colors_getInstance().p4z('c8c8c8');
    var tmp = this;
    tmp.cfc_1 = PlayerStick$Companion$onAdded$lambda(this);
  }
  protoOf(Companion_5).gfc = function () {
    return get_stickHeight() * 159 / 160;
  };
  protoOf(Companion_5).efc = function () {
    return this.gfc() / 4;
  };
  protoOf(Companion_5).ffc = function () {
    return this.efc() * 2;
  };
  protoOf(Companion_5).dfc = function () {
    return -(this.gfc() / 20);
  };
  protoOf(Companion_5).lbv = function () {
    return 0.14285714285714285;
  };
  protoOf(Companion_5).jfc = function () {
    return this.gfc() * this.lbv();
  };
  protoOf(Companion_5).mfc = function () {
    // Inline function 'kotlin.math.sqrt' call
    // Inline function 'kotlin.math.pow' call
    var tmp0_pow = (this.ffc() - this.efc()) / 2.0;
    var tmp = Math.pow(tmp0_pow, 2.0);
    // Inline function 'kotlin.math.pow' call
    var tmp1_pow = this.gfc();
    var tmp2_sqrt = tmp + Math.pow(tmp1_pow, 2.0);
    return Math.sqrt(tmp2_sqrt);
  };
  protoOf(Companion_5).hfc = function () {
    // Inline function 'kotlin.math.sqrt' call
    // Inline function 'kotlin.math.pow' call
    var tmp0_pow = this.mfc() * this.lbv();
    var tmp = Math.pow(tmp0_pow, 2.0);
    // Inline function 'kotlin.math.pow' call
    var tmp1_pow = this.jfc();
    var tmp2_sqrt = tmp - Math.pow(tmp1_pow, 2.0);
    return Math.sqrt(tmp2_sqrt);
  };
  protoOf(Companion_5).ifc = function () {
    return this.ffc() - this.hfc() * 2.0;
  };
  protoOf(Companion_5).afb = function () {
    return this.cfc_1;
  };
  var Companion_instance_5;
  function Companion_getInstance_22() {
    if (Companion_instance_5 == null)
      new Companion_5();
    return Companion_instance_5;
  }
  function PlayerStick(stage) {
    Companion_getInstance_22();
    this.kfc_1 = stage;
  }
  protoOf(PlayerStick).nfc = function () {
    var tmp = this.lfc_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('body');
    }
  };
  protoOf(PlayerStick).pfa = function () {
    return Companion_getInstance_22();
  };
  function Companion_6() {
    Companion_instance_6 = this;
  }
  var Companion_instance_6;
  function Companion_getInstance_23() {
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function AuditEvent(ghostStick, audit) {
    Companion_getInstance_23();
    Event.call(this);
    this.qfc_1 = ghostStick;
    this.rfc_1 = audit;
  }
  protoOf(AuditEvent).r6p = function () {
    return Companion_getInstance_23();
  };
  protoOf(AuditEvent).toString = function () {
    return 'AuditEvent()';
  };
  function Companion_7() {
    Companion_instance_7 = this;
  }
  var Companion_instance_7;
  function Companion_getInstance_24() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function GameEndEvent(isSuccess) {
    Companion_getInstance_24();
    Event.call(this);
    this.ufc_1 = isSuccess;
  }
  protoOf(GameEndEvent).r6p = function () {
    return Companion_getInstance_24();
  };
  protoOf(GameEndEvent).toString = function () {
    return 'GameEndEvent()';
  };
  function Companion_8() {
    Companion_instance_8 = this;
  }
  var Companion_instance_8;
  function Companion_getInstance_25() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function GameStartEvent() {
    Companion_getInstance_25();
    Event.call(this);
  }
  protoOf(GameStartEvent).r6p = function () {
    return Companion_getInstance_25();
  };
  protoOf(GameStartEvent).toString = function () {
    return 'GameStartEvent()';
  };
  function Companion_9() {
    Companion_instance_9 = this;
  }
  var Companion_instance_9;
  function Companion_getInstance_26() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function GhostDrawedEvent(ghostStick, isNaturally) {
    Companion_getInstance_26();
    Event.call(this);
    this.zfc_1 = ghostStick;
    this.afd_1 = isNaturally;
  }
  protoOf(GhostDrawedEvent).r6p = function () {
    return Companion_getInstance_26();
  };
  protoOf(GhostDrawedEvent).toString = function () {
    return 'GhostDisposedEvent()';
  };
  function Companion_10() {
    Companion_instance_10 = this;
  }
  var Companion_instance_10;
  function Companion_getInstance_27() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function GhostSpawnEvent(view) {
    Companion_getInstance_27();
    Event.call(this);
    this.dfd_1 = view;
  }
  protoOf(GhostSpawnEvent).r6p = function () {
    return Companion_getInstance_27();
  };
  protoOf(GhostSpawnEvent).toString = function () {
    return 'GhostSpawnEvent()';
  };
  function Companion_11() {
    Companion_instance_11 = this;
  }
  var Companion_instance_11;
  function Companion_getInstance_28() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function HitEvent(delta) {
    Companion_getInstance_28();
    Event.call(this);
    this.gfd_1 = delta;
  }
  protoOf(HitEvent).r6p = function () {
    return Companion_getInstance_28();
  };
  protoOf(HitEvent).toString = function () {
    return 'HitEvent()';
  };
  function Companion_12() {
    Companion_instance_12 = this;
  }
  var Companion_instance_12;
  function Companion_getInstance_29() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function SettingsMenuToggleEvent() {
    Companion_getInstance_29();
    Event.call(this);
  }
  protoOf(SettingsMenuToggleEvent).r6p = function () {
    return Companion_getInstance_29();
  };
  protoOf(SettingsMenuToggleEvent).toString = function () {
    return 'SettingsMenuToggleEvent()';
  };
  function enableAutoPlaying(_this__u8e3s4) {
    // Inline function 'korlibs.korge.ui.uiText' call
    var tmp0_uiText = get_screen();
    var tmp1_uiText = Companion_getInstance_6().icb_1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(new UIText('Auto', tmp1_uiText), tmp0_uiText);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableAutoPlaying.<anonymous>' call
    // Inline function 'korlibs.korge.style.styles' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = get_styles(tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableAutoPlaying.<anonymous>.<anonymous>' call
    set_textFont(tmp0_apply_0, _this__u8e3s4.cf9_1);
    set_textColor(tmp0_apply_0, get_globalTextColor());
    set_textSize(tmp0_apply_0, 70.0);
    set_textAlignment(tmp0_apply_0, Companion_getInstance_1().r59_1);
    transform(tmp0_apply, enableAutoPlaying$lambda);
    var body = tmp0_apply;
    var tmp = get_screen();
    addUpdater(tmp, enableAutoPlaying$lambda_0(body, _this__u8e3s4));
  }
  function enableAutoPlaying$lambda($this$transform) {
    var padding = 150;
    positionX($this$transform, get_screen().n13() - $this$transform.n13() - padding);
    positionY_0($this$transform, padding);
    return Unit_getInstance();
  }
  function enableAutoPlaying$lambda_0($body, $this_enableAutoPlaying) {
    return function ($this$addUpdater, it) {
      $body.s8i($this_enableAutoPlaying.lf9_1);
      var tmp;
      if ($this_enableAutoPlaying.of9_1 ? true : $this_enableAutoPlaying.ffa()) {
        return Unit_getInstance();
      }
      var tmp_0;
      if (!$this_enableAutoPlaying.lf9_1) {
        return Unit_getInstance();
      }
      var d = $this_enableAutoPlaying.vf9_1 + _TimeSpan___get_seconds__impl__cx2k1c(it.m12_1) - _TimeSpan___get_seconds__impl__cx2k1c($this_enableAutoPlaying.qf9_1) / $this_enableAutoPlaying.vf7();
      var tmp_1;
      if (AuditType_PERF_getInstance().if7_1.d1(d - ($this_enableAutoPlaying.vf9_1 - $this_enableAutoPlaying.uf9_1))) {
        get_screen().q6p(new HitEvent(it.m12_1));
        tmp_1 = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableCombo(_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    var tmp0_apply = new Combo(_this__u8e3s4);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableCombo.<anonymous>' call
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_26();
    tmp.h6p(tmp_0, enableCombo$lambda(tmp0_apply));
    var tmp_1 = get_screen();
    var tmp_2 = Companion_getInstance_23();
    tmp_1.h6p(tmp_2, enableCombo$lambda_0(tmp0_apply));
    var tmp_3 = get_screen();
    var tmp_4 = Companion_getInstance_24();
    tmp_3.h6p(tmp_4, enableCombo$lambda_1(tmp0_apply));
  }
  function _get_span__ddsfup($this) {
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = $this.jfd_1.vf7();
    tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    return TimeSpan__div_impl_l42f2r_0(tmp$ret$0, 6);
  }
  function _set_stack__ks4rel($this, value) {
    $this.lfd_1 = value;
    if (value > 0) {
      setText($this.kfd_1, formattedCombo($this, value));
    }
  }
  function showCombo($this) {
    $this.kfd_1 = null;
    // Inline function 'metron.util.Companion.easingEffect' call
    Companion_getInstance_32();
    var tmp2_easingEffect = $this.mfd();
    var tmp3_easingEffect = _get_span__ddsfup($this);
    var tmp4_easingEffect = Companion_getInstance_4().t4e();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp5_easingEffect = [Companion_getInstance_32().vfb(1.2), Companion_getInstance_32().nfd(_TimeSpan___get_seconds__impl__cx2k1c(_get_span__ddsfup($this)) * 100.0)];
    var tmp6_easingEffect = Combo$showCombo$lambda;
    var tmp7_easingEffect = Combo$showCombo$lambda_0;
    (new EasingEffect(tmp4_easingEffect, tmp5_easingEffect, tmp7_easingEffect, tmp3_easingEffect, tmp2_easingEffect, tmp6_easingEffect)).tfb();
  }
  function hideCombo($this) {
    // Inline function 'kotlin.also' call
    var tmp15_safe_receiver = $this.kfd_1;
    var tmp;
    if (tmp15_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'metron.util.Companion.easingEffect' call
      Companion_getInstance_32();
      var tmp2_easingEffect = _get_span__ddsfup($this);
      var tmp3_easingEffect = Companion_getInstance_4().s4e();
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp4_easingEffect = [Companion_getInstance_32().kfb(1.2, true), Companion_getInstance_32().nfd(_TimeSpan___get_seconds__impl__cx2k1c(_get_span__ddsfup($this)) * 100.0)];
      var tmp5_easingEffect = Combo$hideCombo$lambda;
      var tmp6_easingEffect = Combo$hideCombo$lambda_0;
      (new EasingEffect(tmp3_easingEffect, tmp4_easingEffect, tmp5_easingEffect, tmp2_easingEffect, tmp15_safe_receiver, tmp6_easingEffect)).tfb();
      tmp = Unit_getInstance();
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.Combo.hideCombo.<anonymous>' call
    $this.kfd_1 = null;
  }
  function formattedCombo($this, combo) {
    return ' ' + (combo - 1 | 0) + ' \n-COMBO- ';
  }
  function Combo$_get_view_$lambda$lambda_6ruckk(this$0) {
    return function ($this$transform) {
      centerXOn($this$transform, get_screen());
      positionY_1($this$transform, $this$transform.p2v().z3n_1 - _TimeSpan___get_seconds__impl__cx2k1c(_get_span__ddsfup(this$0)) * 100);
      return Unit_getInstance();
    };
  }
  function Combo$_get_view_$lambda_gzsw1b(this$0) {
    return function ($this$createTitle) {
      transform($this$createTitle, Combo$_get_view_$lambda$lambda_6ruckk(this$0));
      return Unit_getInstance();
    };
  }
  function Combo$showCombo$lambda(it) {
    return it;
  }
  function Combo$showCombo$lambda_0(_this__u8e3s4) {
    return Unit_getInstance();
  }
  function Combo$hideCombo$lambda($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function Combo$hideCombo$lambda_0(it) {
    return it;
  }
  function Combo(stage) {
    this.jfd_1 = stage;
    this.kfd_1 = null;
    this.lfd_1 = 0;
  }
  protoOf(Combo).mfd = function () {
    var _elvis__6sfipt = this.kfd_1;
    var tmp;
    if (_elvis__6sfipt == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.handlers.Combo.<get-view>.<anonymous>' call
      var tmp_0 = this;
      tmp_0.kfd_1 = createTitle(this.jfd_1, '', 30, Combo$_get_view_$lambda_gzsw1b(this));
      tmp = ensureNotNull(this.kfd_1);
    } else {
      tmp = _elvis__6sfipt;
    }
    return tmp;
  };
  protoOf(Combo).ofd = function () {
    if (this.lfd_1 === 1) {
      showCombo(this);
    }
    var _unary__edvuaz = this.lfd_1;
    _set_stack__ks4rel(this, _unary__edvuaz + 1 | 0);
  };
  protoOf(Combo).pfd = function () {
    hideCombo(this);
    _set_stack__ks4rel(this, 0);
  };
  function enableCombo$lambda($tmp0_apply) {
    return function (it) {
      var tmp;
      if (!it.zfc_1.wfa_1 ? it.afd_1 : false) {
        $tmp0_apply.pfd();
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableCombo$lambda_0($tmp0_apply) {
    return function (it) {
      var tmp;
      if (it.rfc_1.equals(AuditType_PERF_getInstance())) {
        $tmp0_apply.ofd();
        tmp = Unit_getInstance();
      } else {
        $tmp0_apply.pfd();
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableCombo$lambda_1($tmp0_apply) {
    return function (it) {
      $tmp0_apply.pfd();
      return Unit_getInstance();
    };
  }
  function get_deathGageHeight() {
    return get_stickHeight();
  }
  function HealthBar(stage, view) {
    this.qfd_1 = stage;
    this.rfd_1 = view;
  }
  function enableDeath(_this__u8e3s4) {
    // Inline function 'korlibs.korge.view.container' call
    var tmp0_container = get_screen();
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = new Container(false);
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(tmp0_addTo, tmp0_container);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableDeath.<anonymous>' call
    // Inline function 'korlibs.korge.view.fastRoundRect' call
    var tmp0_fastRoundRect = new Size(get_stickWidth(), get_deathGageHeight());
    var tmp1_fastRoundRect = _RectCorners___init__impl__w373y9(1);
    var tmp2_fastRoundRect = Companion_getInstance_22().afc_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo_0 = colorMul(new FastRoundRect(tmp0_fastRoundRect, tmp1_fastRoundRect), tmp2_fastRoundRect);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fastRoundRect.<anonymous>' call
    addTo(tmp0_addTo_0, tmp0_apply);
    // Inline function 'korlibs.korge.view.fastRoundRect' call
    var tmp3_fastRoundRect = new Size(get_stickWidth(), get_deathGageHeight());
    var tmp4_fastRoundRect = _RectCorners___init__impl__w373y9(1);
    var tmp5_fastRoundRect = get_globalTextColor();
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo_1 = colorMul(new FastRoundRect(tmp3_fastRoundRect, tmp4_fastRoundRect), tmp5_fastRoundRect);
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = addTo(tmp0_addTo_1, tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableDeath.<anonymous>.<anonymous>' call
    var stage = _this__u8e3s4;
    var healthBar = new HealthBar(stage, tmp0_apply_0);
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_25();
    tmp.h6p(tmp_0, enableDeath$lambda(tmp0_apply_0, _this__u8e3s4));
    tmp0_apply_0.wbs(-1.0);
    positionY(tmp0_apply_0, tmp0_apply_0.p2v().z3n_1 + tmp0_apply_0.o13());
    addUpdater(tmp0_apply_0, enableDeath$lambda_0(healthBar, _this__u8e3s4));
    var tmp_1 = get_screen();
    var tmp_2 = Companion_getInstance_26();
    tmp_1.h6p(tmp_2, enableDeath$lambda_1(_this__u8e3s4, healthBar));
    var tmp_3 = get_screen();
    var tmp_4 = Companion_getInstance_23();
    tmp_3.h6p(tmp_4, enableDeath$lambda_2(_this__u8e3s4, healthBar));
    transform(tmp0_apply, enableDeath$lambda_3);
  }
  function decreaseHealth(_this__u8e3s4, amount) {
    // Inline function 'kotlin.run' call
    _this__u8e3s4.rfd_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.util.Companion.easingEffect' call
    Companion_getInstance_32();
    var tmp2_easingEffect = dummyView(get_screen());
    // Inline function 'korlibs.time.seconds' call
    var tmp3_easingEffect = Companion_getInstance().p12(0.1);
    var tmp4_easingEffect = Companion_getInstance_4().t4e();
    // Inline function 'kotlin.arrayOf' call
    var tmp = decreaseHealth$lambda(_this__u8e3s4, amount);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp5_easingEffect = [new sam$metron_util_Effect$0(tmp)];
    var tmp6_easingEffect = decreaseHealth$lambda_0;
    var tmp7_easingEffect = decreaseHealth$lambda_1;
    (new EasingEffect(tmp4_easingEffect, tmp5_easingEffect, tmp7_easingEffect, tmp3_easingEffect, tmp2_easingEffect, tmp6_easingEffect)).tfb();
    return Unit_getInstance();
  }
  function modifyHealth(_this__u8e3s4, adder) {
    // Inline function 'kotlin.run' call
    var tmp0_run = _this__u8e3s4.rfd_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'metron.app.handlers.modifyHealth.<anonymous>' call
      if (_this__u8e3s4.qfd_1.of9_1) {
        tmp$ret$0 = Unit_getInstance();
        break $l$block;
      }
      var newValue = tmp0_run.o13() + adder;
      var tmp$ret$1;
      // Inline function 'kotlin.math.min' call
      var tmp0_min = get_deathGageHeight();
      tmp$ret$1 = Math.min(newValue, tmp0_min);
      tmp0_run.vbt(tmp$ret$1);
      if (tmp0_run.o13() <= 0) {
        get_screen().q6p(new GameEndEvent(false));
      }
    }
    return tmp$ret$0;
  }
  function sam$metron_util_Effect$0(function_0) {
    this.sfd_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0).tfd = function (view, value) {
    return this.sfd_1(view, value);
  };
  function sam$metron_util_Effect$0_0(function_0) {
    this.ufd_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_0).tfd = function (view, value) {
    return this.ufd_1(view, value);
  };
  function enableDeath$lambda$lambda($tmp0_apply) {
    return function (_unused_var__etf5q3, value) {
      $tmp0_apply.vbt(value * get_deathGageHeight());
      return Unit_getInstance();
    };
  }
  function enableDeath$lambda$lambda_0(it) {
    return it;
  }
  function enableDeath$lambda$lambda_1(_this__u8e3s4) {
    return Unit_getInstance();
  }
  function enableDeath$lambda($tmp0_apply, $this_enableDeath) {
    return function (it) {
      var tmp;
      if (!($tmp0_apply.o13() === get_deathGageHeight())) {
        var tmp$ret$4;
        // Inline function 'metron.util.Companion.easingEffect' call
        var tmp2_easingEffect = Companion_getInstance_32();
        var tmp3_easingEffect = dummyView(get_screen());
        var tmp$ret$0;
        // Inline function 'korlibs.time.seconds' call
        var tmp0_get_seconds_3mcf5u = $this_enableDeath.vf7();
        tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
        var tmp4_easingEffect = TimeSpan__div_impl_l42f2r_0(tmp$ret$0, 4);
        var tmp5_easingEffect = Companion_getInstance_4().o4e();
        var tmp$ret$3;
        // Inline function 'kotlin.arrayOf' call
        var tmp_0 = enableDeath$lambda$lambda($tmp0_apply);
        var tmp1_arrayOf = [new sam$metron_util_Effect$0_0(tmp_0)];
        var tmp$ret$2;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$1;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$1 = tmp1_arrayOf;
        tmp$ret$2 = tmp$ret$1;
        tmp$ret$3 = tmp$ret$2;
        var tmp6_easingEffect = tmp$ret$3;
        var tmp7_easingEffect = enableDeath$lambda$lambda_0;
        var tmp8_easingEffect = enableDeath$lambda$lambda_1;
        (new EasingEffect(tmp5_easingEffect, tmp6_easingEffect, tmp8_easingEffect, tmp4_easingEffect, tmp3_easingEffect, tmp7_easingEffect)).tfb();
        tmp$ret$4 = Unit_getInstance();
        tmp = tmp$ret$4;
      }
      return Unit_getInstance();
    };
  }
  function enableDeath$lambda_0($healthBar, $this_enableDeath) {
    return function ($this$addUpdater, it) {
      $healthBar.rfd_1.s8i(!$this_enableDeath.nf9_1);
      var tmp;
      if ($this_enableDeath.nf9_1) {
        return Unit_getInstance();
      }
      var tmp_0;
      if ($this_enableDeath.ffa() ? true : $this_enableDeath.of9_1) {
        return Unit_getInstance();
      }
      var tmp_1;
      var tmp_2 = $this_enableDeath.qf9_1;
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.0);
      if (TimeSpan__compareTo_impl_zidry4(tmp_2, tmp$ret$0) < 0) {
        return Unit_getInstance();
      }
      modifyHealth($healthBar, -0.98);
      return Unit_getInstance();
    };
  }
  function enableDeath$lambda_1($this_enableDeath, $healthBar) {
    return function (it) {
      var tmp;
      if ($this_enableDeath.nf9_1) {
        return Unit_getInstance();
      }
      decreaseHealth($healthBar, 10.0);
      return Unit_getInstance();
    };
  }
  function enableDeath$lambda_2($this_enableDeath, $healthBar) {
    return function (it) {
      var tmp;
      if ($this_enableDeath.nf9_1) {
        return Unit_getInstance();
      }
      var tmp16_subject = it.rfc_1;
      var tmp0 = tmp16_subject.t5_1;
      var tmp_0;
      switch (tmp0) {
        case 0:
          tmp_0 = 20.0;
          break;
        case 1:
          tmp_0 = 20.0;
          break;
        case 2:
          tmp_0 = 10.0;
          break;
        case 3:
          tmp_0 = 10.0;
          break;
        case 4:
          tmp_0 = -15.0;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      decreaseHealth($healthBar, tmp_0);
      return Unit_getInstance();
    };
  }
  function enableDeath$lambda_3($this$transform) {
    var padding = 60;
    alignY($this$transform, get_screen(), 0.48, true);
    positionX_0($this$transform, padding);
    return Unit_getInstance();
  }
  function decreaseHealth$lambda($this_decreaseHealth, $amount) {
    return function (view, _unused_var__etf5q3) {
      modifyHealth($this_decreaseHealth, -$amount);
      return Unit_getInstance();
    };
  }
  function decreaseHealth$lambda_0(it) {
    return it;
  }
  function decreaseHealth$lambda_1(_this__u8e3s4) {
    return Unit_getInstance();
  }
  function enableGameFinishing(_this__u8e3s4) {
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_24();
    tmp.h6p(tmp_0, enableGameFinishing$lambda(_this__u8e3s4));
  }
  function sam$metron_util_Effect$0_1(function_0) {
    this.vfd_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_1).tfd = function (view, value) {
    return this.vfd_1(view, value);
  };
  function enableGameFinishing$lambda$lambda($this_enableGameFinishing) {
    return function (_unused_var__etf5q3, value) {
      $this_enableGameFinishing.pf9_1 = (1 - value) * $this_enableGameFinishing.gfa();
      return Unit_getInstance();
    };
  }
  function enableGameFinishing$lambda$lambda_0($this_enableGameFinishing) {
    return function ($this$easingEffect) {
      $this_enableGameFinishing.pf9_1 = 0.0;
      $this$easingEffect.xbu();
      var tmp = $this_enableGameFinishing;
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.0);
      tmp.qf9_1 = tmp$ret$0;
      $this_enableGameFinishing.jf9_1 = true;
      return Unit_getInstance();
    };
  }
  function enableGameFinishing$lambda$lambda_1(it) {
    return it;
  }
  function enableGameFinishing$lambda$lambda_2($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function enableGameFinishing$lambda$lambda_3(it) {
    return it;
  }
  function enableGameFinishing$lambda$lambda_4(_unused_var__etf5q3, value) {
    set_filter(get_camera(), new BlurFilter(value * 4.0));
    return Unit_getInstance();
  }
  function enableGameFinishing$lambda$lambda_5($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function enableGameFinishing$lambda$lambda_6(it) {
    return it;
  }
  function enableGameFinishing$lambda$slambda($this_enableGameFinishing, resultContinuation) {
    this.efe_1 = $this_enableGameFinishing;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableGameFinishing$lambda$slambda).g1p = function ($completion) {
    var tmp = this.v1l($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableGameFinishing$lambda$slambda).qj = function ($completion) {
    return this.g1p($completion);
  };
  protoOf(enableGameFinishing$lambda$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          var completionPercentage = numberToInt(TimeSpan__div_impl_l42f2r(this.efe_1.qf9_1, this.efe_1.wf7()) * 100);
          enableIntro(this.efe_1, '' + completionPercentage + '% \uC644\uB8CC');
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(enableGameFinishing$lambda$slambda).v1l = function (completion) {
    return new enableGameFinishing$lambda$slambda(this.efe_1, completion);
  };
  function enableGameFinishing$lambda$slambda_0($this_enableGameFinishing, resultContinuation) {
    var i = new enableGameFinishing$lambda$slambda($this_enableGameFinishing, resultContinuation);
    var l = function ($completion) {
      return i.g1p($completion);
    };
    l.$arity = 0;
    return l;
  }
  function enableGameFinishing$lambda($this_enableGameFinishing) {
    return function (it) {
      var tmp;
      if ($this_enableGameFinishing.of9_1) {
        return Unit_getInstance();
      }
      $this_enableGameFinishing.of9_1 = true;
      var tmp$ret$6;
      // Inline function 'metron.util.Companion.easingEffect' call
      var tmp4_easingEffect = Companion_getInstance_32();
      var tmp5_easingEffect = dummyView(get_screen());
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      var tmp0_get_seconds_3mcf5u = $this_enableGameFinishing.vf7();
      tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
      var tmp_0 = tmp$ret$0;
      var tmp_1 = $this_enableGameFinishing.qf9_1;
      var tmp$ret$1;
      // Inline function 'korlibs.time.seconds' call
      var tmp1_get_seconds_18c81p = $this_enableGameFinishing.vf7();
      tmp$ret$1 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
      var tmp_2 = TimeSpan__minus_impl_5w5v8s(tmp_0, TimeSpan__rem_impl_6i91m2(tmp_1, tmp$ret$1));
      var tmp$ret$2;
      // Inline function 'korlibs.time.seconds' call
      var tmp2_get_seconds_630v98 = $this_enableGameFinishing.vf7();
      tmp$ret$2 = Companion_getInstance().p12(tmp2_get_seconds_630v98);
      var tmp6_easingEffect = TimeSpan__plus_impl_qdd6zo(tmp_2, TimeSpan__times_impl_86ofia(tmp$ret$2, 1.5));
      var tmp7_easingEffect = Companion_getInstance_4().o4e();
      var tmp$ret$5;
      // Inline function 'kotlin.arrayOf' call
      var tmp_3 = enableGameFinishing$lambda$lambda($this_enableGameFinishing);
      var tmp3_arrayOf = [new sam$metron_util_Effect$0_1(tmp_3)];
      var tmp$ret$4;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$3;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$3 = tmp3_arrayOf;
      tmp$ret$4 = tmp$ret$3;
      tmp$ret$5 = tmp$ret$4;
      var tmp8_easingEffect = tmp$ret$5;
      var tmp9_easingEffect = enableGameFinishing$lambda$lambda_0($this_enableGameFinishing);
      var tmp10_easingEffect = enableGameFinishing$lambda$lambda_1;
      (new EasingEffect(tmp7_easingEffect, tmp8_easingEffect, tmp9_easingEffect, tmp6_easingEffect, tmp5_easingEffect, tmp10_easingEffect)).tfb();
      tmp$ret$6 = Unit_getInstance();
      var tmp_4 = $this_enableGameFinishing;
      var tmp$ret$7;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp$ret$7 = ArrayList_init_$Create$();
      tmp_4.tf9_1 = tmp$ret$7.g();
      var tmp11_fastForEach = $this_enableGameFinishing.rf9_1;
      var n = 0;
      while (n < tmp11_fastForEach.j()) {
        // Inline function 'metron.app.handlers.enableGameFinishing.<anonymous>.<anonymous>' call
        var tmp0 = n;
        n = tmp0 + 1 | 0;
        var tmp12_anonymous = tmp11_fastForEach.k(tmp0);
        var tmp$ret$12;
        // Inline function 'metron.util.Companion.easingEffect' call
        var tmp2_easingEffect = Companion_getInstance_32();
        var tmp3_easingEffect = tmp12_anonymous.rfa_1;
        var tmp$ret$8;
        // Inline function 'korlibs.time.seconds' call
        var tmp0_get_seconds_3mcf5u_0 = $this_enableGameFinishing.vf7();
        tmp$ret$8 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u_0);
        var tmp4_easingEffect_0 = TimeSpan__div_impl_l42f2r_0(tmp$ret$8, 6);
        var tmp5_easingEffect_0 = Companion_getInstance_4().r4e();
        var tmp$ret$11;
        // Inline function 'kotlin.arrayOf' call
        var tmp1_arrayOf = [Companion_getInstance_32().vfb(1.0)];
        var tmp$ret$10;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$9;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$9 = tmp1_arrayOf;
        tmp$ret$10 = tmp$ret$9;
        tmp$ret$11 = tmp$ret$10;
        var tmp6_easingEffect_0 = tmp$ret$11;
        var tmp7_easingEffect_0 = enableGameFinishing$lambda$lambda_2;
        var tmp8_easingEffect_0 = enableGameFinishing$lambda$lambda_3;
        (new EasingEffect(tmp5_easingEffect_0, tmp6_easingEffect_0, tmp7_easingEffect_0, tmp4_easingEffect_0, tmp3_easingEffect, tmp8_easingEffect_0)).tfb();
        tmp$ret$12 = Unit_getInstance();
      }
      $this_enableGameFinishing.rf9_1.y2();
      var tmp_5;
      if (it.ufc_1) {
        createTitle($this_enableGameFinishing, '\uD074\uB9AC\uC5B4!');
        var tmp$ret$17;
        // Inline function 'metron.util.Companion.easingEffect' call
        var tmp14_easingEffect = Companion_getInstance_32();
        var tmp15_easingEffect = dummyView(get_screen());
        var tmp$ret$13;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$13 = Companion_getInstance().p12(1.0);
        var tmp16_easingEffect = tmp$ret$13;
        var tmp17_easingEffect = Companion_getInstance_4().r4e();
        var tmp$ret$16;
        // Inline function 'kotlin.arrayOf' call
        var tmp_6 = enableGameFinishing$lambda$lambda_4;
        var tmp13_arrayOf = [new sam$metron_util_Effect$0_1(tmp_6)];
        var tmp$ret$15;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$14;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$14 = tmp13_arrayOf;
        tmp$ret$15 = tmp$ret$14;
        tmp$ret$16 = tmp$ret$15;
        var tmp18_easingEffect = tmp$ret$16;
        var tmp19_easingEffect = enableGameFinishing$lambda$lambda_5;
        var tmp20_easingEffect = enableGameFinishing$lambda$lambda_6;
        (new EasingEffect(tmp17_easingEffect, tmp18_easingEffect, tmp19_easingEffect, tmp16_easingEffect, tmp15_easingEffect, tmp20_easingEffect)).tfb();
        tmp$ret$17 = Unit_getInstance();
        tmp_5 = tmp$ret$17;
      } else {
        launchNow(VOID, enableGameFinishing$lambda$slambda_0($this_enableGameFinishing, null));
        tmp_5 = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableHitEffect(_this__u8e3s4) {
    var dummyView_0 = dummyView(get_screen());
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_28();
    tmp.h6p(tmp_0, enableHitEffect$lambda(_this__u8e3s4, dummyView_0));
  }
  function sam$metron_util_Effect$0_2(function_0) {
    this.ffe_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_2).tfd = function (view, value) {
    return this.ffe_1(view, value);
  };
  function enableHitEffect$lambda$lambda(_unused_var__etf5q3, value) {
    scale_0(get_camera(), 1 + (1 - value) * 0.01);
    centerOn(get_camera(), get_screen());
    return Unit_getInstance();
  }
  function enableHitEffect$lambda$lambda_0(it) {
    return it;
  }
  function enableHitEffect$lambda$lambda_1(_this__u8e3s4) {
    return Unit_getInstance();
  }
  function enableHitEffect$lambda($this_enableHitEffect, $dummyView) {
    return function (it) {
      get_hapticFeedback(get_scene().rab_1).abw(HapticFeedbackKind_GENERIC_getInstance());
      var tmp;
      if ($this_enableHitEffect.of9_1 ? true : $this_enableHitEffect.ffa()) {
        return Unit_getInstance();
      }
      var tmp$ret$4;
      // Inline function 'metron.util.Companion.easingEffect' call
      var tmp1_easingEffect = Companion_getInstance_32();
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.05);
      var tmp2_easingEffect = tmp$ret$0;
      var tmp3_easingEffect = Companion_getInstance_4().q4e();
      var tmp$ret$3;
      // Inline function 'kotlin.arrayOf' call
      var tmp_0 = enableHitEffect$lambda$lambda;
      var tmp0_arrayOf = [new sam$metron_util_Effect$0_2(tmp_0)];
      var tmp$ret$2;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$1;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$1 = tmp0_arrayOf;
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var tmp4_easingEffect = tmp$ret$3;
      var tmp5_easingEffect = enableHitEffect$lambda$lambda_0;
      var tmp6_easingEffect = enableHitEffect$lambda$lambda_1;
      (new EasingEffect(tmp3_easingEffect, tmp4_easingEffect, tmp6_easingEffect, tmp2_easingEffect, $dummyView, tmp5_easingEffect)).tfb();
      tmp$ret$4 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function enableInput(_this__u8e3s4) {
    // Inline function 'kotlin.apply' call
    var tmp0_apply = get_screen();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableInput.<anonymous>' call
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_28();
    tmp.h6p(tmp_0, enableInput$lambda(_this__u8e3s4));
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    var tmp0_run = get_keys(tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableInput.<anonymous>.<anonymous>' call
    var tmp_1 = Key_SPACE_getInstance();
    tmp0_run.nap(tmp_1, enableInput$slambda_0(null));
    var tmp_2 = Key_A_getInstance();
    tmp0_run.nap(tmp_2, enableInput$slambda_2(_this__u8e3s4, null));
    var tmp_3 = Key_ESCAPE_getInstance();
    tmp0_run.nap(tmp_3, enableInput$slambda_4(_this__u8e3s4, tmp0_apply, null));
    var tmp_4 = Key_E_getInstance();
    tmp0_run.nap(tmp_4, enableInput$slambda_6(_this__u8e3s4, null));
    var tmp_5 = get_screen();
    var tmp_6 = Type_START_getInstance();
    tmp_5.h6p(tmp_6, enableInput$lambda_0);
    return tmp0_apply;
  }
  function hit(delta) {
    get_screen().q6p(new HitEvent(delta));
  }
  function enableInput$lambda($this_enableInput) {
    return function (it) {
      var tmp;
      var tmp_0 = $this_enableInput.qf9_1;
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.0);
      if (TimeSpan__compareTo_impl_zidry4(tmp_0, tmp$ret$0) < 0) {
        return Unit_getInstance();
      }
      Companion_getInstance_30().ife($this_enableInput, it.gfd_1);
      return Unit_getInstance();
    };
  }
  function enableInput$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableInput$slambda).pan = function (it, $completion) {
    var tmp = this.qan(it, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableInput$slambda).ck = function (p1, $completion) {
    return this.pan(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(enableInput$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          hit(this.rfe_1.s6q_1);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(enableInput$slambda).qan = function (it, completion) {
    var i = new enableInput$slambda(completion);
    i.rfe_1 = it;
    return i;
  };
  function enableInput$slambda_0(resultContinuation) {
    var i = new enableInput$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.pan(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enableInput$slambda_1($this_enableInput, resultContinuation) {
    this.aff_1 = $this_enableInput;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableInput$slambda_1).pan = function (it, $completion) {
    var tmp = this.qan(it, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableInput$slambda_1).ck = function (p1, $completion) {
    return this.pan(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(enableInput$slambda_1).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          this.aff_1.lf9_1 = !this.aff_1.lf9_1;
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(enableInput$slambda_1).qan = function (it, completion) {
    var i = new enableInput$slambda_1(this.aff_1, completion);
    i.bff_1 = it;
    return i;
  };
  function enableInput$slambda_2($this_enableInput, resultContinuation) {
    var i = new enableInput$slambda_1($this_enableInput, resultContinuation);
    var l = function (it, $completion) {
      return i.pan(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enableInput$slambda$lambda$lambda($this_enableInput) {
    return function () {
      ensureNotNull($this_enableInput.hf9_1).i9k();
      return Unit_getInstance();
    };
  }
  function enableInput$slambda$lambda($this_enableInput, $tmp0_apply) {
    return function (it) {
      var tmp;
      if (get_paused(ensureNotNull($this_enableInput.hf9_1))) {
        var tmp_0 = $this_enableInput.qf9_1;
        var tmp$ret$1;
        // Inline function 'korlibs.time.seconds' call
        var tmp$ret$0;
        // Inline function 'kotlin.math.max' call
        var tmp0_max = $this_enableInput.cfa() * -1;
        tmp$ret$0 = Math.max(0.0, tmp0_max);
        var tmp1_get_seconds_18c81p = tmp$ret$0;
        tmp$ret$1 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
        var timeSpan = TimeSpan__minus_impl_5w5v8s(tmp_0, tmp$ret$1);
        var tmp$ret$2;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$2 = Companion_getInstance().p12(0.0);
        if (TimeSpan__compareTo_impl_zidry4(timeSpan, tmp$ret$2) < 0) {
          timeout($tmp0_apply, timeSpan, enableInput$slambda$lambda$lambda($this_enableInput));
        } else {
          ensureNotNull($this_enableInput.hf9_1).v9j(timeSpan);
          ensureNotNull($this_enableInput.hf9_1).i9k();
        }
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableInput$slambda_3($this_enableInput, $tmp0_apply, resultContinuation) {
    this.kff_1 = $this_enableInput;
    this.lff_1 = $tmp0_apply;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableInput$slambda_3).pan = function (it, $completion) {
    var tmp = this.qan(it, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableInput$slambda_3).ck = function (p1, $completion) {
    return this.pan(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(enableInput$slambda_3).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          if (this.kff_1.kf9_1) {
            this.kff_1.kf9_1 = false;
            this.kff_1.mf9_1 = false;
            get_screen().q6p(new SettingsMenuToggleEvent());
            var tmp_0 = this.kff_1.qf9_1;
            if (TimeSpan__compareTo_impl_zidry4(tmp_0, Companion_getInstance().p12(0.0)) >= 0) {
              countdown(this.kff_1, VOID, enableInput$slambda$lambda(this.kff_1, this.lff_1));
            }
          } else {
            this.kff_1.mf9_1 = true;
            get_screen().q6p(new SettingsMenuToggleEvent());
            var tmp17_safe_receiver = this.kff_1.hf9_1;
            if (tmp17_safe_receiver == null)
              null;
            else {
              tmp17_safe_receiver.g9k();
            }
            this.kff_1.kf9_1 = true;
          }
          if (this.kff_1.nf9_1) {
            get_screen().q6p(new GameEndEvent(false));
          }
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(enableInput$slambda_3).qan = function (it, completion) {
    var i = new enableInput$slambda_3(this.kff_1, this.lff_1, completion);
    i.mff_1 = it;
    return i;
  };
  function enableInput$slambda_4($this_enableInput, $tmp0_apply, resultContinuation) {
    var i = new enableInput$slambda_3($this_enableInput, $tmp0_apply, resultContinuation);
    var l = function (it, $completion) {
      return i.pan(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enableInput$slambda_5($this_enableInput, resultContinuation) {
    this.vff_1 = $this_enableInput;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableInput$slambda_5).pan = function (it, $completion) {
    var tmp = this.qan(it, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableInput$slambda_5).ck = function (p1, $completion) {
    return this.pan(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(enableInput$slambda_5).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.xi_1 = 1;
            suspendResult = enableMapEditor(this.vff_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(enableInput$slambda_5).qan = function (it, completion) {
    var i = new enableInput$slambda_5(this.vff_1, completion);
    i.wff_1 = it;
    return i;
  };
  function enableInput$slambda_6($this_enableInput, resultContinuation) {
    var i = new enableInput$slambda_5($this_enableInput, resultContinuation);
    var l = function (it, $completion) {
      return i.pan(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enableInput$lambda_0(it) {
    hit(DateTime__minus_impl_10njw8(it.l6s_1, Companion_getInstance_5().yy()));
    return Unit_getInstance();
  }
  function enableIntro(_this__u8e3s4, intro) {
    intro = intro === VOID ? '\uD074\uB9AD\uD574\uC11C \uC2DC\uC791\uD558\uC138\uC694' : intro;
    var title = createTitle(_this__u8e3s4, intro, VOID, enableIntro$lambda);
    var hitEventNode = dummyView(get_screen());
    var tmp = Companion_getInstance_29();
    hitEventNode.h6p(tmp, enableIntro$lambda_0(hitEventNode, _this__u8e3s4, title));
    var tmp_0 = Companion_getInstance_28();
    hitEventNode.h6p(tmp_0, enableIntro$lambda_1(_this__u8e3s4, hitEventNode, title));
  }
  function countdown(_this__u8e3s4, times, callback) {
    times = times === VOID ? 4 : times;
    var tmp;
    if (callback === VOID) {
      tmp = countdown$lambda;
    } else {
      tmp = callback;
    }
    callback = tmp;
    var tmp_0 = new TimeSpan(_this__u8e3s4.qf9_1);
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$0 = Companion_getInstance().p12(0.0);
    if (!equals(tmp_0, new TimeSpan(tmp$ret$0))) {
      _this__u8e3s4.jf9_1 = true;
      _this__u8e3s4.kf9_1 = false;
      _this__u8e3s4.of9_1 = true;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = dummyView(get_screen());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.handlers.countdown.<anonymous>' call
      // Inline function 'kotlin.also' call
      var tmp_1 = TimeSpan__unaryMinus_impl_24dqtx(_this__u8e3s4.hfa());
      var tmp0_also = addTimer(tmp0_apply, tmp_1, VOID, countdown$lambda_0(_this__u8e3s4, tmp0_apply, callback));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.handlers.countdown.<anonymous>.<anonymous>' call
      var tmp_2 = Companion_getInstance_29();
      tmp0_apply.h6p(tmp_2, countdown$lambda_1(tmp0_also));
    } else {
      _this__u8e3s4.qf9_1 = _this__u8e3s4.hfa();
      _this__u8e3s4.tf9_1 = _this__u8e3s4.yf8_1.qf7_1.g();
      _this__u8e3s4.uf9_1 = 0.0;
      _this__u8e3s4.vf9_1 = 0.0;
      get_screen().q6p(new GameStartEvent());
      _this__u8e3s4.jf9_1 = false;
      _this__u8e3s4.kf9_1 = false;
      _this__u8e3s4.of9_1 = false;
      // Inline function 'kotlin.apply' call
      var tmp1_apply = dummyView(get_screen());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.handlers.countdown.<anonymous>' call
      var tmp_3 = Companion_getInstance_29();
      tmp1_apply.h6p(tmp_3, countdown$lambda_2(tmp1_apply, _this__u8e3s4));
      // Inline function 'metron.util.Companion.easingEffect' call
      Companion_getInstance_32();
      // Inline function 'korlibs.time.seconds' call
      var tmp0_get_seconds_3mcf5u = _this__u8e3s4.bfa() / 2;
      var tmp3_easingEffect = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
      var tmp4_easingEffect = Companion_getInstance_4().r4e();
      // Inline function 'kotlin.arrayOf' call
      var tmp_4 = countdown$lambda_3(_this__u8e3s4);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp5_easingEffect = [new sam$metron_util_Effect$0_3(tmp_4)];
      var tmp6_easingEffect = countdown$lambda_4(_this__u8e3s4);
      var tmp7_easingEffect = countdown$lambda_5;
      (new EasingEffect(tmp4_easingEffect, tmp5_easingEffect, tmp6_easingEffect, tmp3_easingEffect, tmp1_apply, tmp7_easingEffect)).tfb();
    }
    // Inline function 'kotlin.collections.forEach' call
    var tmp2_forEach = numberRangeToNumber(1, times);
    var inductionVariable = tmp2_forEach.a1_1;
    var last = tmp2_forEach.b1_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'metron.app.handlers.countdown.<anonymous>' call
        // Inline function 'korlibs.time.seconds' call
        var tmp0_get_seconds_3mcf5u_0 = _this__u8e3s4.vf7() / 3;
        var countdownEffectPeriod = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u_0);
        // Inline function 'kotlin.apply' call
        var tmp1_apply_0 = dummyView(get_screen());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'metron.app.handlers.countdown.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.also' call
        // Inline function 'korlibs.time.seconds' call
        var tmp_5 = element * _this__u8e3s4.vf7() - _this__u8e3s4.zf9() * _this__u8e3s4.vf7();
        // Inline function 'kotlin.math.max' call
        var tmp0_max = _this__u8e3s4.efa();
        var tmp1_get_seconds_18c81p = tmp_5 + Math.max(0.0, tmp0_max);
        var tmp_6 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
        var tmp2_also = timeout(tmp1_apply_0, tmp_6, countdown$lambda_6(element, times, _this__u8e3s4, countdownEffectPeriod));
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'metron.app.handlers.countdown.<anonymous>.<anonymous>.<anonymous>' call
        var tmp_7 = Companion_getInstance_29();
        tmp1_apply_0.h6p(tmp_7, countdown$lambda_7(tmp2_also, tmp1_apply_0));
      }
       while (!(element === last));
  }
  function sam$metron_util_Effect$0_3(function_0) {
    this.xff_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_3).tfd = function (view, value) {
    return this.xff_1(view, value);
  };
  function enableIntro$hideTitle($this_enableIntro, title) {
    // Inline function 'metron.util.Companion.easingEffect' call
    Companion_getInstance_32();
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = $this_enableIntro.vf7() / 3;
    var tmp3_easingEffect = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    var tmp4_easingEffect = Companion_getInstance_4().t4e();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp5_easingEffect = [Companion_getInstance_32().kfb(1.0, true), Companion_getInstance_32().nfd(70.0)];
    var tmp6_easingEffect = enableIntro$hideTitle$lambda;
    var tmp7_easingEffect = enableIntro$hideTitle$lambda_0;
    (new EasingEffect(tmp4_easingEffect, tmp5_easingEffect, tmp6_easingEffect, tmp3_easingEffect, title, tmp7_easingEffect)).tfb();
  }
  function enableIntro$lambda($this$createTitle) {
    transform($this$createTitle, enableIntro$lambda$lambda);
    // Inline function 'metron.util.Companion.easingEffect' call
    Companion_getInstance_32();
    // Inline function 'korlibs.time.seconds' call
    var tmp2_easingEffect = Companion_getInstance().p12(0.7);
    var tmp3_easingEffect = Companion_getInstance_4().t4e();
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_easingEffect = [Companion_getInstance_32().vfb(1.25), Companion_getInstance_32().nfd(70.0)];
    var tmp5_easingEffect = enableIntro$lambda$lambda_0;
    var tmp6_easingEffect = enableIntro$lambda$lambda_1;
    (new EasingEffect(tmp3_easingEffect, tmp4_easingEffect, tmp6_easingEffect, tmp2_easingEffect, $this$createTitle, tmp5_easingEffect)).tfb();
    return Unit_getInstance();
  }
  function enableIntro$lambda$lambda($this$transform) {
    centerXOn($this$transform, get_screen());
    return Unit_getInstance();
  }
  function enableIntro$lambda$lambda_0(it) {
    return it;
  }
  function enableIntro$lambda$lambda_1(_this__u8e3s4) {
    return Unit_getInstance();
  }
  function enableIntro$lambda_0($hitEventNode, $this_enableIntro, $title) {
    return function (it) {
      $hitEventNode.xbu();
      enableIntro$hideTitle($this_enableIntro, $title);
      return Unit_getInstance();
    };
  }
  function enableIntro$lambda_1($this_enableIntro, $hitEventNode, $title) {
    return function (it) {
      var tmp;
      var tmp_0;
      if ($this_enableIntro.of9_1) {
        var tmp_1 = new TimeSpan($this_enableIntro.qf9_1);
        var tmp$ret$0;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$0 = Companion_getInstance().p12(0.0);
        tmp_0 = !equals(tmp_1, new TimeSpan(tmp$ret$0));
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        return Unit_getInstance();
      }
      countdown($this_enableIntro);
      $hitEventNode.xbu();
      enableIntro$hideTitle($this_enableIntro, $title);
      return Unit_getInstance();
    };
  }
  function countdown$lambda(it) {
    return Unit_getInstance();
  }
  function countdown$lambda_0($this_countdown, $tmp0_apply, $callback) {
    return function (it) {
      $this_countdown.jf9_1 = false;
      $this_countdown.kf9_1 = false;
      $this_countdown.of9_1 = false;
      $tmp0_apply.xbu();
      $callback(it);
      return Unit_getInstance();
    };
  }
  function countdown$lambda_1($tmp0_also) {
    return function (it) {
      cancel($tmp0_also);
      return Unit_getInstance();
    };
  }
  function countdown$lambda_2($tmp1_apply, $this_countdown) {
    return function (it) {
      $tmp1_apply.xbu();
      var tmp = $this_countdown;
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.0);
      tmp.qf9_1 = tmp$ret$0;
      $this_countdown.pf9_1 = 0.0;
      return Unit_getInstance();
    };
  }
  function countdown$lambda_3($this_countdown) {
    return function (_unused_var__etf5q3, value) {
      $this_countdown.pf9_1 = value * $this_countdown.gfa();
      return Unit_getInstance();
    };
  }
  function countdown$lambda_4($this_countdown) {
    return function ($this$easingEffect) {
      $this_countdown.pf9_1 = $this_countdown.gfa();
      $this$easingEffect.xbu();
      return Unit_getInstance();
    };
  }
  function countdown$lambda_5(it) {
    return it;
  }
  function countdown$lambda$slambda($this_countdown, resultContinuation) {
    this.gfg_1 = $this_countdown;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(countdown$lambda$slambda).g1p = function ($completion) {
    var tmp = this.v1l($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(countdown$lambda$slambda).qj = function ($completion) {
    return this.g1p($completion);
  };
  protoOf(countdown$lambda$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.xi_1 = 1;
            suspendResult = this.gfg_1.af9_1.l9k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(countdown$lambda$slambda).v1l = function (completion) {
    return new countdown$lambda$slambda(this.gfg_1, completion);
  };
  function countdown$lambda$slambda_0($this_countdown, resultContinuation) {
    var i = new countdown$lambda$slambda($this_countdown, resultContinuation);
    var l = function ($completion) {
      return i.g1p($completion);
    };
    l.$arity = 0;
    return l;
  }
  function countdown$lambda$lambda$lambda($this$transform) {
    centerXOn($this$transform, get_screen());
    return Unit_getInstance();
  }
  function countdown$lambda$lambda$lambda$lambda($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function countdown$lambda$lambda$lambda$lambda_0(it) {
    return it;
  }
  function countdown$lambda$lambda$lambda_0($countdownEffectPeriod) {
    return function ($this$easingEffect) {
      var tmp$ret$3;
      // Inline function 'metron.util.Companion.easingEffect' call
      var tmp1_easingEffect = Companion_getInstance_32();
      var tmp2_easingEffect = Companion_getInstance_4().v4e();
      var tmp$ret$2;
      // Inline function 'kotlin.arrayOf' call
      var tmp0_arrayOf = [Companion_getInstance_32().kfb(1.0, true), Companion_getInstance_32().nfd(100.0 * _TimeSpan___get_seconds__impl__cx2k1c($countdownEffectPeriod))];
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_arrayOf;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var tmp3_easingEffect = tmp$ret$2;
      var tmp4_easingEffect = countdown$lambda$lambda$lambda$lambda;
      var tmp5_easingEffect = countdown$lambda$lambda$lambda$lambda_0;
      (new EasingEffect(tmp2_easingEffect, tmp3_easingEffect, tmp4_easingEffect, $countdownEffectPeriod, $this$easingEffect, tmp5_easingEffect)).tfb();
      tmp$ret$3 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function countdown$lambda$lambda$lambda_1(it) {
    return it;
  }
  function countdown$lambda$lambda($countdownEffectPeriod) {
    return function ($this$createTitle) {
      transform($this$createTitle, countdown$lambda$lambda$lambda);
      var tmp$ret$3;
      // Inline function 'metron.util.Companion.easingEffect' call
      var tmp1_easingEffect = Companion_getInstance_32();
      var tmp2_easingEffect = Companion_getInstance_4().u4e();
      var tmp$ret$2;
      // Inline function 'kotlin.arrayOf' call
      var tmp0_arrayOf = [Companion_getInstance_32().vfb(1.0), Companion_getInstance_32().nfd(100.0 * _TimeSpan___get_seconds__impl__cx2k1c($countdownEffectPeriod))];
      var tmp$ret$1;
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp$ret$0;
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$0 = tmp0_arrayOf;
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp$ret$1;
      var tmp3_easingEffect = tmp$ret$2;
      var tmp4_easingEffect = countdown$lambda$lambda$lambda_0($countdownEffectPeriod);
      var tmp5_easingEffect = countdown$lambda$lambda$lambda_1;
      (new EasingEffect(tmp2_easingEffect, tmp3_easingEffect, tmp4_easingEffect, $countdownEffectPeriod, $this$createTitle, tmp5_easingEffect)).tfb();
      tmp$ret$3 = Unit_getInstance();
      return Unit_getInstance();
    };
  }
  function countdown$lambda_6($element, $times, $this_countdown, $countdownEffectPeriod) {
    return function () {
      launchNow(VOID, countdown$lambda$slambda_0($this_countdown, null));
      var isStart = $element === $times;
      var tmp = isStart ? '\uC2DC\uC791!' : ' ' + ($times - $element | 0) + ' ';
      createTitle($this_countdown, tmp, 45, countdown$lambda$lambda($countdownEffectPeriod));
      return Unit_getInstance();
    };
  }
  function countdown$lambda_7($tmp2_also, $tmp1_apply) {
    return function (it) {
      $tmp2_also.jw();
      $tmp1_apply.xbu();
      return Unit_getInstance();
    };
  }
  function enableIntro$hideTitle$lambda($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function enableIntro$hideTitle$lambda_0(it) {
    return it;
  }
  function enableMapEditor(_this__u8e3s4, $completion) {
    _this__u8e3s4.nf9_1 = true;
    var tmp = _this__u8e3s4;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.tf9_1 = ArrayList_init_$Create$().g();
    var tmp_0 = get_screen();
    var tmp_1 = Companion_getInstance_25();
    tmp_0.h6p(tmp_1, enableMapEditor$lambda(_this__u8e3s4));
    var tmp$ret$1;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$1 = Companion_getInstance().p12(0.0);
    var before = {_v: new TimeSpan(tmp$ret$1)};
    // Inline function 'kotlin.collections.mutableListOf' call
    var map = ArrayList_init_$Create$();
    var tmp_2 = get_screen();
    var tmp_3 = Companion_getInstance_28();
    tmp_2.h6p(tmp_3, enableMapEditor$lambda_0(_this__u8e3s4, before, map));
    var tmp_4 = get_screen();
    var tmp_5 = Companion_getInstance_24();
    tmp_4.h6p(tmp_5, enableMapEditor$lambda_1(_this__u8e3s4, map));
    return Unit_getInstance();
  }
  function roundRange(value) {
    var range = 0.25;
    var tmp = 0;
    var tmp_0 = numberToInt(1.0 / range) + 1 | 0;
    var tmp_1 = new Float64Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = tmp_2 * range;
      tmp = tmp + 1 | 0;
    }
    var allowedValues = toMutableList(tmp_1);
    var halfRange = range / 2.0;
    var decimal = value % 1.0;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var tmp0_iterator = allowedValues.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'metron.app.handlers.roundRange.<anonymous>' call
        if (element - halfRange <= decimal ? decimal <= element + halfRange : false) {
          tmp$ret$2 = element;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
    }
    var rounded = tmp$ret$2;
    return toIntFloor(value) + rounded;
  }
  function enableMapEditor$lambda($this_enableMapEditor) {
    return function (it) {
      $this_enableMapEditor.nf9_1 = true;
      var tmp = $this_enableMapEditor;
      var tmp$ret$0;
      // Inline function 'kotlin.collections.mutableListOf' call
      tmp$ret$0 = ArrayList_init_$Create$();
      tmp.tf9_1 = tmp$ret$0.g();
      return Unit_getInstance();
    };
  }
  function enableMapEditor$lambda_0($this_enableMapEditor, $before, $map) {
    return function (it) {
      var tmp;
      var tmp_0 = $this_enableMapEditor.qf9_1;
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.0);
      if (TimeSpan__compareTo_impl_zidry4(tmp_0, tmp$ret$0) < 0) {
        return Unit_getInstance();
      }
      var currentNote = _TimeSpan___get_seconds__impl__cx2k1c(TimeSpan__div_impl_l42f2r_1(TimeSpan__plus_impl_qdd6zo($this_enableMapEditor.qf9_1, it.gfd_1), $this_enableMapEditor.vf7()));
      var previousNote = _TimeSpan___get_seconds__impl__cx2k1c(TimeSpan__div_impl_l42f2r_1($before._v.m12_1, $this_enableMapEditor.vf7()));
      var distance = currentNote - previousNote;
      var tmp$ret$1;
      // Inline function 'korlibs.time.seconds' call
      var tmp0_get_seconds_3mcf5u = roundRange(currentNote);
      tmp$ret$1 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
      var tmp_1 = $this_enableMapEditor.kfa(TimeSpan__times_impl_86ofia(tmp$ret$1, $this_enableMapEditor.vf7()));
      var tmp$ret$2;
      // Inline function 'korlibs.time.seconds' call
      var tmp1_get_seconds_18c81p = $this_enableMapEditor.vf7();
      tmp$ret$2 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
      var tmp_2 = tmp$ret$2;
      var tmp$ret$3;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$3 = Companion_getInstance().p12(1.0);
      createGhostNote($this_enableMapEditor, tmp_1, tmp_2, tmp$ret$3);
      var note = roundRange(distance);
      $before._v = new TimeSpan($this_enableMapEditor.qf9_1);
      var tmp_3;
      if (!(note === 0.0)) {
        $map.b(note);
        tmp_3 = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableMapEditor$lambda$slambda($mapData, resultContinuation) {
    this.pfg_1 = $mapData;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableMapEditor$lambda$slambda).g1p = function ($completion) {
    var tmp = this.v1l($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableMapEditor$lambda$slambda).qj = function ($completion) {
    return this.g1p($completion);
  };
  protoOf(enableMapEditor$lambda$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 3;
            if (Companion_getInstance_8().i1g()) {
              this.xi_1 = 2;
              continue $sm;
            } else {
              this.xi_1 = 1;
              suspendResult = get_rootLocalVfs().b18(DateTime__format_impl_6el5l1(Companion_getInstance_5().yy(), Companion_getInstance_7().fy_1) + '.json').i27(this.pfg_1, [], VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            this.xi_1 = 2;
            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 3) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(enableMapEditor$lambda$slambda).v1l = function (completion) {
    return new enableMapEditor$lambda$slambda(this.pfg_1, completion);
  };
  function enableMapEditor$lambda$slambda_0($mapData, resultContinuation) {
    var i = new enableMapEditor$lambda$slambda($mapData, resultContinuation);
    var l = function ($completion) {
      return i.g1p($completion);
    };
    l.$arity = 0;
    return l;
  }
  function enableMapEditor$lambda_1($this_enableMapEditor, $map) {
    return function (it) {
      var tmp$ret$2;
      // Inline function 'kotlinx.serialization.encodeToString' call
      var tmp0_encodeToString = Default_getInstance();
      var tmp1_encodeToString = $this_enableMapEditor.yf8_1.yf7(VOID, VOID, VOID, VOID, $map);
      var tmp$ret$1;
      // Inline function 'kotlinx.serialization.serializer' call
      var tmp0_serializer = tmp0_encodeToString.ueb();
      var tmp$ret$0;
      // Inline function 'kotlinx.serialization.internal.cast' call
      var tmp0_cast = serializer(tmp0_serializer, createKType(getKClass(Level), arrayOf([]), false));
      tmp$ret$0 = isInterface(tmp0_cast, KSerializer) ? tmp0_cast : THROW_CCE();
      tmp$ret$1 = tmp$ret$0;
      tmp$ret$2 = tmp0_encodeToString.aet(tmp$ret$1, tmp1_encodeToString);
      var mapData = tmp$ret$2;
      launchNow(VOID, enableMapEditor$lambda$slambda_0(mapData, null));
      return Unit_getInstance();
    };
  }
  function enableProgressbar(_this__u8e3s4) {
    // Inline function 'korlibs.korge.view.solidRect' call
    var tmp0_solidRect = get_screen();
    var tmp1_solidRect = Size_init_$Create$();
    var tmp2_solidRect = Colors_getInstance().k4k_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = new SolidRect(tmp1_solidRect, tmp2_solidRect);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var tmp = addTo(tmp0_addTo, tmp0_solidRect);
    var tmp_0 = transform(tmp, enableProgressbar$lambda);
    addUpdater(tmp_0, enableProgressbar$lambda_0(_this__u8e3s4));
  }
  function enableProgressbar$lambda($this$transform) {
    size_0($this$transform, get_screen().n13(), 15.0);
    $this$transform.ubs(0.0);
    positionY($this$transform, get_screen().o13() - 15.0);
    return Unit_getInstance();
  }
  function enableProgressbar$lambda_0($this_enableProgressbar) {
    return function ($this$addUpdater, it) {
      var tmp;
      if ($this_enableProgressbar.of9_1) {
        return Unit_getInstance();
      }
      $this$addUpdater.ubs(TimeSpan__div_impl_l42f2r($this_enableProgressbar.qf9_1, $this_enableProgressbar.wf7()));
      var tmp_0;
      if ($this$addUpdater.vbs() >= 1) {
        get_screen().q6p(new GameEndEvent(true));
        tmp_0 = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableScore(_this__u8e3s4) {
    var score = {_v: 0};
    // Inline function 'korlibs.korge.ui.uiText' call
    var tmp0_uiText = get_screen();
    var tmp1_uiText = Companion_getInstance_6().icb_1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(new UIText('0', tmp1_uiText), tmp0_uiText);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableScore.<anonymous>' call
    // Inline function 'korlibs.korge.style.styles' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = get_styles(tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableScore.<anonymous>.<anonymous>' call
    set_textFont(tmp0_apply_0, _this__u8e3s4.cf9_1);
    set_textColor(tmp0_apply_0, get_globalTextColor());
    set_textSize(tmp0_apply_0, 70.0);
    set_textAlignment(tmp0_apply_0, Companion_getInstance_1().r59_1);
    transform(tmp0_apply, enableScore$lambda);
    var body = tmp0_apply;
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_25();
    tmp.h6p(tmp_0, enableScore$lambda_0(score, body));
    var tmp_1 = get_screen();
    var tmp_2 = Companion_getInstance_23();
    tmp_1.h6p(tmp_2, enableScore$lambda_1(_this__u8e3s4, score, body));
  }
  function enableScore$lambda($this$transform) {
    var padding = 40;
    positionX($this$transform, get_screen().n13() - $this$transform.n13() - padding);
    positionY_0($this$transform, padding);
    return Unit_getInstance();
  }
  function enableScore$lambda_0($score, $body) {
    return function (it) {
      $score._v = 0;
      setText($body, '' + $score._v);
      return Unit_getInstance();
    };
  }
  function enableScore$lambda_1($this_enableScore, $score, $body) {
    return function (event) {
      var tmp18_subject = event.rfc_1;
      var tmp0 = tmp18_subject.t5_1;
      var tmp;
      switch (tmp0) {
        case 0:
          tmp = 0;
          break;
        case 1:
          tmp = 0;
          break;
        case 2:
          tmp = 0;
          break;
        case 3:
          tmp = 0;
          break;
        case 4:
          tmp = 1000000 / $this_enableScore.yf8_1.qf7_1.j() | 0;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      var scoreAdder = tmp;
      var tmp_0;
      if (!(scoreAdder === 0)) {
        $score._v = $score._v + scoreAdder | 0;
        setText($body, '' + $score._v);
        tmp_0 = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu(_this__u8e3s4) {
    // Inline function 'korlibs.korge.ui.uiContainer' call
    var tmp0_uiContainer = get_screen();
    var tmp1_uiContainer = Size_init_$Create$();
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(new UIContainer(tmp1_uiContainer), tmp0_uiContainer);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>' call
    // Inline function 'korlibs.korge.style.styles' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = get_styles(tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>' call
    set_textFont(tmp0_apply_0, _this__u8e3s4.cf9_1);
    set_textColor(tmp0_apply_0, get_globalTextColor());
    set_textAlignment(tmp0_apply_0, Companion_getInstance_1().q59_1);
    position(tmp0_apply, get_screen().n13(), 0.0);
    transform(tmp0_apply, enableSettingsMenu$lambda);
    var panel = tmp0_apply;
    // Inline function 'korlibs.korge.view.solidRect' call
    var tmp0_solidRect = tmp0_apply.j();
    var tmp1_solidRect = Colors_getInstance().p4z('808080');
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = new SolidRect(tmp0_solidRect, tmp1_solidRect);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.solidRect.<anonymous>' call
    var tmp = addTo(tmp0_addTo, tmp0_apply);
    var background = transform(tmp, enableSettingsMenu$lambda_0(panel));
    // Inline function 'korlibs.korge.ui.uiVerticalStack' call
    var tmp2_uiVerticalStack = tmp0_apply.n13();
    var tmp3_uiVerticalStack = get_UI_DEFAULT_PADDING();
    // Inline function 'kotlin.apply' call
    var tmp0_apply_1 = addTo(new UIVerticalStack(tmp2_uiVerticalStack, tmp3_uiVerticalStack, false), tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.korge.ui.uiSpacing' call
    var tmp0_uiSpacing = new Size(0.0, 144.0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.uiSpacing.<anonymous>' call
    addTo(new UISpacing(tmp0_uiSpacing), tmp0_apply_1);
    // Inline function 'korlibs.korge.ui.uiText' call
    var tmp1_uiText = Companion_getInstance_6().icb_1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply_2 = addTo(new UIText('\uC124\uC815', tmp1_uiText), tmp0_apply_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>.<anonymous>' call
    set_textSize(get_styles(tmp0_apply_2), 100.0);
    var tmp_0 = tmp0_apply_2;
    transform(tmp_0, enableSettingsMenu$lambda_1(panel));
    // Inline function 'korlibs.korge.ui.uiSpacing' call
    var tmp2_uiSpacing = new Size(0.0, 250.0);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.uiSpacing.<anonymous>' call
    addTo(new UISpacing(tmp2_uiSpacing), tmp0_apply_1);
    var sliderWidth = 100.0;
    // Inline function 'korlibs.korge.ui.uiContainer' call
    var tmp3_uiContainer = Size_init_$Create$();
    // Inline function 'kotlin.apply' call
    var tmp0_apply_3 = addTo(new UIContainer(tmp3_uiContainer), tmp0_apply_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>.<anonymous>' call
    transform(tmp0_apply_3, enableSettingsMenu$lambda_2(sliderWidth));
    // Inline function 'korlibs.korge.ui.uiText' call
    var tmp0_uiText = enableSettingsMenu$_anonymous_$_anonymous_$_anonymous_$formattedOffset_wm817(_this__u8e3s4);
    var tmp1_uiText_0 = Companion_getInstance_6().icb_1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply_4 = addTo(new UIText(tmp0_uiText, tmp1_uiText_0), tmp0_apply_3);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    set_textSize(get_styles(tmp0_apply_4), 70.0);
    set_textAlignment(get_styles(tmp0_apply_4), Companion_getInstance_1().q59_1);
    var tmp_1 = tmp0_apply_4;
    var text = transform(tmp_1, enableSettingsMenu$lambda_3(tmp0_apply_3));
    var borderSize = 10.0;
    var selectorBorder = new Size(borderSize, borderSize);
    // Inline function 'korlibs.korge.ui.uiContainer' call
    var tmp2_uiContainer = tmp0_apply_3.j().m3x(selectorBorder.o3x(2));
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.ui.uiContainer.<anonymous>' call
    var tmp_2 = addTo(new UIContainer(tmp2_uiContainer), tmp0_apply_3);
    var selector = transform(tmp_2, enableSettingsMenu$lambda_4(tmp0_apply_3, selectorBorder));
    var tmp19_size = tmp0_apply_3.j();
    var tmp20_color = get_textColor(get_styles(tmp0_apply_3));
    var tmp21_corners = _RectCorners___init__impl__w373y9_0(0.5);
    // Inline function 'korlibs.korge.view.fastRoundRect' call
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo_0 = colorMul(new FastRoundRect(tmp19_size, tmp21_corners), tmp20_color);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fastRoundRect.<anonymous>' call
    var tmp_3 = addTo(tmp0_addTo_0, tmp0_apply_3);
    var border = transform(tmp_3, enableSettingsMenu$lambda_5(tmp0_apply_3));
    var tmp22_size = Size_init_$Create$();
    var tmp23_color = background.u5t();
    var tmp24_corners = _RectCorners___init__impl__w373y9_0(0.5);
    // Inline function 'korlibs.korge.view.fastRoundRect' call
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo_1 = colorMul(new FastRoundRect(tmp22_size, tmp24_corners), tmp23_color);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.fastRoundRect.<anonymous>' call
    var tmp_4 = addTo(tmp0_addTo_1, tmp0_apply_3);
    centerOn(transform(tmp_4, enableSettingsMenu$lambda_6(tmp0_apply_3, selectorBorder)), border);
    var maxSlide = 300.0;
    var step = 5.0;
    // Inline function 'korlibs.korge.view.roundRect' call
    var tmp3_roundRect = new Size(sliderWidth * 1.5, sliderWidth);
    var tmp4_roundRect = _RectCorners___init__impl__w373y9_1(sliderWidth - (sliderWidth - borderSize));
    var tmp5_roundRect = get_textColor(get_styles(tmp0_apply_3));
    var tmp6_roundRect = Colors_getInstance().k4k_1;
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo_2 = new RoundRect(tmp3_roundRect, tmp4_roundRect, new RGBA(tmp5_roundRect), new RGBA(tmp6_roundRect), 0.0, true);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.roundRect.<anonymous>' call
    var tmp_5 = addTo(tmp0_addTo_2, tmp0_apply_3);
    var button = transform(tmp_5, enableSettingsMenu$lambda_7(_this__u8e3s4, maxSlide, tmp0_apply_3));
    // Inline function 'korlibs.korge.input.keys' call
    // Inline function 'kotlin.run' call
    var tmp0_run = get_keys(button);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
    var tmp_6 = [Key_LEFT_getInstance(), Key_RIGHT_getInstance()];
    tmp0_run.oap(tmp_6, enableSettingsMenu$slambda_0(_this__u8e3s4, step, button, text, null));
    draggable(button, selector, VOID, enableSettingsMenu$lambda_8(tmp0_apply_3, button, maxSlide, step, _this__u8e3s4, text, border));
    var tmp_7 = tmp0_apply_3;
    transform(tmp_7, enableSettingsMenu$lambda_9(panel));
    var panel_0 = zIndex(tmp0_apply, 50);
    var isOpened = {_v: false};
    var tmp_8 = get_screen();
    var tmp_9 = Companion_getInstance_29();
    tmp_8.h6p(tmp_9, enableSettingsMenu$lambda_10(isOpened, _this__u8e3s4, panel_0));
  }
  function enableSettingsMenu$_anonymous_$_anonymous_$_anonymous_$formattedOffset_wm817($this_enableSettingsMenu) {
    return '<  \uC624\uD504\uC14B: ' + $this_enableSettingsMenu.ff9_1 + '  >';
  }
  function enableSettingsMenu$lambda($this$transform) {
    size($this$transform, new Size(get_screen().n13(), get_screen().o13()));
    return Unit_getInstance();
  }
  function enableSettingsMenu$lambda_0($panel) {
    return function ($this$transform) {
      size($this$transform, $panel.j());
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_1($panel) {
    return function ($this$transform) {
      centerXOn($this$transform, $panel);
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_2($sliderWidth) {
    return function ($this$transform) {
      size($this$transform, new Size(get_screen().n13() / 1.5, $sliderWidth));
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_3($tmp0_apply) {
    return function ($this$transform) {
      positionY_0(centerXOn($this$transform, $tmp0_apply), -70);
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_4($tmp0_apply, $selectorBorder) {
    return function ($this$transform) {
      var tmp = centerOn($this$transform, $tmp0_apply);
      var tmp$ret$0;
      // Inline function 'korlibs.math.geom.Vector2.unaryMinus' call
      var tmp0_unaryMinus = toPoint($selectorBorder);
      tmp$ret$0 = new Vector2(-tmp0_unaryMinus.y3n_1, -tmp0_unaryMinus.z3n_1);
      position_0(tmp, tmp$ret$0);
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_5($tmp0_apply) {
    return function ($this$transform) {
      size($this$transform, $tmp0_apply.j());
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_6($tmp0_apply, $selectorBorder) {
    return function ($this$transform) {
      size($this$transform, $tmp0_apply.j().l3x($selectorBorder.o3x(2)));
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_7($this_enableSettingsMenu, $maxSlide, $tmp0_apply) {
    return function ($this$transform) {
      positionX($this$transform, $this_enableSettingsMenu.ff9_1 / $maxSlide * ($tmp0_apply.n13() - $this$transform.n13()));
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$slambda($this_enableSettingsMenu, $step, $button, $text, resultContinuation) {
    this.yfg_1 = $this_enableSettingsMenu;
    this.zfg_1 = $step;
    this.afh_1 = $button;
    this.bfh_1 = $text;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableSettingsMenu$slambda).pan = function (it, $completion) {
    var tmp = this.qan(it, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableSettingsMenu$slambda).ck = function (p1, $completion) {
    return this.pan(p1 instanceof KeyEvent ? p1 : THROW_CCE(), $completion);
  };
  protoOf(enableSettingsMenu$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          if (!this.yfg_1.mf9_1)
            return Unit_getInstance();
          var tmp_0 = this.yfg_1;
          var tmp_1 = this.yfg_1.ff9_1;
          var tmp0 = this.cfh_1.k6q_1.t5_1;
          tmp_0.ff9_1 = tmp_1 + (tmp0 === 63 ? -numberToInt(this.zfg_1) | 0 : tmp0 === 62 ? numberToInt(this.zfg_1) : 0) | 0;
          this.afh_1.q6p(new ResizedEvent());
          setText(this.bfh_1, enableSettingsMenu$_anonymous_$_anonymous_$_anonymous_$formattedOffset_wm817(this.yfg_1));
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(enableSettingsMenu$slambda).qan = function (it, completion) {
    var i = new enableSettingsMenu$slambda(this.yfg_1, this.zfg_1, this.afh_1, this.bfh_1, completion);
    i.cfh_1 = it;
    return i;
  };
  function enableSettingsMenu$slambda_0($this_enableSettingsMenu, $step, $button, $text, resultContinuation) {
    var i = new enableSettingsMenu$slambda($this_enableSettingsMenu, $step, $button, $text, resultContinuation);
    var l = function (it, $completion) {
      return i.pan(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function enableSettingsMenu$lambda_8($tmp0_apply, $button, $maxSlide, $step, $this_enableSettingsMenu, $text, $border) {
    return function (it) {
      var length = $tmp0_apply.n13() - $button.n13();
      var tmp$ret$5;
      // Inline function 'kotlin.let' call
      var tmp$ret$3;
      // Inline function 'kotlin.let' call
      var tmp0_let = $tmp0_apply.sbu(new Vector2(it.wap_1 + it.qap_1, 0.0)).y3n_1 - $button.n13() / 2;
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$2;
      // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      var tmp$ret$1;
      // Inline function 'kotlin.math.max' call
      var tmp$ret$0;
      // Inline function 'kotlin.math.min' call
      tmp$ret$0 = Math.min(length, tmp0_let);
      var tmp0_max = tmp$ret$0;
      tmp$ret$1 = Math.max(0.0, tmp0_max);
      tmp$ret$2 = tmp$ret$1;
      tmp$ret$3 = tmp$ret$2;
      var tmp1_let = tmp$ret$3;
      // Inline function 'kotlin.contracts.contract' call
      var tmp$ret$4;
      // Inline function 'metron.app.handlers.enableSettingsMenu.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
      tmp$ret$4 = toIntFloor_0(toIntCeil(tmp1_let / length * $maxSlide / $step) * $step);
      tmp$ret$5 = tmp$ret$4;
      var nextX = tmp$ret$5;
      $this_enableSettingsMenu.ff9_1 = nextX;
      setText($text, enableSettingsMenu$_anonymous_$_anonymous_$_anonymous_$formattedOffset_wm817($this_enableSettingsMenu));
      position($button, nextX / $maxSlide * length, $border.d6s());
      return Unit_getInstance();
    };
  }
  function enableSettingsMenu$lambda_9($panel) {
    return function ($this$transform) {
      centerXOn($this$transform, $panel);
      return Unit_getInstance();
    };
  }
  function invoke$effectPosX(receiver, p0) {
    return receiver.dfh(p0);
  }
  function invoke$effectPosX_0(receiver, p0) {
    return receiver.dfh(p0);
  }
  function enableSettingsMenu$lambda$lambda($this$easingEffect) {
    positionX($this$easingEffect, 0.0);
    return Unit_getInstance();
  }
  function enableSettingsMenu$lambda$lambda_0(it) {
    return it;
  }
  function enableSettingsMenu$lambda$lambda_1($this$easingEffect) {
    positionX($this$easingEffect, $this$easingEffect.n13());
    return Unit_getInstance();
  }
  function enableSettingsMenu$lambda$lambda_2(it) {
    return it;
  }
  function enableSettingsMenu$lambda_10($isOpened, $this_enableSettingsMenu, $panel) {
    return function (it) {
      var tmp;
      if ($isOpened._v === $this_enableSettingsMenu.mf9_1) {
        return Unit_getInstance();
      }
      $isOpened._v = $this_enableSettingsMenu.mf9_1;
      var tmp_0;
      if ($this_enableSettingsMenu.mf9_1) {
        var tmp$ret$6;
        // Inline function 'metron.util.Companion.easingEffect' call
        var tmp3_easingEffect = Companion_getInstance_32();
        var tmp$ret$0;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$0 = Companion_getInstance().p12(0.628);
        var tmp4_easingEffect = tmp$ret$0;
        var tmp5_easingEffect = Companion_getInstance_4().p4e();
        var tmp$ret$5;
        // Inline function 'kotlin.arrayOf' call
        var tmp$ret$2;
        // Inline function 'kotlin.run' call
        var tmp0_run = -$panel.n13() + $panel.n13() - $panel.p2v().y3n_1;
        var tmp1_run_receiver = Companion_getInstance_32();
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$1;
        tmp$ret$1 = invoke$effectPosX(tmp1_run_receiver, tmp0_run);
        tmp$ret$2 = tmp$ret$1;
        var tmp2_arrayOf = [tmp$ret$2];
        var tmp$ret$4;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$3;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$3 = tmp2_arrayOf;
        tmp$ret$4 = tmp$ret$3;
        tmp$ret$5 = tmp$ret$4;
        var tmp6_easingEffect = tmp$ret$5;
        var tmp7_easingEffect = enableSettingsMenu$lambda$lambda;
        var tmp8_easingEffect = enableSettingsMenu$lambda$lambda_0;
        (new EasingEffect(tmp5_easingEffect, tmp6_easingEffect, tmp7_easingEffect, tmp4_easingEffect, $panel, tmp8_easingEffect)).tfb();
        tmp$ret$6 = Unit_getInstance();
        tmp_0 = tmp$ret$6;
      } else {
        var tmp$ret$13;
        // Inline function 'metron.util.Companion.easingEffect' call
        var tmp12_easingEffect = Companion_getInstance_32();
        var tmp$ret$7;
        // Inline function 'korlibs.time.seconds' call
        tmp$ret$7 = Companion_getInstance().p12(0.628);
        var tmp13_easingEffect = tmp$ret$7;
        var tmp14_easingEffect = Companion_getInstance_4().p4e();
        var tmp$ret$12;
        // Inline function 'kotlin.arrayOf' call
        var tmp$ret$9;
        // Inline function 'kotlin.run' call
        var tmp9_run = $panel.n13() + $panel.p2v().y3n_1;
        var tmp10_run_receiver = Companion_getInstance_32();
        // Inline function 'kotlin.contracts.contract' call
        var tmp$ret$8;
        tmp$ret$8 = invoke$effectPosX_0(tmp10_run_receiver, tmp9_run);
        tmp$ret$9 = tmp$ret$8;
        var tmp11_arrayOf = [tmp$ret$9];
        var tmp$ret$11;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$10;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$10 = tmp11_arrayOf;
        tmp$ret$11 = tmp$ret$10;
        tmp$ret$12 = tmp$ret$11;
        var tmp15_easingEffect = tmp$ret$12;
        var tmp16_easingEffect = enableSettingsMenu$lambda$lambda_1;
        var tmp17_easingEffect = enableSettingsMenu$lambda$lambda_2;
        (new EasingEffect(tmp14_easingEffect, tmp15_easingEffect, tmp16_easingEffect, tmp13_easingEffect, $panel, tmp17_easingEffect)).tfb();
        tmp$ret$13 = Unit_getInstance();
        tmp_0 = tmp$ret$13;
      }
      return Unit_getInstance();
    };
  }
  function enableSongTitle(_this__u8e3s4) {
    // Inline function 'korlibs.korge.ui.uiText' call
    var tmp0_uiText = get_screen();
    var tmp1_uiText = _this__u8e3s4.yf8_1.nf7_1 + ' - ' + _this__u8e3s4.yf8_1.mf7_1;
    var tmp2_uiText = Companion_getInstance_6().icb_1;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(new UIText(tmp1_uiText, tmp2_uiText), tmp0_uiText);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSongTitle.<anonymous>' call
    // Inline function 'korlibs.korge.style.styles' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = get_styles(tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.enableSongTitle.<anonymous>.<anonymous>' call
    set_textFont(tmp0_apply_0, _this__u8e3s4.cf9_1);
    set_textColor(tmp0_apply_0, get_globalTextColor());
    set_textSize(tmp0_apply_0, 40.0);
    set_textAlignment(tmp0_apply_0, Companion_getInstance_1().p59_1);
    transform(tmp0_apply, enableSongTitle$lambda);
  }
  function enableSongTitle$lambda($this$transform) {
    var padding = 20;
    positionY($this$transform, $this$transform.o13() + padding);
    positionX_0($this$transform, padding);
    return Unit_getInstance();
  }
  function get_stickArea() {
    return 0.65;
  }
  function get_stickHeight() {
    return get_screen().o13() * get_stickArea();
  }
  function get_stickWidth() {
    return get_stickArea() * 30.0;
  }
  function get_stickSize() {
    return new Size(get_stickWidth(), get_stickHeight());
  }
  function get_stickY() {
    return (get_screen().o13() * 2 + get_stickHeight()) / 3.0 - (get_stickHeight() - Companion_getInstance_22().gfc());
  }
  function configureAnchor(container) {
    return transform(container, configureAnchor$lambda);
  }
  function configurePositionAndAnchor(container) {
    return transform(container, configurePositionAndAnchor$lambda);
  }
  function configurePosition(container) {
    return transform(container, configurePosition$lambda);
  }
  function configureAnchor$lambda($this$transform) {
    if (isInterface($this$transform, Anchorable)) {
      anchor_0($this$transform, 0.5, 1 - $this$transform.n13() / 2 / $this$transform.o13());
    }
    return Unit_getInstance();
  }
  function configurePositionAndAnchor$lambda($this$transform) {
    configureAnchor($this$transform);
    configurePosition($this$transform);
    return Unit_getInstance();
  }
  function configurePosition$lambda($this$transform) {
    centerXOn($this$transform, get_screen());
    positionY($this$transform, get_stickY());
    return Unit_getInstance();
  }
  function get_globalTextColor() {
    _init_properties_Text_kt__l2j80d();
    return globalTextColor;
  }
  var globalTextColor;
  function get_titlePosY() {
    _init_properties_Text_kt__l2j80d();
    return get_screen().o13() / -2.3;
  }
  function createTitle(_this__u8e3s4, text, fontSize, configuration) {
    fontSize = fontSize === VOID ? 41 : fontSize;
    var tmp;
    if (configuration === VOID) {
      tmp = createTitle$lambda;
    } else {
      tmp = configuration;
    }
    configuration = tmp;
    _init_properties_Text_kt__l2j80d();
    // Inline function 'korlibs.korge.ui.uiText' call
    var tmp0_uiText = get_screen();
    var tmp1_uiText = get_screen().j();
    // Inline function 'kotlin.apply' call
    var tmp0_apply = addTo(new UIText(text, tmp1_uiText), tmp0_uiText);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.createTitle.<anonymous>' call
    // Inline function 'korlibs.korge.style.styles' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply_0 = get_styles(tmp0_apply);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'metron.app.handlers.createTitle.<anonymous>.<anonymous>' call
    set_textFont(tmp0_apply_0, _this__u8e3s4.bf9_1);
    set_textAlignment(tmp0_apply_0, Companion_getInstance_1().q59_1);
    set_textColor(tmp0_apply_0, get_globalTextColor());
    transform(tmp0_apply, createTitle$lambda_0(fontSize));
    configuration(tmp0_apply);
    return tmp0_apply;
  }
  function createTitle$lambda(_this__u8e3s4) {
    _init_properties_Text_kt__l2j80d();
    return Unit_getInstance();
  }
  function createTitle$lambda_0($fontSize) {
    return function ($this$transform) {
      size($this$transform, get_screen().j());
      set_textSize(get_styles($this$transform), $fontSize * (get_screen().o13() / get_scene().o13()));
      var tmp26_safe_receiver = getExtra($this$transform, Companion_getInstance_32().ifb_1);
      var tmp;
      if (tmp26_safe_receiver == null) {
        tmp = null;
      } else {
        var tmp$ret$2;
        // Inline function 'korlibs.datastructure.fastCastTo' call
        var tmp$ret$1;
        // Inline function 'kotlin.js.unsafeCast' call
        var tmp$ret$0;
        // Inline function 'kotlin.js.asDynamic' call
        tmp$ret$0 = tmp26_safe_receiver;
        tmp$ret$1 = tmp$ret$0;
        tmp$ret$2 = tmp$ret$1;
        tmp = tmp$ret$2;
      }
      var tmp27_safe_receiver = tmp;
      var _elvis__6sfipt = tmp27_safe_receiver == null ? null : tmp27_safe_receiver * get_screen().o13();
      positionY($this$transform, _elvis__6sfipt == null ? get_titlePosY() : _elvis__6sfipt);
      return Unit_getInstance();
    };
  }
  var properties_initialized_Text_kt_kgdrtb;
  function _init_properties_Text_kt__l2j80d() {
    if (!properties_initialized_Text_kt_kgdrtb) {
      properties_initialized_Text_kt_kgdrtb = true;
      globalTextColor = Colors_getInstance().p4z('DDE6ED');
    }
  }
  function enableMusic(_this__u8e3s4, $completion) {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'kotlin.math.max' call
    var tmp0_max = _this__u8e3s4.cfa() * -1;
    var tmp1_get_seconds_18c81p = Math.max(0.0, tmp0_max);
    var offset = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
    var tmp = get_screen();
    var tmp_0 = Companion_getInstance_25();
    tmp.h6p(tmp_0, enableMusic$lambda(offset, _this__u8e3s4));
    var tmp_1 = get_screen();
    var tmp_2 = Companion_getInstance_24();
    tmp_1.h6p(tmp_2, enableMusic$lambda_0(_this__u8e3s4));
    return Unit_getInstance();
  }
  function enableMusic$lambda$lambda$slambda($this_enableMusic, resultContinuation) {
    this.mfh_1 = $this_enableMusic;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(enableMusic$lambda$lambda$slambda).g1p = function ($completion) {
    var tmp = this.v1l($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(enableMusic$lambda$lambda$slambda).qj = function ($completion) {
    return this.g1p($completion);
  };
  protoOf(enableMusic$lambda$lambda$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.xi_1 = 1;
            suspendResult = this.mfh_1.zf8_1.l9k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_apply = suspendResult;
            tmp0_apply.l9g(0.55);
            var ARGUMENT = tmp0_apply;
            this.mfh_1.hf9_1 = ARGUMENT;
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(enableMusic$lambda$lambda$slambda).v1l = function (completion) {
    return new enableMusic$lambda$lambda$slambda(this.mfh_1, completion);
  };
  function enableMusic$lambda$lambda$slambda_0($this_enableMusic, resultContinuation) {
    var i = new enableMusic$lambda$lambda$slambda($this_enableMusic, resultContinuation);
    var l = function ($completion) {
      return i.g1p($completion);
    };
    l.$arity = 0;
    return l;
  }
  function enableMusic$lambda$lambda($this_enableMusic) {
    return function () {
      launchNow(VOID, enableMusic$lambda$lambda$slambda_0($this_enableMusic, null));
      return Unit_getInstance();
    };
  }
  function enableMusic$lambda$lambda_0($tmp0_also, $tmp0_apply) {
    return function (it) {
      $tmp0_also.jw();
      $tmp0_apply.xbu();
      return Unit_getInstance();
    };
  }
  function enableMusic$lambda($offset, $this_enableMusic) {
    return function (it) {
      var tmp$ret$1;
      // Inline function 'kotlin.also' call
      var tmp = get_timers(get_screen());
      var tmp0_also = tmp.ebx($offset, enableMusic$lambda$lambda($this_enableMusic));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.handlers.enableMusic.<anonymous>.<anonymous>' call
      var tmp$ret$0;
      // Inline function 'kotlin.apply' call
      var tmp0_apply = dummyView(get_screen());
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.app.handlers.enableMusic.<anonymous>.<anonymous>.<anonymous>' call
      var tmp_0 = Companion_getInstance_29();
      tmp0_apply.h6p(tmp_0, enableMusic$lambda$lambda_0(tmp0_also, tmp0_apply));
      tmp$ret$0 = tmp0_apply;
      tmp$ret$1 = tmp0_also;
      return Unit_getInstance();
    };
  }
  function enableMusic$lambda_0($this_enableMusic) {
    return function (it) {
      var tmp28_safe_receiver = $this_enableMusic.hf9_1;
      if (tmp28_safe_receiver == null)
        null;
      else {
        tmp28_safe_receiver.r9g();
      }
      return Unit_getInstance();
    };
  }
  function mainView($completion) {
    var tmp = new $mainViewCOROUTINE$3($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  }
  function mainView$lambda($this$Stage, stage) {
    $this$Stage.wf6(mainView$lambda$lambda);
    $this$Stage.xf6(mainView$lambda$lambda_0(stage));
    return Unit_getInstance();
  }
  function mainView$lambda$lambda($this$components) {
    // Inline function 'metron.util.add' call
    var tmp0_add = [Companion_getInstance_20()];
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < tmp0_add.length) {
      // Inline function 'metron.util.add.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp0_anonymous = tmp0_add[tmp0];
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onAdd' call
      var tmp0_onAdd = tmp0_anonymous.afb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentAddHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder = $this$components.af7_1.xf3_1;
      if (tmp0_holder.gf3_1.if2(tmp0_anonymous.ef3_1)) {
        var _elvis__6sfipt = getKClass(GhostStick).ue();
        var name = _elvis__6sfipt == null ? tmp0_holder.if3(getKClass(GhostStick)) : _elvis__6sfipt;
        var tmp = tmp0_holder.hf3();
        var tmp_0 = 0;
        var tmp_1 = tmp0_holder.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_2 = fillArrayVal(Array(tmp_1), null);
        while (tmp_0 < tmp_1) {
          tmp_2[tmp_0] = null;
          tmp_0 = tmp_0 + 1 | 0;
        }
        tmp0_holder.gf3_1.hf2(tmp0_anonymous.ef3_1, new ComponentsHolder(tmp, name, tmp_2));
      }
      var tmp_3 = tmp0_holder.gf3_1.k(tmp0_anonymous.ef3_1);
      var holder = tmp_3 instanceof ComponentsHolder ? tmp_3 : THROW_CCE();
      if (!(holder.nf3_1 == null))
        throw new FleksHookAlreadyAddedException('addHook', 'Component ' + getKClassFromExpression(tmp0_anonymous).ue());
      holder.nf3_1 = tmp0_onAdd;
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onRemove' call
      var tmp1_onRemove = tmp0_anonymous.bfb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentRemoveHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_0 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_0.gf3_1.if2(tmp0_anonymous.ef3_1)) {
        var _elvis__6sfipt_0 = getKClass(GhostStick).ue();
        var name_0 = _elvis__6sfipt_0 == null ? tmp0_holder_0.if3(getKClass(GhostStick)) : _elvis__6sfipt_0;
        var tmp_4 = tmp0_holder_0.hf3();
        var tmp_5 = 0;
        var tmp_6 = tmp0_holder_0.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_7 = fillArrayVal(Array(tmp_6), null);
        while (tmp_5 < tmp_6) {
          tmp_7[tmp_5] = null;
          tmp_5 = tmp_5 + 1 | 0;
        }
        tmp0_holder_0.gf3_1.hf2(tmp0_anonymous.ef3_1, new ComponentsHolder(tmp_4, name_0, tmp_7));
      }
      var tmp_8 = tmp0_holder_0.gf3_1.k(tmp0_anonymous.ef3_1);
      var holder_0 = tmp_8 instanceof ComponentsHolder ? tmp_8 : THROW_CCE();
      if (!(holder_0.of3_1 == null))
        throw new FleksHookAlreadyAddedException('removeHook', 'Component ' + getKClassFromExpression(tmp0_anonymous).ue());
      holder_0.of3_1 = tmp1_onRemove;
    }
    // Inline function 'metron.util.add' call
    var tmp1_add = [Companion_getInstance_21()];
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_0 = 0;
    while (n_0 < tmp1_add.length) {
      // Inline function 'metron.util.add.<anonymous>' call
      var tmp0_0 = n_0;
      n_0 = tmp0_0 + 1 | 0;
      var tmp0_anonymous_0 = tmp1_add[tmp0_0];
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onAdd' call
      var tmp0_onAdd_0 = tmp0_anonymous_0.afb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentAddHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_1 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_1.gf3_1.if2(tmp0_anonymous_0.ef3_1)) {
        var _elvis__6sfipt_1 = getKClass(GhostStickSpawner).ue();
        var name_1 = _elvis__6sfipt_1 == null ? tmp0_holder_1.if3(getKClass(GhostStickSpawner)) : _elvis__6sfipt_1;
        var tmp_9 = tmp0_holder_1.hf3();
        var tmp_10 = 0;
        var tmp_11 = tmp0_holder_1.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_12 = fillArrayVal(Array(tmp_11), null);
        while (tmp_10 < tmp_11) {
          tmp_12[tmp_10] = null;
          tmp_10 = tmp_10 + 1 | 0;
        }
        tmp0_holder_1.gf3_1.hf2(tmp0_anonymous_0.ef3_1, new ComponentsHolder(tmp_9, name_1, tmp_12));
      }
      var tmp_13 = tmp0_holder_1.gf3_1.k(tmp0_anonymous_0.ef3_1);
      var holder_1 = tmp_13 instanceof ComponentsHolder ? tmp_13 : THROW_CCE();
      if (!(holder_1.nf3_1 == null))
        throw new FleksHookAlreadyAddedException('addHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_0).ue());
      holder_1.nf3_1 = tmp0_onAdd_0;
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onRemove' call
      var tmp1_onRemove_0 = tmp0_anonymous_0.bfb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentRemoveHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_2 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_2.gf3_1.if2(tmp0_anonymous_0.ef3_1)) {
        var _elvis__6sfipt_2 = getKClass(GhostStickSpawner).ue();
        var name_2 = _elvis__6sfipt_2 == null ? tmp0_holder_2.if3(getKClass(GhostStickSpawner)) : _elvis__6sfipt_2;
        var tmp_14 = tmp0_holder_2.hf3();
        var tmp_15 = 0;
        var tmp_16 = tmp0_holder_2.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_17 = fillArrayVal(Array(tmp_16), null);
        while (tmp_15 < tmp_16) {
          tmp_17[tmp_15] = null;
          tmp_15 = tmp_15 + 1 | 0;
        }
        tmp0_holder_2.gf3_1.hf2(tmp0_anonymous_0.ef3_1, new ComponentsHolder(tmp_14, name_2, tmp_17));
      }
      var tmp_18 = tmp0_holder_2.gf3_1.k(tmp0_anonymous_0.ef3_1);
      var holder_2 = tmp_18 instanceof ComponentsHolder ? tmp_18 : THROW_CCE();
      if (!(holder_2.of3_1 == null))
        throw new FleksHookAlreadyAddedException('removeHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_0).ue());
      holder_2.of3_1 = tmp1_onRemove_0;
    }
    // Inline function 'metron.util.add' call
    var tmp2_add = [Companion_getInstance_22()];
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_1 = 0;
    while (n_1 < tmp2_add.length) {
      // Inline function 'metron.util.add.<anonymous>' call
      var tmp0_1 = n_1;
      n_1 = tmp0_1 + 1 | 0;
      var tmp0_anonymous_1 = tmp2_add[tmp0_1];
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onAdd' call
      var tmp0_onAdd_1 = tmp0_anonymous_1.afb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentAddHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_3 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_3.gf3_1.if2(tmp0_anonymous_1.ef3_1)) {
        var _elvis__6sfipt_3 = getKClass(PlayerStick).ue();
        var name_3 = _elvis__6sfipt_3 == null ? tmp0_holder_3.if3(getKClass(PlayerStick)) : _elvis__6sfipt_3;
        var tmp_19 = tmp0_holder_3.hf3();
        var tmp_20 = 0;
        var tmp_21 = tmp0_holder_3.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_22 = fillArrayVal(Array(tmp_21), null);
        while (tmp_20 < tmp_21) {
          tmp_22[tmp_20] = null;
          tmp_20 = tmp_20 + 1 | 0;
        }
        tmp0_holder_3.gf3_1.hf2(tmp0_anonymous_1.ef3_1, new ComponentsHolder(tmp_19, name_3, tmp_22));
      }
      var tmp_23 = tmp0_holder_3.gf3_1.k(tmp0_anonymous_1.ef3_1);
      var holder_3 = tmp_23 instanceof ComponentsHolder ? tmp_23 : THROW_CCE();
      if (!(holder_3.nf3_1 == null))
        throw new FleksHookAlreadyAddedException('addHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_1).ue());
      holder_3.nf3_1 = tmp0_onAdd_1;
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onRemove' call
      var tmp1_onRemove_1 = tmp0_anonymous_1.bfb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentRemoveHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_4 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_4.gf3_1.if2(tmp0_anonymous_1.ef3_1)) {
        var _elvis__6sfipt_4 = getKClass(PlayerStick).ue();
        var name_4 = _elvis__6sfipt_4 == null ? tmp0_holder_4.if3(getKClass(PlayerStick)) : _elvis__6sfipt_4;
        var tmp_24 = tmp0_holder_4.hf3();
        var tmp_25 = 0;
        var tmp_26 = tmp0_holder_4.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_27 = fillArrayVal(Array(tmp_26), null);
        while (tmp_25 < tmp_26) {
          tmp_27[tmp_25] = null;
          tmp_25 = tmp_25 + 1 | 0;
        }
        tmp0_holder_4.gf3_1.hf2(tmp0_anonymous_1.ef3_1, new ComponentsHolder(tmp_24, name_4, tmp_27));
      }
      var tmp_28 = tmp0_holder_4.gf3_1.k(tmp0_anonymous_1.ef3_1);
      var holder_4 = tmp_28 instanceof ComponentsHolder ? tmp_28 : THROW_CCE();
      if (!(holder_4.of3_1 == null))
        throw new FleksHookAlreadyAddedException('removeHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_1).ue());
      holder_4.of3_1 = tmp1_onRemove_1;
    }
    // Inline function 'metron.util.add' call
    var tmp3_add = [Companion_getInstance_18()];
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_2 = 0;
    while (n_2 < tmp3_add.length) {
      // Inline function 'metron.util.add.<anonymous>' call
      var tmp0_2 = n_2;
      n_2 = tmp0_2 + 1 | 0;
      var tmp0_anonymous_2 = tmp3_add[tmp0_2];
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onAdd' call
      var tmp0_onAdd_2 = tmp0_anonymous_2.afb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentAddHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_5 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_5.gf3_1.if2(tmp0_anonymous_2.ef3_1)) {
        var _elvis__6sfipt_5 = getKClass(Audit).ue();
        var name_5 = _elvis__6sfipt_5 == null ? tmp0_holder_5.if3(getKClass(Audit)) : _elvis__6sfipt_5;
        var tmp_29 = tmp0_holder_5.hf3();
        var tmp_30 = 0;
        var tmp_31 = tmp0_holder_5.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_32 = fillArrayVal(Array(tmp_31), null);
        while (tmp_30 < tmp_31) {
          tmp_32[tmp_30] = null;
          tmp_30 = tmp_30 + 1 | 0;
        }
        tmp0_holder_5.gf3_1.hf2(tmp0_anonymous_2.ef3_1, new ComponentsHolder(tmp_29, name_5, tmp_32));
      }
      var tmp_33 = tmp0_holder_5.gf3_1.k(tmp0_anonymous_2.ef3_1);
      var holder_5 = tmp_33 instanceof ComponentsHolder ? tmp_33 : THROW_CCE();
      if (!(holder_5.nf3_1 == null))
        throw new FleksHookAlreadyAddedException('addHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_2).ue());
      holder_5.nf3_1 = tmp0_onAdd_2;
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onRemove' call
      var tmp1_onRemove_2 = tmp0_anonymous_2.bfb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentRemoveHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_6 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_6.gf3_1.if2(tmp0_anonymous_2.ef3_1)) {
        var _elvis__6sfipt_6 = getKClass(Audit).ue();
        var name_6 = _elvis__6sfipt_6 == null ? tmp0_holder_6.if3(getKClass(Audit)) : _elvis__6sfipt_6;
        var tmp_34 = tmp0_holder_6.hf3();
        var tmp_35 = 0;
        var tmp_36 = tmp0_holder_6.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_37 = fillArrayVal(Array(tmp_36), null);
        while (tmp_35 < tmp_36) {
          tmp_37[tmp_35] = null;
          tmp_35 = tmp_35 + 1 | 0;
        }
        tmp0_holder_6.gf3_1.hf2(tmp0_anonymous_2.ef3_1, new ComponentsHolder(tmp_34, name_6, tmp_37));
      }
      var tmp_38 = tmp0_holder_6.gf3_1.k(tmp0_anonymous_2.ef3_1);
      var holder_6 = tmp_38 instanceof ComponentsHolder ? tmp_38 : THROW_CCE();
      if (!(holder_6.of3_1 == null))
        throw new FleksHookAlreadyAddedException('removeHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_2).ue());
      holder_6.of3_1 = tmp1_onRemove_2;
    }
    // Inline function 'metron.util.add' call
    var tmp4_add = [Companion_getInstance_19()];
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n_3 = 0;
    while (n_3 < tmp4_add.length) {
      // Inline function 'metron.util.add.<anonymous>' call
      var tmp0_3 = n_3;
      n_3 = tmp0_3 + 1 | 0;
      var tmp0_anonymous_3 = tmp4_add[tmp0_3];
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onAdd' call
      var tmp0_onAdd_3 = tmp0_anonymous_3.afb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentAddHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_7 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_7.gf3_1.if2(tmp0_anonymous_3.ef3_1)) {
        var _elvis__6sfipt_7 = getKClass(AuditSpawner).ue();
        var name_7 = _elvis__6sfipt_7 == null ? tmp0_holder_7.if3(getKClass(AuditSpawner)) : _elvis__6sfipt_7;
        var tmp_39 = tmp0_holder_7.hf3();
        var tmp_40 = 0;
        var tmp_41 = tmp0_holder_7.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_42 = fillArrayVal(Array(tmp_41), null);
        while (tmp_40 < tmp_41) {
          tmp_42[tmp_40] = null;
          tmp_40 = tmp_40 + 1 | 0;
        }
        tmp0_holder_7.gf3_1.hf2(tmp0_anonymous_3.ef3_1, new ComponentsHolder(tmp_39, name_7, tmp_42));
      }
      var tmp_43 = tmp0_holder_7.gf3_1.k(tmp0_anonymous_3.ef3_1);
      var holder_7 = tmp_43 instanceof ComponentsHolder ? tmp_43 : THROW_CCE();
      if (!(holder_7.nf3_1 == null))
        throw new FleksHookAlreadyAddedException('addHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_3).ue());
      holder_7.nf3_1 = tmp0_onAdd_3;
      // Inline function 'com.github.quillraven.fleks.ComponentConfiguration.onRemove' call
      var tmp1_onRemove_3 = tmp0_anonymous_3.bfb();
      // Inline function 'com.github.quillraven.fleks.World.setComponentRemoveHook' call
      // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
      var tmp0_holder_8 = $this$components.af7_1.xf3_1;
      if (tmp0_holder_8.gf3_1.if2(tmp0_anonymous_3.ef3_1)) {
        var _elvis__6sfipt_8 = getKClass(AuditSpawner).ue();
        var name_8 = _elvis__6sfipt_8 == null ? tmp0_holder_8.if3(getKClass(AuditSpawner)) : _elvis__6sfipt_8;
        var tmp_44 = tmp0_holder_8.hf3();
        var tmp_45 = 0;
        var tmp_46 = tmp0_holder_8.hf3().gf2();
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_47 = fillArrayVal(Array(tmp_46), null);
        while (tmp_45 < tmp_46) {
          tmp_47[tmp_45] = null;
          tmp_45 = tmp_45 + 1 | 0;
        }
        tmp0_holder_8.gf3_1.hf2(tmp0_anonymous_3.ef3_1, new ComponentsHolder(tmp_44, name_8, tmp_47));
      }
      var tmp_48 = tmp0_holder_8.gf3_1.k(tmp0_anonymous_3.ef3_1);
      var holder_8 = tmp_48 instanceof ComponentsHolder ? tmp_48 : THROW_CCE();
      if (!(holder_8.of3_1 == null))
        throw new FleksHookAlreadyAddedException('removeHook', 'Component ' + getKClassFromExpression(tmp0_anonymous_3).ue());
      holder_8.of3_1 = tmp1_onRemove_3;
    }
    return Unit_getInstance();
  }
  function mainView$lambda$lambda_0($stage) {
    return function ($this$systems) {
      $this$systems.bf7(new GhostSpawnerSystem($stage));
      $this$systems.bf7(new PlayerStickSystem($stage));
      $this$systems.bf7(new AuditSpawnerSystem($stage));
      return Unit_getInstance();
    };
  }
  function $mainViewCOROUTINE$3(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($mainViewCOROUTINE$3).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 3;
            this.xi_1 = 1;
            var tmp_0 = Companion_getInstance_17();
            suspendResult = tmp_0.xf9('level1', mainView$lambda, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.vfh_1 = suspendResult;
            enableHitEffect(this.vfh_1);
            this.xi_1 = 2;
            suspendResult = enableMusic(this.vfh_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            enableIntro(this.vfh_1);
            createGhostSpawner(this.vfh_1);
            createPlayerStick(this.vfh_1);
            enableInput(this.vfh_1);
            enableCombo(this.vfh_1);
            enableProgressbar(this.vfh_1);
            enableScore(this.vfh_1);
            enableSongTitle(this.vfh_1);
            enableDeath(this.vfh_1);
            enableGameFinishing(this.vfh_1);
            enableAutoPlaying(this.vfh_1);
            enableSettingsMenu(this.vfh_1);
            return this.vfh_1;
          case 3:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 3) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlin_Comparator$0(function_0) {
    this.wfh_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).d5 = function (a, b) {
    return this.wfh_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.d5(a, b);
  };
  function AuditSpawnerSystem$Companion$audit$lambda(a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'metron.app.systems.Companion.audit.<anonymous>' call
    var tmp = new DateTime(a.tfa_1);
    var tmp$ret$1;
    // Inline function 'metron.app.systems.Companion.audit.<anonymous>' call
    tmp$ret$1 = new DateTime(b.tfa_1);
    return compareValues(tmp, tmp$ret$1);
  }
  function AuditSpawnerSystem$Companion$audit$slambda($this_audit, resultContinuation) {
    this.ffi_1 = $this_audit;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AuditSpawnerSystem$Companion$audit$slambda).g1p = function ($completion) {
    var tmp = this.v1l($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(AuditSpawnerSystem$Companion$audit$slambda).qj = function ($completion) {
    return this.g1p($completion);
  };
  protoOf(AuditSpawnerSystem$Companion$audit$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.xi_1 = 1;
            suspendResult = this.ffi_1.af9_1.l9k(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(AuditSpawnerSystem$Companion$audit$slambda).v1l = function (completion) {
    return new AuditSpawnerSystem$Companion$audit$slambda(this.ffi_1, completion);
  };
  function AuditSpawnerSystem$Companion$audit$slambda_0($this_audit, resultContinuation) {
    var i = new AuditSpawnerSystem$Companion$audit$slambda($this_audit, resultContinuation);
    var l = function ($completion) {
      return i.g1p($completion);
    };
    l.$arity = 0;
    return l;
  }
  function Companion_13() {
    Companion_instance_13 = this;
    var tmp = this;
    // Inline function 'korlibs.time.milliseconds' call
    tmp.gfe_1 = Companion_getInstance().g10(0.0);
    this.hfe_1 = values();
  }
  protoOf(Companion_13).ife = function (_this__u8e3s4, delta) {
    println(new TimeSpan(this.gfe_1));
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'kotlin.collections.sortedBy' call
    var tmp0_sortedBy = _this__u8e3s4.rf9_1;
    var tmp$ret$0;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp = AuditSpawnerSystem$Companion$audit$lambda;
    tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
    var tmp1_fastForEach = sortedWith(tmp0_sortedBy, tmp$ret$0);
    var n = 0;
    while (n < tmp1_fastForEach.j()) {
      // Inline function 'metron.app.systems.Companion.audit.<anonymous>' call
      var tmp0 = n;
      n = tmp0 + 1 | 0;
      var tmp2_anonymous = tmp1_fastForEach.k(tmp0);
      var sub = TimeSpan__plus_impl_qdd6zo(TimeSpan__div_impl_l42f2r_1(TimeSpan__minus_impl_5w5v8s(TimeSpan__plus_impl_qdd6zo(TimeSpan__plus_impl_qdd6zo(_this__u8e3s4.qf9_1, this.gfe_1), _this__u8e3s4.dfa()), tmp2_anonymous.vfa_1), _this__u8e3s4.vf7()), delta);
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      $l$block: {
        // Inline function 'metron.app.systems.Companion.audit.<anonymous>.<anonymous>' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var tmp0_fastForEach = this.hfe_1;
        var n_0 = 0;
        while (n_0 < tmp0_fastForEach.length) {
          // Inline function 'metron.app.systems.Companion.audit.<anonymous>.<anonymous>.<anonymous>' call
          var tmp0_0 = n_0;
          n_0 = tmp0_0 + 1 | 0;
          var tmp1_anonymous = tmp0_fastForEach[tmp0_0];
          if (tmp1_anonymous.if7_1.d1(_TimeSpan___get_seconds__impl__cx2k1c(sub))) {
            launchNow(VOID, AuditSpawnerSystem$Companion$audit$slambda_0(_this__u8e3s4, null));
            createAudit(_this__u8e3s4, tmp2_anonymous, tmp1_anonymous);
            get_screen().q6p(new AuditEvent(tmp2_anonymous, tmp1_anonymous));
            tmp2_anonymous.wfa_1 = true;
            break $l$block;
          }
        }
      }
    }
  };
  var Companion_instance_13;
  function Companion_getInstance_30() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function AuditSpawnerSystem$_init_$lambda_ttgii7($this$family) {
    $this$family.qf5([Companion_getInstance_19()]);
    return Unit_getInstance();
  }
  function AuditSpawnerSystem(stage) {
    Companion_getInstance_30();
    var tmp = Companion_getInstance_9();
    IteratingSystem.call(this, tmp.of6(AuditSpawnerSystem$_init_$lambda_ttgii7), VOID, VOID, EachFrame_getInstance());
    this.pfi_1 = stage;
  }
  protoOf(AuditSpawnerSystem).bf6 = function (entity) {
    var tmp = this.pfi_1.qf9_1;
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$0 = Companion_getInstance().p12(0.0);
    if (TimeSpan__compareTo_impl_zidry4(tmp, tmp$ret$0) < 0)
      return Unit_getInstance();
    var tmp_0 = Companion_getInstance_30();
    var tmp$ret$1;
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = this.mf6();
    tmp$ret$1 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    tmp_0.ife(this.pfi_1, tmp$ret$1);
  };
  function GhostSpawnerSystem$_init_$lambda_p2t6vx($this$family) {
    $this$family.qf5([Companion_getInstance_21()]);
    return Unit_getInstance();
  }
  function GhostSpawnerSystem(stage) {
    var tmp = Companion_getInstance_9();
    IteratingSystem.call(this, tmp.of6(GhostSpawnerSystem$_init_$lambda_p2t6vx));
    this.zfi_1 = stage;
  }
  protoOf(GhostSpawnerSystem).bf6 = function (entity) {
    // Inline function 'kotlin.run' call
    var tmp0_run = this.zfi_1;
    // Inline function 'kotlin.contracts.contract' call
    if (tmp0_run.ffa() ? true : tmp0_run.of9_1)
      return Unit_getInstance();
    if (!tmp0_run.tf9_1.h())
      return Unit_getInstance();
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    var tmp0_get_seconds_3mcf5u = tmp0_run.vf9_1;
    tmp$ret$0 = Companion_getInstance().p12(tmp0_get_seconds_3mcf5u);
    var nextSec = TimeSpan__times_impl_86ofia(tmp$ret$0, tmp0_run.vf7());
    var tmp$ret$1;
    // Inline function 'korlibs.time.seconds' call
    var tmp1_get_seconds_18c81p = tmp0_run.uf9_1;
    tmp$ret$1 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
    var prevSec = TimeSpan__times_impl_86ofia(tmp$ret$1, tmp0_run.vf7());
    var tmp = tmp0_run.qf9_1;
    var tmp$ret$2;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$2 = Companion_getInstance().p12(0.0);
    if (TimeSpan__compareTo_impl_zidry4(tmp, tmp$ret$2) <= 0)
      return Unit_getInstance();
    var distance = TimeSpan__minus_impl_5w5v8s(nextSec, prevSec);
    var lifeTime = TimeSpan__div_impl_l42f2r_1(distance, tmp0_run.vf7());
    var tmp_0;
    if (TimeSpan__compareTo_impl_zidry4(tmp0_run.qf9_1, TimeSpan__minus_impl_5w5v8s(nextSec, distance)) >= 0) {
      var angle = tmp0_run.kfa(nextSec);
      var ghost = createGhostNote(tmp0_run, angle, lifeTime, nextSec);
      tmp0_run.rf9_1.b(ghost);
      get_screen().q6p(new GhostSpawnEvent(ghost));
      tmp0_run.uf9_1 = tmp0_run.vf9_1;
      tmp0_run.vf9_1 = tmp0_run.vf9_1 + tmp0_run.tf9_1.i();
      tmp0_run.sf9_1 = tmp0_run.sf9_1 + 1 | 0;
      tmp_0 = Unit_getInstance();
    }
    return tmp_0;
  };
  function PlayerStickSystem$_init_$lambda_ukdi5v($this$family) {
    $this$family.qf5([Companion_getInstance_22()]);
    return Unit_getInstance();
  }
  function PlayerStickSystem(stage) {
    var tmp = Companion_getInstance_9();
    IteratingSystem.call(this, tmp.of6(PlayerStickSystem$_init_$lambda_ukdi5v));
    this.jfj_1 = stage;
  }
  protoOf(PlayerStickSystem).bf6 = function (entity) {
    if (this.jfj_1.ffa())
      return Unit_getInstance();
    // Inline function 'com.github.quillraven.fleks.EntityComponentContext.get' call
    var tmp0_get = Companion_getInstance_22();
    // Inline function 'com.github.quillraven.fleks.ComponentService.holder' call
    var tmp0_holder = this.xf3_1;
    if (tmp0_holder.gf3_1.if2(tmp0_get.ef3_1)) {
      var _elvis__6sfipt = getKClass(PlayerStick).ue();
      var name = _elvis__6sfipt == null ? tmp0_holder.if3(getKClass(PlayerStick)) : _elvis__6sfipt;
      var tmp = tmp0_holder.hf3();
      var tmp_0 = 0;
      var tmp_1 = tmp0_holder.hf3().gf2();
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_2 = fillArrayVal(Array(tmp_1), null);
      while (tmp_0 < tmp_1) {
        tmp_2[tmp_0] = null;
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp0_holder.gf3_1.hf2(tmp0_get.ef3_1, new ComponentsHolder(tmp, name, tmp_2));
    }
    var tmp_3 = tmp0_holder.gf3_1.k(tmp0_get.ef3_1);
    var tmp_4 = (tmp_3 instanceof ComponentsHolder ? tmp_3 : THROW_CCE()).rf3(entity).nfc();
    var tmp$ret$4;
    // Inline function 'korlibs.time.seconds' call
    var tmp1_get_seconds_18c81p = this.mf6();
    tmp$ret$4 = Companion_getInstance().p12(tmp1_get_seconds_18c81p);
    tmp_4.gbt(this.jfj_1.ifa(tmp$ret$4));
  };
  function Companion_14() {
    Companion_instance_14 = this;
  }
  var Companion_instance_14;
  function Companion_getInstance_31() {
    if (Companion_instance_14 == null)
      new Companion_14();
    return Companion_instance_14;
  }
  function ResizedEvent() {
    Companion_getInstance_31();
    Event.call(this);
  }
  protoOf(ResizedEvent).r6p = function () {
    return Companion_getInstance_31();
  };
  protoOf(ResizedEvent).toString = function () {
    return 'ResizedEvent()';
  };
  function get_defaultStyle() {
    _init_properties_start_kt__ygz7rk();
    // Inline function 'kotlin.getValue' call
    defaultStyle$factory();
    return defaultStyle$delegate.q();
  }
  var defaultStyle$delegate;
  function set_currentUrl(_set____db54di) {
    _init_properties_start_kt__ygz7rk();
    currentUrl = _set____db54di;
  }
  var currentUrl;
  function set_version(_set____db54di) {
    _init_properties_start_kt__ygz7rk();
    version = _set____db54di;
  }
  function get_version() {
    _init_properties_start_kt__ygz7rk();
    var tmp = version;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('version');
    }
  }
  var version;
  function set_scene(_set____db54di) {
    _init_properties_start_kt__ygz7rk();
    scene = _set____db54di;
  }
  function get_scene() {
    _init_properties_start_kt__ygz7rk();
    var tmp = scene;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('scene');
    }
  }
  var scene;
  function set_screen(_set____db54di) {
    _init_properties_start_kt__ygz7rk();
    screen = _set____db54di;
  }
  function get_screen() {
    _init_properties_start_kt__ygz7rk();
    var tmp = screen;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('screen');
    }
  }
  var screen;
  function set_font(_set____db54di) {
    _init_properties_start_kt__ygz7rk();
    font = _set____db54di;
  }
  function get_font() {
    _init_properties_start_kt__ygz7rk();
    var tmp = font;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  var font;
  function set_camera(_set____db54di) {
    _init_properties_start_kt__ygz7rk();
    camera = _set____db54di;
  }
  function get_camera() {
    _init_properties_start_kt__ygz7rk();
    var tmp = camera;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('camera');
    }
  }
  var camera;
  function startMain($completion) {
    var tmp = new $startMainCOROUTINE$4($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  }
  function MainScene$sceneMain$slambda$lambda($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function MainScene$sceneMain$slambda$lambda_0(it) {
    return it;
  }
  function MainScene$sceneMain$slambda$lambda_1($this$easingEffect) {
    $this$easingEffect.xbu();
    return Unit_getInstance();
  }
  function MainScene$sceneMain$slambda$lambda_2(it) {
    return it;
  }
  function MainScene$sceneMain$lambda($this$onStageResized, width, height) {
    size_1(get_screen(), width, height);
    $this$onStageResized.q6p(new ResizedEvent());
    println('Resized!');
    return Unit_getInstance();
  }
  function MainScene$sceneMain$lambda_0($this$transform) {
    var padding = 10;
    positionY($this$transform, get_screen().o13() - $this$transform.o13() - padding);
    positionX_0($this$transform, imul(padding, 2));
    return Unit_getInstance();
  }
  function MainScene$sceneMain$lambda_1($this$transform) {
    size($this$transform, get_screen().j());
    return Unit_getInstance();
  }
  function MainScene$sceneMain$lambda_2($this$transform) {
    size($this$transform, get_screen().j());
    return Unit_getInstance();
  }
  function MainScene$sceneMain$slambda($loading, $curtain, resultContinuation) {
    this.gfk_1 = $loading;
    this.hfk_1 = $curtain;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(MainScene$sceneMain$slambda).g1p = function ($completion) {
    var tmp = this.v1l($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(MainScene$sceneMain$slambda).qj = function ($completion) {
    return this.g1p($completion);
  };
  protoOf(MainScene$sceneMain$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.xi_1 = 1;
            suspendResult = mainView(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            Companion_getInstance_32();
            var tmp2_easingEffect = Companion_getInstance().p12(0.2);
            var tmp3_easingEffect = Companion_getInstance_4().o4e();
            var tmp4_easingEffect = [Companion_getInstance_32().kfb(1.0, true)];
            var tmp5_easingEffect = MainScene$sceneMain$slambda$lambda;
            var tmp6_easingEffect = MainScene$sceneMain$slambda$lambda_0;
            (new EasingEffect(tmp3_easingEffect, tmp4_easingEffect, tmp5_easingEffect, tmp2_easingEffect, this.gfk_1, tmp6_easingEffect)).tfb();
            Companion_getInstance_32();
            var tmp9_easingEffect = Companion_getInstance().p12(0.5);
            var tmp10_easingEffect = Companion_getInstance_4().o4e();
            var tmp11_easingEffect = [Companion_getInstance_32().kfb(1.0, true)];
            var tmp12_easingEffect = MainScene$sceneMain$slambda$lambda_1;
            var tmp13_easingEffect = MainScene$sceneMain$slambda$lambda_2;
            (new EasingEffect(tmp10_easingEffect, tmp11_easingEffect, tmp12_easingEffect, tmp9_easingEffect, this.hfk_1, tmp13_easingEffect)).tfb();
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(MainScene$sceneMain$slambda).v1l = function (completion) {
    return new MainScene$sceneMain$slambda(this.gfk_1, this.hfk_1, completion);
  };
  function MainScene$sceneMain$slambda_0($loading, $curtain, resultContinuation) {
    var i = new MainScene$sceneMain$slambda($loading, $curtain, resultContinuation);
    var l = function ($completion) {
      return i.g1p($completion);
    };
    l.$arity = 0;
    return l;
  }
  function $sceneMainCOROUTINE$5(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qfk_1 = _this__u8e3s4;
    this.rfk_1 = _this__u8e3s4_0;
  }
  protoOf($sceneMainCOROUTINE$5).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.xi_1 = 1;
            suspendResult = readWoffFont(get_resourcesVfs().b18('fonts/NanumSquareNeoTTF-dEb.woff'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            set_font(ARGUMENT);
            var tmp0_uiContainer = this.rfk_1.j();
            var tmp0_apply = addTo(new UIContainer(tmp0_uiContainer), this.rfk_1);
            get_defaultStyle()(get_styles(tmp0_apply));
            set_screen(tmp0_apply);
            var tmp1_camera = get_screen();
            var tmp0_addTo = new Camera();
            var tmp0_apply_0 = addTo(tmp0_addTo, tmp1_camera);
            set_camera(tmp0_apply_0);
            onStageResized(this.rfk_1, VOID, MainScene$sceneMain$lambda);
            var tmp2_container = get_screen();
            var tmp0_addTo_0 = new Container(false);
            var tmp0_apply_1 = addTo(tmp0_addTo_0, tmp2_container);
            var tmp0_text = get_version();
            var tmp1_text = Colors_getInstance().k4k_1;
            var tmp2_text = get_DefaultTtfFontAsBitmap();
            var tmp3_text = Companion_getInstance_1().d59_1;
            var tmp4_text = get_DefaultStringTextRenderer();
            var tmp5_text = Companion_getInstance_2().qch_1;
            var tmp0_addTo_1 = new Text(tmp0_text, 30.0, tmp1_text, tmp2_text, tmp3_text, tmp4_text, tmp5_text, null, null);
            var tmp0_apply_2 = addTo(tmp0_addTo_1, tmp0_apply_1);
            zIndex(tmp0_apply_2, 100);
            zIndex(tmp0_apply_1, 100);
            transform(tmp0_apply_1, MainScene$sceneMain$lambda_0);
            var tmp3_uiText = Companion_getInstance_6().icb_1;
            var tmp0_apply_3 = addTo(new UIText('\uB85C\uADF8\uC778 \uC911...', tmp3_uiText), this.rfk_1);
            get_defaultStyle()(get_styles(tmp0_apply_3));
            centerOn(tmp0_apply_3, get_screen());
            var loading = tmp0_apply_3;
            alignY(loading, get_screen(), 0.48, true);
            var tmp4_solidRect = get_screen().j();
            var tmp5_solidRect = Colors_getInstance().p4z('#353535');
            var tmp0_addTo_2 = new SolidRect(tmp4_solidRect, tmp5_solidRect);
            var tmp0_apply_4 = addTo(tmp0_addTo_2, this.rfk_1);
            zIndex(transform(tmp0_apply_4, MainScene$sceneMain$lambda_1), -100);
            var tmp6_solidRect = get_screen();
            var tmp7_solidRect = get_screen().j();
            var tmp8_solidRect = this.qfk_1.sao().ua4_1.u8i();
            var tmp0_addTo_3 = new SolidRect(tmp7_solidRect, tmp8_solidRect);
            var tmp0_apply_5 = addTo(tmp0_addTo_3, tmp6_solidRect);
            var tmp_0 = zIndex(tmp0_apply_5, 1000);
            var curtain = transform(tmp_0, MainScene$sceneMain$lambda_2);
            Registry_getInstance();
            launchNow(VOID, MainScene$sceneMain$slambda_0(loading, curtain, null));
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  function MainScene() {
    Scene.call(this);
  }
  protoOf(MainScene).ybc = function (_this__u8e3s4, $completion) {
    var tmp = new $sceneMainCOROUTINE$5(this, _this__u8e3s4, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  function defaultStyle$delegate$lambda() {
    _init_properties_start_kt__ygz7rk();
    return defaultStyle$delegate$lambda$lambda;
  }
  function defaultStyle$delegate$lambda$lambda($this$lazy) {
    _init_properties_start_kt__ygz7rk();
    set_textFont($this$lazy, get_font());
    set_textAlignment($this$lazy, Companion_getInstance_1().q59_1);
    set_textSize($this$lazy, 100.0);
    set_textColor($this$lazy, get_globalTextColor());
    return Unit_getInstance();
  }
  function startMain$slambda$lambda(it) {
    return it instanceof FixedSizeContainer;
  }
  function startMain$slambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(startMain$slambda$slambda).lfl = function ($this$mapPrototype, $completion) {
    var tmp = this.haf($this$mapPrototype, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(startMain$slambda$slambda).ck = function (p1, $completion) {
    return this.lfl(p1 instanceof AsyncInjector ? p1 : THROW_CCE(), $completion);
  };
  protoOf(startMain$slambda$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          return new MainScene();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(startMain$slambda$slambda).haf = function ($this$mapPrototype, completion) {
    var i = new startMain$slambda$slambda(completion);
    i.kfl_1 = $this$mapPrototype;
    return i;
  };
  function startMain$slambda$slambda_0(resultContinuation) {
    var i = new startMain$slambda$slambda(resultContinuation);
    var l = function ($this$mapPrototype, $completion) {
      return i.lfl($this$mapPrototype, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function startMain$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(startMain$slambda).ia1 = function ($this$Korge, $completion) {
    var tmp = this.ja1($this$Korge, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(startMain$slambda).ck = function (p1, $completion) {
    return this.ia1(p1 instanceof Stage ? p1 : THROW_CCE(), $completion);
  };
  protoOf(startMain$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 5;
            var tmp_0 = this;
            tmp_0.vfl_1 = withEasing(get_AlphaTransition(), Companion_getInstance_4().w4e());
            var tmp_1 = this;
            tmp_1.wfl_1 = Companion_getInstance_10().i3x_1;
            this.xi_1 = 1;
            suspendResult = views(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.xfl_1 = suspendResult;
            this.yfl_1 = this.wfl_1;
            this.zfl_1 = this.yfl_1.e4();
            this.afm_1 = this.yfl_1.f4();
            this.bfm_1 = this.zfl_1;
            this.cfm_1 = this.afm_1;
            if (this.zfl_1 === 0.0 ? this.afm_1 === 0.0 : false) {
              var tmp_2 = findFirstAscendant(this.ufl_1, startMain$slambda$lambda);
              var base = (tmp_2 == null ? true : tmp_2 instanceof FixedSizeContainer) ? tmp_2 : null;
              var tmp_3 = this;
              var tmp2_elvis_lhs = base == null ? null : base.n13();
              tmp_3.bfm_1 = tmp2_elvis_lhs == null ? this.xfl_1.aa6_1.n13() : tmp2_elvis_lhs;
              var tmp_4 = this;
              var tmp4_elvis_lhs = base == null ? null : base.o13();
              tmp_4.cfm_1 = tmp4_elvis_lhs == null ? this.xfl_1.aa6_1.o13() : tmp4_elvis_lhs;
            }

            var tmp_5 = this;
            var tmp0_addTo = new SceneContainer(this.xfl_1, this.vfl_1, 'sceneContainer', new Size(this.bfm_1, this.cfm_1));
            tmp_5.dfm_1 = addTo(tmp0_addTo, this.ufl_1);
            set_scene(this.dfm_1);
            var tmp_6 = this;
            tmp_6.efm_1 = get_scene();
            var tmp_7 = this;
            tmp_7.ffm_1 = Companion_getInstance().p12(0.0);
            var tmp_8 = this;
            tmp_8.gfm_1 = this.efm_1.sab_1;
            var tmp_9 = this;
            tmp_9.hfm_1 = getKClass(MainScene);
            var tmp_10 = this;
            tmp_10.ifm_1 = [].slice();
            this.jfm_1 = this.efm_1.rab_1.qa4_1.s9y().r9y(getKClass(SceneContainer), this.efm_1).r9y(getKClass(Resources), new Resources(this.efm_1.nk(), this.efm_1.rab_1.daj().f2t_1, this.efm_1.rab_1.daj()));
            var n = 0;
            while (n < this.ifm_1.length) {
              var tmp0 = n;
              n = tmp0 + 1 | 0;
              var tmp0_anonymous = this.ifm_1[tmp0];
              var tmp_11 = getKClassFromExpression(tmp0_anonymous);
              this.jfm_1.r9y(isInterface(tmp_11, KClass) ? tmp_11 : THROW_CCE(), tmp0_anonymous);
            }

            var tmp_12 = this;
            tmp_12.kfm_1 = new MainScene();
            var tmp1_info = Companion_getInstance_11().bbf_1;
            var tmp0_log = Level_INFO_getInstance();
            if (tmp1_info.f1k(tmp0_log)) {
              tmp1_info.g1k(tmp0_log, 'Changing scene to... ' + this.hfm_1 + ' ... ' + this.kfm_1);
            }

            this.xi_1 = 2;
            suspendResult = this.kfm_1.c9y(this.jfm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp_13 = getKClassFromExpression(this.kfm_1);
            var tmp_14 = isInterface(tmp_13, KClass) ? tmp_13 : THROW_CCE();
            this.efm_1.rab_1.qa4_1.u9y(tmp_14, startMain$slambda$slambda_0(null));
            this.xi_1 = 3;
            continue $sm;
          case 3:
            this.xi_1 = 4;
            suspendResult = this.efm_1.wbf(this.kfm_1, this.ffm_1, this.gfm_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_getInstance();
          case 5:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 5) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  protoOf(startMain$slambda).ja1 = function ($this$Korge, completion) {
    var i = new startMain$slambda(completion);
    i.ufl_1 = $this$Korge;
    return i;
  };
  function startMain$slambda_0(resultContinuation) {
    var i = new startMain$slambda(resultContinuation);
    var l = function ($this$Korge, $completion) {
      return i.ia1($this$Korge, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $startMainCOROUTINE$4(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($startMainCOROUTINE$4).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 2;
            this.ufj_1 = Size_init_$Create$_0(1280, 720);
            this.vfj_1 = Companion_getInstance_12().d3x_1;
            this.wfj_1 = Companion_getInstance_13().c3n_1;
            this.xfj_1 = Colors_getInstance().p4z('333333');
            this.xi_1 = 1;
            suspendResult = Korge(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.ufj_1, VOID, VOID, VOID, this.vfj_1, this.wfj_1, false, VOID, VOID, VOID, this.xfj_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, startMain$slambda_0(null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_getInstance();
          case 2:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 2) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  function defaultStyle$factory() {
    return getPropertyCallableRef('defaultStyle', 0, KProperty0, function () {
      return get_defaultStyle();
    }, null);
  }
  var properties_initialized_start_kt_sj9ucy;
  function _init_properties_start_kt__ygz7rk() {
    if (!properties_initialized_start_kt_sj9ucy) {
      properties_initialized_start_kt_sj9ucy = true;
      defaultStyle$delegate = lazy(defaultStyle$delegate$lambda);
    }
  }
  function ComponentHooks$onAdded$lambda(_this__u8e3s4, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    return Unit_getInstance();
  }
  function ComponentHooks$onRemoved$lambda(_this__u8e3s4, _unused_var__etf5q3, _unused_var__etf5q3_0) {
    return Unit_getInstance();
  }
  function ComponentHooks() {
    ComponentType.call(this);
    var tmp = this;
    tmp.yfa_1 = ComponentHooks$onAdded$lambda;
    var tmp_0 = this;
    tmp_0.zfa_1 = ComponentHooks$onRemoved$lambda;
  }
  protoOf(ComponentHooks).afb = function () {
    return this.yfa_1;
  };
  protoOf(ComponentHooks).bfb = function () {
    return this.zfa_1;
  };
  function launchNow(context, callback) {
    context = context === VOID ? GlobalScope_getInstance().nk() : context;
    launchImmediately(CoroutineScope(context), callback);
  }
  function _get_onDestroyView__jc6zqp($this) {
    var tmp = $this.rfb_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('onDestroyView');
    }
  }
  function EasingEffect$enableEffect$lambda($elapsed, this$0, $span) {
    return function ($this$addUpdater, it) {
      $elapsed._v = new TimeSpan(TimeSpan__plus_impl_qdd6zo($elapsed._v.m12_1, this$0.qfb_1(it).m12_1));
      var tmp;
      if (TimeSpan__compareTo_impl_zidry4($elapsed._v.m12_1, $span) > 0) {
        var tmp33_safe_receiver = this$0.sfb_1;
        if (tmp33_safe_receiver == null)
          null;
        else {
          cancel(tmp33_safe_receiver);
        }
        this$0.lfm();
        tmp = Unit_getInstance();
      } else {
        var tmp0_fastForEach = this$0.mfb_1;
        var n = 0;
        while (n < tmp0_fastForEach.length) {
          // Inline function 'metron.util.EasingEffect.enableEffect.<anonymous>.<anonymous>' call
          var tmp0 = n;
          n = tmp0 + 1 | 0;
          var tmp1_anonymous = tmp0_fastForEach[tmp0];
          tmp1_anonymous.tfd(this$0.pfb_1, this$0.lfb_1.d4f(TimeSpan__div_impl_l42f2r($elapsed._v.m12_1, $span)));
        }
        tmp = Unit_getInstance();
      }
      return Unit_getInstance();
    };
  }
  function EasingEffect$startEffect$lambda($newParent) {
    return function (it) {
      $newParent.xbu();
      return Unit_getInstance();
    };
  }
  function EasingEffect(easing, effects, finishing, timeSpan, view, interval) {
    this.lfb_1 = easing;
    this.mfb_1 = effects;
    this.nfb_1 = finishing;
    this.ofb_1 = timeSpan;
    this.pfb_1 = view;
    this.qfb_1 = interval;
    this.sfb_1 = null;
  }
  protoOf(EasingEffect).tfb = function () {
    var span = this.ofb_1;
    this.mfm();
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$0 = Companion_getInstance().p12(0.0);
    var elapsed = {_v: new TimeSpan(tmp$ret$0)};
    var tmp = this;
    tmp.sfb_1 = addUpdater(this.pfb_1, EasingEffect$enableEffect$lambda(elapsed, this, span));
  };
  protoOf(EasingEffect).mfm = function () {
    var tmp34_safe_receiver = this.pfb_1.a27();
    if (tmp34_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.util.EasingEffect.startEffect.<anonymous>' call
      if (hasExtra(tmp34_safe_receiver, Companion_getInstance_32().hfb_1)) {
        ensureNotNull(getExtraTyped(tmp34_safe_receiver, Companion_getInstance_32().hfb_1)).lfm();
      }
    }
    var _elvis__6sfipt = this.pfb_1.a27();
    var tmp;
    if (_elvis__6sfipt == null) {
      return Unit_getInstance();
    } else {
      tmp = _elvis__6sfipt;
    }
    var originalParent = tmp;
    // Inline function 'korlibs.korge.view.container' call
    // Inline function 'korlibs.korge.view.addTo' call
    var tmp0_addTo = new Container(false);
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.view.container.<anonymous>' call
    var newParent = addTo(tmp0_addTo, originalParent);
    var easingEffect = this;
    setExtra(newParent, Companion_getInstance_32().hfb_1, easingEffect);
    var tmp_0 = this;
    var tmp_1 = Companion_getInstance_14();
    tmp_0.rfb_1 = newParent.h6p(tmp_1, EasingEffect$startEffect$lambda(newParent));
    this.pfb_1.xbu();
    addTo(this.pfb_1, newParent);
  };
  protoOf(EasingEffect).lfm = function () {
    var tuckedParent = this.pfb_1.a27();
    var thisEasingEffect = this;
    var tmp35_safe_receiver = this.sfb_1;
    if (tmp35_safe_receiver == null)
      null;
    else {
      cancel(tmp35_safe_receiver);
    }
    if (tuckedParent == null)
      null;
    else {
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.util.EasingEffect.stopEffect.<anonymous>' call
      if (hasExtra(tuckedParent, Companion_getInstance_32().hfb_1))
        if (equals(getExtraTyped(tuckedParent, Companion_getInstance_32().hfb_1), thisEasingEffect)) {
          var tmp37_safe_receiver = tuckedParent.r1d();
          if (tmp37_safe_receiver == null)
            null;
          else {
            // Inline function 'korlibs.datastructure.remove' call
            var tmp0_remove = Companion_getInstance_32().hfb_1;
            // Inline function 'kotlin.js.asDynamic' call
            tmp37_safe_receiver.delete(tmp0_remove);
          }
        }
    }
    var _elvis__6sfipt = this.pfb_1.a27();
    var tmp;
    if (_elvis__6sfipt == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      cancel(_get_onDestroyView__jc6zqp(this));
      this.nfb_1(this.pfb_1);
      return Unit_getInstance();
    } else {
      tmp = _elvis__6sfipt;
    }
    var originalParent = ensureNotNull(tmp.a27());
    if (tuckedParent == null)
      null;
    else {
      tuckedParent.xbu();
    }
    this.pfb_1.xbu();
    addTo(this.pfb_1, originalParent);
    cancel(_get_onDestroyView__jc6zqp(this));
    this.nfb_1(this.pfb_1);
  };
  function sam$metron_util_Effect$0_4(function_0) {
    this.nfm_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_4).tfd = function (view, value) {
    return this.nfm_1(view, value);
  };
  function sam$metron_util_Effect$0_5(function_0) {
    this.ofm_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_5).tfd = function (view, value) {
    return this.ofm_1(view, value);
  };
  function sam$metron_util_Effect$0_6(function_0) {
    this.pfm_1 = function_0;
  }
  protoOf(sam$metron_util_Effect$0_6).tfd = function (view, value) {
    return this.pfm_1(view, value);
  };
  function Effect$Companion$effectPosX$lambda($origin, $magnanimity, $isDown, this$0) {
    return function (view, value) {
      var tmp;
      if ($origin._v === null) {
        $origin._v = view.p2v().y3n_1;
        tmp = Unit_getInstance();
      }
      positionX(view, ensureNotNull($origin._v) + $magnanimity * ($isDown ? 1 - value : value));
      setExtra(view, this$0.jfb_1, view.p2v().y3n_1 / get_screen().n13());
      return Unit_getInstance();
    };
  }
  function Effect$Companion$effectPosY$lambda($origin, $magnanimity, $isDown, this$0) {
    return function (view, value) {
      var tmp;
      if ($origin._v === null) {
        $origin._v = view.p2v().z3n_1;
        tmp = Unit_getInstance();
      }
      positionY(view, ensureNotNull($origin._v) + $magnanimity * ($isDown ? 1 - value : value));
      setExtra(view, this$0.ifb_1, view.p2v().z3n_1 / get_screen().o13());
      return Unit_getInstance();
    };
  }
  function Effect$Companion$effectAlpha$lambda($magnanimity, $isDown) {
    return function (view, value) {
      alpha(view, $magnanimity * ($isDown ? 1 - value : value));
      return Unit_getInstance();
    };
  }
  function Companion_15() {
    Companion_instance_15 = this;
    this.hfb_1 = Companion_getInstance_15().r3i().toString();
    this.ifb_1 = Companion_getInstance_15().r3i().toString();
    this.jfb_1 = Companion_getInstance_15().r3i().toString();
  }
  protoOf(Companion_15).qfm = function (magnanimity, isDown) {
    var origin = {_v: null};
    var tmp = Effect$Companion$effectPosX$lambda(origin, magnanimity, isDown, this);
    return new sam$metron_util_Effect$0_4(tmp);
  };
  protoOf(Companion_15).dfh = function (magnanimity, isDown, $super) {
    isDown = isDown === VOID ? false : isDown;
    return $super === VOID ? this.qfm(magnanimity, isDown) : $super.qfm.call(this, magnanimity, isDown);
  };
  protoOf(Companion_15).rfm = function (magnanimity, isDown) {
    var origin = {_v: null};
    var tmp = Effect$Companion$effectPosY$lambda(origin, magnanimity, isDown, this);
    return new sam$metron_util_Effect$0_5(tmp);
  };
  protoOf(Companion_15).nfd = function (magnanimity, isDown, $super) {
    isDown = isDown === VOID ? false : isDown;
    return $super === VOID ? this.rfm(magnanimity, isDown) : $super.rfm.call(this, magnanimity, isDown);
  };
  protoOf(Companion_15).kfb = function (magnanimity, isDown) {
    var tmp = Effect$Companion$effectAlpha$lambda(magnanimity, isDown);
    return new sam$metron_util_Effect$0_6(tmp);
  };
  protoOf(Companion_15).vfb = function (magnanimity, isDown, $super) {
    isDown = isDown === VOID ? false : isDown;
    return $super === VOID ? this.kfb(magnanimity, isDown) : $super.kfb.call(this, magnanimity, isDown);
  };
  var Companion_instance_15;
  function Companion_getInstance_32() {
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function addTimer(_this__u8e3s4, timeSpan, interval, callback) {
    timeSpan = timeSpan === VOID ? null : timeSpan;
    var tmp;
    if (interval === VOID) {
      tmp = addTimer$lambda;
    } else {
      tmp = interval;
    }
    interval = tmp;
    var cancellable = {_v: null};
    var tmp$ret$0;
    // Inline function 'korlibs.time.seconds' call
    tmp$ret$0 = Companion_getInstance().p12(0.0);
    var elapsed = {_v: new TimeSpan(tmp$ret$0)};
    cancellable._v = addUpdater_0(_this__u8e3s4, false, VOID, addTimer$lambda_0(elapsed, interval, timeSpan, cancellable, callback));
    return cancellable._v;
  }
  function addTimer$lambda(it) {
    return it;
  }
  function addTimer$lambda_0($elapsed, $interval, $timeSpan, $cancellable, $callback) {
    return function ($this$addUpdater, it) {
      var tmp = $elapsed._v.m12_1;
      var tmp$ret$1;
      // Inline function 'kotlin.also' call
      var tmp0_also = $interval(it).m12_1;
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'metron.util.addTimer.<anonymous>.<anonymous>' call
      var tmp_0 = new TimeSpan(tmp0_also);
      var tmp$ret$0;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$0 = Companion_getInstance().p12(0.0);
      if (equals(tmp_0, new TimeSpan(tmp$ret$0)))
        return Unit_getInstance();
      tmp$ret$1 = tmp0_also;
      $elapsed._v = new TimeSpan(TimeSpan__plus_impl_qdd6zo(tmp, tmp$ret$1));
      var tmp_1;
      var tmp_2 = $elapsed._v;
      var tmp$ret$2;
      // Inline function 'korlibs.time.seconds' call
      tmp$ret$2 = Companion_getInstance().p12(0.0);
      if (tmp_2.equals(new TimeSpan(tmp$ret$2))) {
        return Unit_getInstance();
      }
      var tmp_3;
      var tmp_4;
      var tmp_5 = $timeSpan;
      if ((tmp_5 == null ? null : new TimeSpan(tmp_5)) == null) {
        tmp_4 = true;
      } else {
        tmp_4 = TimeSpan__compareTo_impl_zidry4($elapsed._v.m12_1, $timeSpan) >= 0;
      }
      if (tmp_4) {
        var tmp39_safe_receiver = $cancellable._v;
        if (tmp39_safe_receiver == null)
          null;
        else {
          cancel(tmp39_safe_receiver);
        }
        tmp_3 = $callback(it);
      }
      return Unit_getInstance();
    };
  }
  function transform(_this__u8e3s4, code) {
    code(_this__u8e3s4);
    var tmp = Companion_getInstance_31();
    _this__u8e3s4.h6p(tmp, transform$lambda(code, _this__u8e3s4));
    return _this__u8e3s4;
  }
  function transform$lambda($code, $this_transform) {
    return function (it) {
      $code($this_transform);
      return Unit_getInstance();
    };
  }
  function main($completion) {
    var tmp = new $mainCOROUTINE$6($completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  }
  function main$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(main$slambda).kfn = function (it, $completion) {
    var tmp = this.lfn(it, $completion);
    tmp.zi_1 = Unit_getInstance();
    tmp.aj_1 = null;
    return tmp.fj();
  };
  protoOf(main$slambda).ck = function (p1, $completion) {
    return this.kfn((!(p1 == null) ? typeof p1 === 'string' : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(main$slambda).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        if (tmp === 0) {
          this.yi_1 = 1;
          window.location.replace(this.jfn_1);
          return Unit_getInstance();
        } else if (tmp === 1) {
          throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(main$slambda).lfn = function (it, completion) {
    var i = new main$slambda(completion);
    i.jfn_1 = it;
    return i;
  };
  function main$slambda_0(resultContinuation) {
    var i = new main$slambda(resultContinuation);
    var l = function (it, $completion) {
      return i.kfn(it, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function main$lambda() {
    // Inline function 'kotlin.collections.associate' call
    // Inline function 'kotlin.apply' call
    var tmp0_apply = document.cookie;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'main.<anonymous>.<anonymous>' call
    println(tmp0_apply);
    var tmp1_associate = split(tmp0_apply, ['; ']);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(tmp1_associate, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var tmp0_associateTo = LinkedHashMap_init_$Create$(capacity);
    var tmp0_iterator = tmp1_associate.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'main.<anonymous>.<anonymous>' call
      var tmp0_plusAssign = to(substringBefore(element, '='), substringAfter(element, '='));
      tmp0_associateTo.g4(tmp0_plusAssign.c4_1, tmp0_plusAssign.d4_1);
    }
    return ensureNotNull(tmp0_associateTo.c2('LoginToken'));
  }
  function main$lambda_0(it) {
    document.cookie = 'LoginToken=' + it;
    return Unit_getInstance();
  }
  function main$lambda_1() {
    return window.location.href;
  }
  function $mainCOROUTINE$6(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf($mainCOROUTINE$6).fj = function () {
    var suspendResult = this.zi_1;
    $sm: do
      try {
        var tmp = this.xi_1;
        switch (tmp) {
          case 0:
            this.yi_1 = 3;
            this.xi_1 = 1;
            suspendResult = readProperties(get_resourcesVfs().b18('client.properties'), VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.afn_1 = suspendResult;
            set_currentUrl(ensureNotNull(this.afn_1.b18('server')));
            set_version(ensureNotNull(this.afn_1.b18('version')));
            set_redirector(main$slambda_0(null));
            set_LoginTokenGetter(main$lambda);
            set_LoginTokenSetter(main$lambda_0);
            set_clientWebsite(main$lambda_1);
            this.xi_1 = 2;
            suspendResult = startMain(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_getInstance();
          case 3:
            throw this.aj_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.yi_1 === 3) {
          throw e;
        } else {
          this.xi_1 = this.yi_1;
          this.aj_1 = e;
        }
      }
     while (true);
  };
  //region block: post-declaration
  protoOf($serializer).dei = typeParametersSerializers;
  //endregion
  //region block: init
  LoginTokenSetter = null;
  LoginTokenGetter = null;
  clientWebsite = null;
  //endregion
  main(get_EmptyContinuation());
  return _;
}));
